import * as i0 from '@angular/core';
import { Component, Input, HostBinding, HostListener, NgModule, EventEmitter, forwardRef, Output, ContentChildren, ViewChild, Injectable, Directive, ContentChild, ViewChildren, Inject, ElementRef, ChangeDetectionStrategy, ViewEncapsulation } from '@angular/core';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i2 from '@levelaccess/angular-fontawesome';
import { FontAwesomeModule } from '@levelaccess/angular-fontawesome';
import { faArrowDownArrowUp, faArrowDownToBracket, faArrowPointer, faArrowProgress, faArrowRightFromBracket, faArrowTrendDown, faArrowTrendUp, faArrowUpFromBracket, faArrowUpFromSquare, faArrowUpRightFromSquare, faArrowsRotate, faArrowsUpDownLeftRight, faAward, faBars, faBolt, faBell, faBook, faBriefcase, faBuilding, faBrowser, faBug, faBullseyePointer, faCalendarClock, faCalendarDays, faCamera, faChartColumn, faCheck, faChevronDown, faChevronLeft, faChevronRight, faChevronUp, faChevronsLeft, faChevronsRight, faChevronsUp, faChevronsDown, faCircle, faCircleCheck, faCircleDot, faCircleExclamation, faCircleHalfStroke, faCircleInfo, faCirclePlay, faCircleQuestion, faCircleStop, faCircleXmark, faClipboardList, faClock, faCog, faComment, faCompassDrafting, faCopy, faEllipsis, faEllipsisVertical, faEmptySet, faEnvelope, faEye, faEyeSlash, faFile, faFileArrowUp, faFileCsv, faFileExcel, faFileInvoice, faFileMagnifyingGlass, faFileMinus, faFilePdf, faFilePlus, faFlag, faFolder, faFolderGear, faFont, faFrame, faGavel, faGear, faGlobe, faGraduationCap, faGrid, faHandPointer, faHeart, faHome, faICursor, faImage, faKerning, faKey, faKeyboard, faLink, faLinkSlash, faListUl, faLock, faLockOpen, faMagnifyingGlass, faMagnifyingGlassMinus, faMagnifyingGlassPlus, faMap, faMessagesQuestion, faMicrochipAi, faMinus, faMobile, faPaperclip, faPencil, faPlus, faPuzzlePiece, faRecordVinyl, faShareNodes, faSliders, faSort, faSortDown, faSortUp, faSparkles, faSquare, faSquareCheck, faSquareChevronDown, faSquareMinus, faStar, faSuitcase, faTag, faTextSize, faThumbsDown, faThumbsUp, faTrashCan, faTriangleExclamation, faUniversalAccess, faUser, faUserCheck, faUserMagnifyingGlass, faUserTag, faUserXmark, faWavePulse, faWrench, faXmark, faCircleMinus, faArrowUp, faArrowDown, faMessageArrowUpRight, faMessageCheck, faArrowUpToLine, faArrowDownToLine, faVolume } from '@levelaccess/pro-solid-svg-icons';
import { faArrowDownArrowUp as faArrowDownArrowUp$1, faArrowDownToBracket as faArrowDownToBracket$1, faArrowPointer as faArrowPointer$1, faArrowProgress as faArrowProgress$1, faArrowRightFromBracket as faArrowRightFromBracket$1, faArrowTrendDown as faArrowTrendDown$1, faArrowTrendUp as faArrowTrendUp$1, faArrowUpFromBracket as faArrowUpFromBracket$1, faArrowUpFromSquare as faArrowUpFromSquare$1, faArrowUpRightFromSquare as faArrowUpRightFromSquare$1, faArrowsRotate as faArrowsRotate$1, faArrowsUpDownLeftRight as faArrowsUpDownLeftRight$1, faAward as faAward$1, faBars as faBars$1, faBolt as faBolt$1, faBell as faBell$1, faBook as faBook$1, faBriefcase as faBriefcase$1, faBuilding as faBuilding$1, faBrowser as faBrowser$1, faBug as faBug$1, faBullseyePointer as faBullseyePointer$1, faCalendarClock as faCalendarClock$1, faCalendarDays as faCalendarDays$1, faCamera as faCamera$1, faChartColumn as faChartColumn$1, faCheck as faCheck$1, faChevronDown as faChevronDown$1, faChevronLeft as faChevronLeft$1, faChevronRight as faChevronRight$1, faChevronUp as faChevronUp$1, faChevronsLeft as faChevronsLeft$1, faChevronsRight as faChevronsRight$1, faChevronsUp as faChevronsUp$1, faChevronsDown as faChevronsDown$1, faCircle as faCircle$1, faCircleCheck as faCircleCheck$1, faCircleDot as faCircleDot$1, faCircleExclamation as faCircleExclamation$1, faCircleHalfStroke as faCircleHalfStroke$1, faCircleInfo as faCircleInfo$1, faCirclePlay as faCirclePlay$1, faCircleQuestion as faCircleQuestion$1, faCircleStop as faCircleStop$1, faCircleXmark as faCircleXmark$1, faClipboardList as faClipboardList$1, faClock as faClock$1, faCog as faCog$1, faComment as faComment$1, faCompassDrafting as faCompassDrafting$1, faCopy as faCopy$1, faEllipsis as faEllipsis$1, faEllipsisVertical as faEllipsisVertical$1, faEmptySet as faEmptySet$1, faEnvelope as faEnvelope$1, faEye as faEye$1, faEyeSlash as faEyeSlash$1, faFile as faFile$1, faFileArrowUp as faFileArrowUp$1, faFileCsv as faFileCsv$1, faFileExcel as faFileExcel$1, faFileInvoice as faFileInvoice$1, faFileMagnifyingGlass as faFileMagnifyingGlass$1, faFileMinus as faFileMinus$1, faFilePdf as faFilePdf$1, faFilePlus as faFilePlus$1, faFlag as faFlag$1, faFolder as faFolder$1, faFolderGear as faFolderGear$1, faFont as faFont$1, faFrame as faFrame$1, faGavel as faGavel$1, faGear as faGear$1, faGlobe as faGlobe$1, faGraduationCap as faGraduationCap$1, faGrid as faGrid$1, faHandPointer as faHandPointer$1, faHeart as faHeart$1, faHome as faHome$1, faICursor as faICursor$1, faImage as faImage$1, faKerning as faKerning$1, faKey as faKey$1, faKeyboard as faKeyboard$1, faLink as faLink$1, faLinkSlash as faLinkSlash$1, faListUl as faListUl$1, faLock as faLock$1, faLockOpen as faLockOpen$1, faMagnifyingGlass as faMagnifyingGlass$1, faMagnifyingGlassMinus as faMagnifyingGlassMinus$1, faMagnifyingGlassPlus as faMagnifyingGlassPlus$1, faMap as faMap$1, faMessagesQuestion as faMessagesQuestion$1, faMicrochipAi as faMicrochipAi$1, faMinus as faMinus$1, faMobile as faMobile$1, faPaperclip as faPaperclip$1, faPencil as faPencil$1, faPlus as faPlus$1, faPuzzlePiece as faPuzzlePiece$1, faRecordVinyl as faRecordVinyl$1, faShareNodes as faShareNodes$1, faSliders as faSliders$1, faSort as faSort$1, faSortDown as faSortDown$1, faSortUp as faSortUp$1, faSparkles as faSparkles$1, faSquare as faSquare$1, faSquareCheck as faSquareCheck$1, faSquareChevronDown as faSquareChevronDown$1, faSquareMinus as faSquareMinus$1, faStar as faStar$1, faSuitcase as faSuitcase$1, faTag as faTag$1, faTextSize as faTextSize$1, faThumbsDown as faThumbsDown$1, faThumbsUp as faThumbsUp$1, faTrashCan as faTrashCan$1, faTriangleExclamation as faTriangleExclamation$1, faUniversalAccess as faUniversalAccess$1, faUser as faUser$1, faUserCheck as faUserCheck$1, faUserMagnifyingGlass as faUserMagnifyingGlass$1, faUserTag as faUserTag$1, faUserXmark as faUserXmark$1, faWavePulse as faWavePulse$1, faWrench as faWrench$1, faXmark as faXmark$1, faCircleMinus as faCircleMinus$1, faArrowUp as faArrowUp$1, faArrowDown as faArrowDown$1, faMessageArrowUpRight as faMessageArrowUpRight$1, faMessageCheck as faMessageCheck$1, faArrowUpToLine as faArrowUpToLine$1, faArrowDownToLine as faArrowDownToLine$1, faVolume as faVolume$1 } from '@levelaccess/pro-regular-svg-icons';
import { faArrowDownArrowUp as faArrowDownArrowUp$2, faArrowDownToBracket as faArrowDownToBracket$2, faArrowPointer as faArrowPointer$2, faArrowProgress as faArrowProgress$2, faArrowRightFromBracket as faArrowRightFromBracket$2, faArrowTrendDown as faArrowTrendDown$2, faArrowTrendUp as faArrowTrendUp$2, faArrowUpFromBracket as faArrowUpFromBracket$2, faArrowUpFromSquare as faArrowUpFromSquare$2, faArrowUpRightFromSquare as faArrowUpRightFromSquare$2, faArrowsRotate as faArrowsRotate$2, faArrowsUpDownLeftRight as faArrowsUpDownLeftRight$2, faAward as faAward$2, faBars as faBars$2, faBolt as faBolt$2, faBell as faBell$2, faBook as faBook$2, faBriefcase as faBriefcase$2, faBuilding as faBuilding$2, faBrowser as faBrowser$2, faBug as faBug$2, faBullseyePointer as faBullseyePointer$2, faCalendarClock as faCalendarClock$2, faCalendarDays as faCalendarDays$2, faCamera as faCamera$2, faChartColumn as faChartColumn$2, faCheck as faCheck$2, faChevronDown as faChevronDown$2, faChevronLeft as faChevronLeft$2, faChevronRight as faChevronRight$2, faChevronUp as faChevronUp$2, faChevronsLeft as faChevronsLeft$2, faChevronsRight as faChevronsRight$2, faChevronsUp as faChevronsUp$2, faChevronsDown as faChevronsDown$2, faCircle as faCircle$2, faCircleCheck as faCircleCheck$2, faCircleDot as faCircleDot$2, faCircleExclamation as faCircleExclamation$2, faCircleHalfStroke as faCircleHalfStroke$2, faCircleInfo as faCircleInfo$2, faCirclePlay as faCirclePlay$2, faCircleQuestion as faCircleQuestion$2, faCircleStop as faCircleStop$2, faCircleXmark as faCircleXmark$2, faClipboardList as faClipboardList$2, faClock as faClock$2, faCog as faCog$2, faComment as faComment$2, faCompassDrafting as faCompassDrafting$2, faCopy as faCopy$2, faEllipsis as faEllipsis$2, faEllipsisVertical as faEllipsisVertical$2, faEmptySet as faEmptySet$2, faEnvelope as faEnvelope$2, faEye as faEye$2, faEyeSlash as faEyeSlash$2, faFile as faFile$2, faFileArrowUp as faFileArrowUp$2, faFileCsv as faFileCsv$2, faFileExcel as faFileExcel$2, faFileInvoice as faFileInvoice$2, faFileMagnifyingGlass as faFileMagnifyingGlass$2, faFileMinus as faFileMinus$2, faFilePdf as faFilePdf$2, faFilePlus as faFilePlus$2, faFlag as faFlag$2, faFolder as faFolder$2, faFolderGear as faFolderGear$2, faFont as faFont$2, faFrame as faFrame$2, faGavel as faGavel$2, faGear as faGear$2, faGlobe as faGlobe$2, faGraduationCap as faGraduationCap$2, faGrid as faGrid$2, faHandPointer as faHandPointer$2, faHeart as faHeart$2, faHome as faHome$2, faICursor as faICursor$2, faImage as faImage$2, faKerning as faKerning$2, faKey as faKey$2, faKeyboard as faKeyboard$2, faLink as faLink$2, faLinkSlash as faLinkSlash$2, faListUl as faListUl$2, faLock as faLock$2, faLockOpen as faLockOpen$2, faMagnifyingGlass as faMagnifyingGlass$2, faMagnifyingGlassMinus as faMagnifyingGlassMinus$2, faMagnifyingGlassPlus as faMagnifyingGlassPlus$2, faMap as faMap$2, faMessagesQuestion as faMessagesQuestion$2, faMicrochipAi as faMicrochipAi$2, faMinus as faMinus$2, faMobile as faMobile$2, faPaperclip as faPaperclip$2, faPencil as faPencil$2, faPlus as faPlus$2, faPuzzlePiece as faPuzzlePiece$2, faRecordVinyl as faRecordVinyl$2, faShareNodes as faShareNodes$2, faSliders as faSliders$2, faSort as faSort$2, faSortDown as faSortDown$2, faSortUp as faSortUp$2, faSparkles as faSparkles$2, faSquare as faSquare$2, faSquareCheck as faSquareCheck$2, faSquareChevronDown as faSquareChevronDown$2, faSquareMinus as faSquareMinus$2, faStar as faStar$2, faSuitcase as faSuitcase$2, faTag as faTag$2, faTextSize as faTextSize$2, faThumbsDown as faThumbsDown$2, faThumbsUp as faThumbsUp$2, faTrashCan as faTrashCan$2, faTriangleExclamation as faTriangleExclamation$2, faUniversalAccess as faUniversalAccess$2, faUser as faUser$2, faUserCheck as faUserCheck$2, faUserMagnifyingGlass as faUserMagnifyingGlass$2, faUserTag as faUserTag$2, faUserXmark as faUserXmark$2, faWavePulse as faWavePulse$2, faWrench as faWrench$2, faXmark as faXmark$2, faCircleMinus as faCircleMinus$2, faArrowUp as faArrowUp$2, faArrowDown as faArrowDown$2, faMessageArrowUpRight as faMessageArrowUpRight$2, faMessageCheck as faMessageCheck$2, faArrowUpToLine as faArrowUpToLine$2, faArrowDownToLine as faArrowDownToLine$2, faVolume as faVolume$2 } from '@levelaccess/pro-light-svg-icons';
import { faArrowDownArrowUp as faArrowDownArrowUp$3, faArrowDownToBracket as faArrowDownToBracket$3, faArrowPointer as faArrowPointer$3, faArrowProgress as faArrowProgress$3, faArrowRightFromBracket as faArrowRightFromBracket$3, faArrowTrendDown as faArrowTrendDown$3, faArrowTrendUp as faArrowTrendUp$3, faArrowUpFromBracket as faArrowUpFromBracket$3, faArrowUpFromSquare as faArrowUpFromSquare$3, faArrowUpRightFromSquare as faArrowUpRightFromSquare$3, faArrowsRotate as faArrowsRotate$3, faArrowsUpDownLeftRight as faArrowsUpDownLeftRight$3, faAward as faAward$3, faBars as faBars$3, faBolt as faBolt$3, faBell as faBell$3, faBook as faBook$3, faBriefcase as faBriefcase$3, faBuilding as faBuilding$3, faBrowser as faBrowser$3, faBug as faBug$3, faBullseyePointer as faBullseyePointer$3, faCalendarClock as faCalendarClock$3, faCalendarDays as faCalendarDays$3, faCamera as faCamera$3, faChartColumn as faChartColumn$3, faCheck as faCheck$3, faChevronDown as faChevronDown$3, faChevronLeft as faChevronLeft$3, faChevronRight as faChevronRight$3, faChevronUp as faChevronUp$3, faChevronsLeft as faChevronsLeft$3, faChevronsRight as faChevronsRight$3, faChevronsUp as faChevronsUp$3, faChevronsDown as faChevronsDown$3, faCircle as faCircle$3, faCircleCheck as faCircleCheck$3, faCircleDot as faCircleDot$3, faCircleExclamation as faCircleExclamation$3, faCircleHalfStroke as faCircleHalfStroke$3, faCircleInfo as faCircleInfo$3, faCirclePlay as faCirclePlay$3, faCircleQuestion as faCircleQuestion$3, faCircleStop as faCircleStop$3, faCircleXmark as faCircleXmark$3, faClipboardList as faClipboardList$3, faClock as faClock$3, faCog as faCog$3, faComment as faComment$3, faCompassDrafting as faCompassDrafting$3, faCopy as faCopy$3, faEllipsis as faEllipsis$3, faEllipsisVertical as faEllipsisVertical$3, faEmptySet as faEmptySet$3, faEnvelope as faEnvelope$3, faEye as faEye$3, faEyeSlash as faEyeSlash$3, faFile as faFile$3, faFileArrowUp as faFileArrowUp$3, faFileCsv as faFileCsv$3, faFileExcel as faFileExcel$3, faFileInvoice as faFileInvoice$3, faFileMagnifyingGlass as faFileMagnifyingGlass$3, faFileMinus as faFileMinus$3, faFilePdf as faFilePdf$3, faFilePlus as faFilePlus$3, faFlag as faFlag$3, faFolder as faFolder$3, faFolderGear as faFolderGear$3, faFont as faFont$3, faFrame as faFrame$3, faGavel as faGavel$3, faGear as faGear$3, faGlobe as faGlobe$3, faGraduationCap as faGraduationCap$3, faGrid as faGrid$3, faHandPointer as faHandPointer$3, faHeart as faHeart$3, faHome as faHome$3, faICursor as faICursor$3, faImage as faImage$3, faKerning as faKerning$3, faKey as faKey$3, faKeyboard as faKeyboard$3, faLink as faLink$3, faLinkSlash as faLinkSlash$3, faListUl as faListUl$3, faLock as faLock$3, faLockOpen as faLockOpen$3, faMagnifyingGlass as faMagnifyingGlass$3, faMagnifyingGlassMinus as faMagnifyingGlassMinus$3, faMagnifyingGlassPlus as faMagnifyingGlassPlus$3, faMap as faMap$3, faMessagesQuestion as faMessagesQuestion$3, faMicrochipAi as faMicrochipAi$3, faMinus as faMinus$3, faMobile as faMobile$3, faPaperclip as faPaperclip$3, faPencil as faPencil$3, faPlus as faPlus$3, faPuzzlePiece as faPuzzlePiece$3, faRecordVinyl as faRecordVinyl$3, faShareNodes as faShareNodes$3, faSliders as faSliders$3, faSort as faSort$3, faSortDown as faSortDown$3, faSortUp as faSortUp$3, faSparkles as faSparkles$3, faSquare as faSquare$3, faSquareCheck as faSquareCheck$3, faSquareChevronDown as faSquareChevronDown$3, faSquareMinus as faSquareMinus$3, faStar as faStar$3, faSuitcase as faSuitcase$3, faTag as faTag$3, faTextSize as faTextSize$3, faThumbsDown as faThumbsDown$3, faThumbsUp as faThumbsUp$3, faTrashCan as faTrashCan$3, faTriangleExclamation as faTriangleExclamation$3, faUniversalAccess as faUniversalAccess$3, faUser as faUser$3, faUserCheck as faUserCheck$3, faUserMagnifyingGlass as faUserMagnifyingGlass$3, faUserTag as faUserTag$3, faUserXmark as faUserXmark$3, faWavePulse as faWavePulse$3, faWrench as faWrench$3, faXmark as faXmark$3, faCircleMinus as faCircleMinus$3, faArrowUp as faArrowUp$3, faArrowDown as faArrowDown$3, faMessageArrowUpRight as faMessageArrowUpRight$3, faMessageCheck as faMessageCheck$3, faArrowUpToLine as faArrowUpToLine$3, faArrowDownToLine as faArrowDownToLine$3, faVolume as faVolume$3 } from '@levelaccess/pro-duotone-svg-icons';
import * as i1$1 from '@angular/forms';
import { NG_VALUE_ACCESSOR, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Subscription, Subject, asyncScheduler, fromEvent, merge, isObservable, of } from 'rxjs';
import * as i4 from '@ng-bootstrap/ng-bootstrap';
import { NgbOffcanvasRef, NgbActiveOffcanvas, NgbDropdown, NgbDropdownMenu, NgbDropdownItem, NgbModule, NgbModalModule, NgbOffcanvasModule, NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { observeOn, startWith, map, filter, tap, delay } from 'rxjs/operators';
import { createFocusTrap } from 'focus-trap';
import * as i2$1 from '@angular/router';
import { RouterModule } from '@angular/router';

var Icons;
(function (Icons) {
    Icons["ArrowDown"] = "arrow-down";
    Icons["ArrowUp"] = "arrow-up";
    Icons["ArrowDownArrowUp"] = "arrow-down-arrow-up";
    Icons["ArrowDownToBracket"] = "arrow-down-to-bracket";
    Icons["ArrowPointer"] = "arrow-pointer";
    Icons["ArrowProgress"] = "arrow-progress";
    Icons["ArrowRightFromBracket"] = "arrow-right-from-bracket";
    Icons["ArrowTrendDown"] = "arrow-trend-down";
    Icons["ArrowTrendUp"] = "arrow-trend-up";
    Icons["ArrowUpFromBracket"] = "arrow-up-from-bracket";
    Icons["ArrowUpFromSquare"] = "arrow-up-from-square";
    Icons["ArrowUpRightFromSquare"] = "arrow-up-right-from-square";
    Icons["ArrowsRotate"] = "arrows-rotate";
    Icons["ArrowsUpDownLeftRight"] = "arrows-up-down-left-right";
    Icons["Award"] = "award";
    Icons["Bars"] = "bars";
    Icons["Bolt"] = "bolt";
    Icons["Bell"] = "bell";
    Icons["Book"] = "book";
    Icons["Briefcase"] = "briefcase";
    Icons["Browser"] = "browser";
    Icons["Bug"] = "bug";
    Icons["Building"] = "building";
    Icons["BullseyePointer"] = "bullseye-pointer";
    Icons["CalendarClock"] = "calendar-clock";
    Icons["CalendarDays"] = "calendar-days";
    Icons["Camera"] = "camera";
    Icons["ChartColumn"] = "chart-column";
    Icons["Check"] = "check";
    Icons["ChevronDown"] = "chevron-down";
    Icons["ChevronLeft"] = "chevron-left";
    Icons["ChevronRight"] = "chevron-right";
    Icons["ChevronUp"] = "chevron-up";
    Icons["ChevronsLeft"] = "chevrons-left";
    Icons["ChevronsRight"] = "chevrons-right";
    Icons["ChevronsUp"] = "chevrons-up";
    Icons["ChevronsDown"] = "chevrons-down";
    Icons["Circle"] = "circle";
    Icons["CircleCheck"] = "circle-check";
    Icons["CircleDot"] = "circle-dot";
    Icons["CircleExclamation"] = "circle-exclamation";
    Icons["CircleHalfStroke"] = "circle-half-stroke";
    Icons["CircleInfo"] = "circle-info";
    Icons["CircleMinus"] = "circle-minus";
    Icons["CirclePlay"] = "circle-play";
    Icons["CircleQuestion"] = "circle-question";
    Icons["CircleStop"] = "circle-stop";
    Icons["CircleXmark"] = "circle-xmark";
    Icons["ClipboardList"] = "clipboard-list";
    Icons["Clock"] = "clock";
    Icons["Cog"] = "cog";
    Icons["Comment"] = "comment";
    Icons["CompassDrafting"] = "compass-drafting";
    Icons["Copy"] = "copy";
    Icons["Ellipsis"] = "ellipsis";
    Icons["EllipsisVertical"] = "ellipsis-vertical";
    Icons["EmptySet"] = "empty-set";
    Icons["Envelope"] = "envelope";
    Icons["Eye"] = "eye";
    Icons["EyeSlash"] = "eye-slash";
    Icons["File"] = "file";
    Icons["FileArrowUp"] = "file-arrow-up";
    Icons["FileCsv"] = "file-csv";
    Icons["FileExcel"] = "file-excel";
    Icons["FileInvoice"] = "file-invoice";
    Icons["FileMagnifyingGlass"] = "file-magnifying-glass";
    Icons["FileMinus"] = "file-minus";
    Icons["FilePdf"] = "file-pdf";
    Icons["FilePlus"] = "file-plus";
    Icons["Flag"] = "flag";
    Icons["Folder"] = "folder";
    Icons["FolderGear"] = "folder-gear";
    Icons["Font"] = "font";
    Icons["Frame"] = "frame";
    Icons["Gavel"] = "gavel";
    Icons["Gear"] = "gear";
    Icons["Globe"] = "globe";
    Icons["GraduationCap"] = "graduation-cap";
    Icons["Grid"] = "grid";
    Icons["HandPointer"] = "hand-pointer";
    Icons["Heart"] = "heart";
    Icons["Home"] = "home";
    Icons["ICursor"] = "i-cursor";
    Icons["Image"] = "image";
    Icons["Kerning"] = "kerning";
    Icons["Key"] = "key";
    Icons["Keyboard"] = "keyboard";
    Icons["Link"] = "link";
    Icons["LinkSlash"] = "link-slash";
    Icons["ListUl"] = "list-ul";
    Icons["Lock"] = "lock";
    Icons["LockOpen"] = "lock-open";
    Icons["MagnifyingGlass"] = "magnifying-glass";
    Icons["MagnifyingGlassMinus"] = "magnifying-glass-minus";
    Icons["MagnifyingGlassPlus"] = "magnifying-glass-plus";
    Icons["Map"] = "map";
    Icons["MessagesQuestion"] = "messages-question";
    Icons["MicrochipAi"] = "microchip-ai";
    Icons["Minus"] = "minus";
    Icons["Mobile"] = "mobile";
    Icons["Paperclip"] = "paperclip";
    Icons["Pencil"] = "pencil";
    Icons["Plus"] = "plus";
    Icons["PuzzlePiece"] = "puzzle-piece";
    Icons["RecordVinyl"] = "record-vinyl";
    Icons["ShareNodes"] = "share-nodes";
    Icons["Sliders"] = "sliders";
    Icons["Sort"] = "sort";
    Icons["SortDown"] = "sort-down";
    Icons["SortUp"] = "sort-up";
    Icons["Sparkles"] = "sparkles";
    Icons["Square"] = "square";
    Icons["SquareCheck"] = "square-check";
    Icons["SquareChevronDown"] = "square-chevron-down";
    Icons["SquareMinus"] = "square-minus";
    Icons["Star"] = "star";
    Icons["Suitcase"] = "suitcase";
    Icons["Tag"] = "tag";
    Icons["TextSize"] = "text-size";
    Icons["ThumbsDown"] = "thumbs-down";
    Icons["ThumbsUp"] = "thumbs-up";
    Icons["TrashCan"] = "trash-can";
    Icons["TriangleExclamation"] = "triangle-exclamation";
    Icons["UniversalAccess"] = "universal-access";
    Icons["User"] = "user";
    Icons["UserCheck"] = "user-check";
    Icons["UserMagnifyingGlass"] = "user-magnifying-glass";
    Icons["UserTag"] = "user-tag";
    Icons["UserXMark"] = "user-xmark";
    Icons["Volume"] = "volume";
    Icons["WavePulse"] = "wave-pulse";
    Icons["Wrench"] = "wrench";
    Icons["XMark"] = "xmark";
    Icons["MessageArrowUpRight"] = "message-arrow-up-right";
    Icons["MessageCheck"] = "message-check";
    Icons["ArrowUpToLine"] = "arrow-up-to-line";
    Icons["ArrowDownToLine"] = "arrow-down-to-line";
})(Icons || (Icons = {}));
var IconStyles;
(function (IconStyles) {
    IconStyles["Solid"] = "fas";
    IconStyles["Regular"] = "far";
    IconStyles["Light"] = "fal";
    IconStyles["DuoTone"] = "fad";
})(IconStyles || (IconStyles = {}));
var IconScale;
(function (IconScale) {
    IconScale["FA_1X"] = "fa-1x";
    IconScale["FA_1_5X"] = "fa-1_5x";
    IconScale["FA_2X"] = "fa-2x";
    IconScale["FA_3X"] = "fa-3x";
    IconScale["FA_4X"] = "fa-4x";
    IconScale["FA_5X"] = "fa-5x";
    IconScale["FA_6X"] = "fa-6x";
    IconScale["FA_7X"] = "fa-7x";
    IconScale["FA_8X"] = "fa-8x";
    IconScale["FA_9X"] = "fa-9x";
    IconScale["FA_10X"] = "fa-10x";
})(IconScale || (IconScale = {}));

class CommonUtility {
    static isNullish(obj) {
        return obj === null || obj === undefined;
    }
    static notNullish(obj) {
        return !CommonUtility.isNullish(obj);
    }
    static isNullishOrEmpty(obj) {
        return CommonUtility.isNullish(obj) || obj.length === 0;
    }
    static notNullishOrEmpty(obj) {
        return !CommonUtility.isNullishOrEmpty(obj);
    }
    /**
     * Returns an insecurely generated string of alphanumerics, lowercase.
     * After a few calls, it is possible to predict what Math.random() will return next. And so, it is considered insecure.
     * See the server/client versions of getRandomSecureString if you need a secure CSPRNG.
     *
     * @param length
     */
    static getRandomInsecureString(length = 16) {
        return Math.random()
            .toString(36)
            .substring(2, 2 + length);
    }
    static { this.isValidUrl = (str) => {
        try {
            const url = new URL(str);
            // Note: if statement here is to avoid tslint unused-variable issue
            if (url) {
                return true;
            }
        }
        catch (_) {
            return false;
        }
        return undefined;
    }; }
}

var DsColors;
(function (DsColors) {
    DsColors["Inactive"] = "#074EB0";
    DsColors["Focus"] = "#a30083";
    DsColors["Alert"] = "#b10606";
})(DsColors || (DsColors = {}));
var DsLinkColor;
(function (DsLinkColor) {
    DsLinkColor["Default"] = "Default";
    DsLinkColor["Black"] = "Black";
    DsLinkColor["White"] = "White";
    DsLinkColor["Dark"] = "Dark";
})(DsLinkColor || (DsLinkColor = {}));
var DsButtonColor;
(function (DsButtonColor) {
    DsButtonColor["Default"] = "Default";
    DsButtonColor["White"] = "White";
})(DsButtonColor || (DsButtonColor = {}));

class DsIconComponent {
    constructor() {
        this.iconStyle = IconStyles.Light;
        this.scale = IconScale.FA_1X;
        this.IconStyles = IconStyles;
    }
    get class() {
        return `ds-icon ${this.scale}`;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsIconComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.5", type: DsIconComponent, selector: "ds-icon", inputs: { icon: "icon", iconStyle: "iconStyle", scale: "scale", fixedWidth: "fixedWidth", secondaryColor: "secondaryColor", title: "title" }, ngImport: i0, template: `
    <ng-container *ngIf="iconStyle !== IconStyles.DuoTone; else duoTone">
      <fa-icon [icon]="[iconStyle, icon]" [fixedWidth]="fixedWidth" [title]="title" [class]="class"></fa-icon>
    </ng-container>
    <ng-template #duoTone>
      <fa-duotone-icon
        [icon]="[iconStyle, icon]"
        [fixedWidth]="fixedWidth"
        [title]="title"
        [class]="class"
        [secondaryColor]="secondaryColor"
      ></fa-duotone-icon>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i2.FaIconComponent, selector: "fa-icon", inputs: ["icon", "title", "spin", "pulse", "mask", "styles", "flip", "size", "pull", "border", "inverse", "symbol", "rotate", "fixedWidth", "classes", "transform", "a11yRole"] }, { kind: "component", type: i2.FaDuotoneIconComponent, selector: "fa-duotone-icon", inputs: ["swapOpacity", "primaryOpacity", "secondaryOpacity", "primaryColor", "secondaryColor"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'ds-icon',
                    template: `
    <ng-container *ngIf="iconStyle !== IconStyles.DuoTone; else duoTone">
      <fa-icon [icon]="[iconStyle, icon]" [fixedWidth]="fixedWidth" [title]="title" [class]="class"></fa-icon>
    </ng-container>
    <ng-template #duoTone>
      <fa-duotone-icon
        [icon]="[iconStyle, icon]"
        [fixedWidth]="fixedWidth"
        [title]="title"
        [class]="class"
        [secondaryColor]="secondaryColor"
      ></fa-duotone-icon>
    </ng-template>
  `,
                }]
        }], propDecorators: { icon: [{
                type: Input
            }], iconStyle: [{
                type: Input
            }], scale: [{
                type: Input
            }], fixedWidth: [{
                type: Input
            }], secondaryColor: [{
                type: Input
            }], title: [{
                type: Input
            }] } });

var DsButtonVariants;
(function (DsButtonVariants) {
    DsButtonVariants["primary"] = "primary";
    DsButtonVariants["secondary"] = "secondary";
    DsButtonVariants["microAction"] = "microAction";
    DsButtonVariants["microActionHorizontalLayout"] = "microActionHorizontalLayout";
    DsButtonVariants["microActionStacked"] = "microActionStacked";
    DsButtonVariants["microActionWithChevronRight"] = "microActionWithChevronRight";
    DsButtonVariants["microActionWithChevronRightInline"] = "microActionWithChevronRightInline";
})(DsButtonVariants || (DsButtonVariants = {}));
const dsButtonVariantsCssClassname = Object.freeze(new Map([
    [DsButtonVariants.primary, ''],
    [DsButtonVariants.secondary, 'ds-btn-secondary'],
    [DsButtonVariants.microAction, 'ds-btn-micro-action'],
    [DsButtonVariants.microActionHorizontalLayout, 'ds-btn-micro-action-h-layout'],
    [DsButtonVariants.microActionStacked, 'ds-btn-micro-action-v-layout'],
    [DsButtonVariants.microActionWithChevronRight, 'ds-btn-micro-action-with-chevron-right'],
    [DsButtonVariants.microActionWithChevronRightInline, 'ds-btn-micro-action-with-chevron-right-inline'],
]));
const microActionVariants = Object.freeze([
    DsButtonVariants.microAction,
    DsButtonVariants.microActionHorizontalLayout,
    DsButtonVariants.microActionStacked,
    DsButtonVariants.microActionWithChevronRight,
    DsButtonVariants.microActionWithChevronRightInline,
]);
const microActionChevronVariants = Object.freeze([
    DsButtonVariants.microActionWithChevronRight,
    DsButtonVariants.microActionWithChevronRightInline,
]);
class DsButtonComponent {
    get class() {
        let hostClass = 'ds-btn';
        if (this.color === DsButtonColor.White) {
            hostClass += ' ds-btn-white-color-variant';
        }
        if (this._disabled) {
            hostClass += ' ds-btn-disabled';
        }
        return hostClass;
    }
    click(e) {
        this.onClick(e);
    }
    set variant(val) {
        if (this._variant !== DsButtonVariants.primary) {
            this.elRef.nativeElement.classList.remove(dsButtonVariantsCssClassname.get(this._variant));
        }
        this._variant = dsButtonVariantsCssClassname.has(val) ? val : DsButtonVariants.primary;
        if (this._variant !== DsButtonVariants.primary) {
            this.elRef.nativeElement.classList.add(dsButtonVariantsCssClassname.get(this._variant));
        }
    }
    set withChevron(val) {
        if (val && microActionChevronVariants.includes(this._variant)) {
            throw new Error(`Chevron cannot be used with the variants "${microActionChevronVariants.join(', ')}".`);
        }
        this._withChevron = val;
        this.elRef.nativeElement.ariaExpanded = this._withChevron ? false : null;
    }
    set microActionIcon(icon) {
        if (CommonUtility.notNullish(icon) && !microActionVariants.includes(this._variant)) {
            throw new Error('Micro action icons are only supported by the micro action variant.');
        }
        this._microActionIcon = icon;
    }
    set hideMicroActionIcon(val) {
        if (!microActionVariants.includes(this._variant)) {
            throw new Error('Hiding the micro action icon is only supported by the microAction variants.');
        }
        this._hideMicroActionIcon = val;
    }
    set disabledLink(val) {
        this.checkIfTagIsAnchor('Setting "disabledLink" is only supported for anchor element.');
        this._disabled = val;
    }
    set isExternalLink(val) {
        this.checkIfTagIsAnchor('Setting "isExternalLink" is only supported for anchor element.');
        this._isExternalLink = val;
        this.handleTargetAttribute();
    }
    get isExternalLink() {
        return this._isExternalLink;
    }
    constructor(elRef, renderer) {
        this.elRef = elRef;
        this.renderer = renderer;
        this._withChevron = false;
        this._variant = DsButtonVariants.primary;
        this.isChevronCollapsed = true;
        this._disabled = this.elRef.nativeElement.disabled;
        this._isExternalLink = false;
        this.externalLinkIcon = Icons.ArrowUpRightFromSquare;
        this.observeDisabledAttributeChange();
    }
    onClick(e) {
        if (this._disabled) {
            e.preventDefault();
            return;
        }
        if (this._withChevron) {
            this.toggleChevron();
        }
    }
    toggleChevron() {
        this.isChevronCollapsed = !this.isChevronCollapsed;
        this.elRef.nativeElement.ariaExpanded = !this.isChevronCollapsed;
    }
    get labelText() {
        return this.elRef.nativeElement.innerText.trim();
    }
    onMouseEnter() {
        this.hovered = true;
    }
    onMouseLeave() {
        this.hovered = false;
    }
    onFocus() {
        this.focused = true;
    }
    onBlur() {
        this.focused = false;
    }
    observeDisabledAttributeChange() {
        const observer = new MutationObserver(() => {
            modifyDisabledCallback();
        });
        const modifyDisabledCallback = () => {
            this._disabled = this.elRef.nativeElement.disabled;
        };
        const config = { attributeFilter: ['disabled'] };
        observer.observe(this.elRef.nativeElement, config);
    }
    get iconStyle() {
        if (!this._disabled && (this.focused || this.hovered)) {
            return IconStyles.Solid;
        }
        return IconStyles.Light;
    }
    get chevronIcon() {
        if (microActionChevronVariants.includes(this._variant)) {
            return Icons.ChevronRight;
        }
        return this.isChevronCollapsed ? Icons.ChevronDown : Icons.ChevronUp;
    }
    get isMicroAction() {
        return microActionVariants.includes(this._variant);
    }
    get showChevron() {
        return this._withChevron || microActionChevronVariants.includes(this._variant);
    }
    get showMicroActionIcon() {
        return this.isMicroAction && !this._hideMicroActionIcon;
    }
    handleTargetAttribute() {
        if (this._isExternalLink) {
            this.renderer.setAttribute(this.elRef.nativeElement, 'target', '_blank');
        }
        else {
            this.renderer.removeAttribute(this.elRef.nativeElement, 'target');
        }
    }
    checkIfTagIsAnchor(errorMessage) {
        if (this.elRef.nativeElement.tagName.toLowerCase() !== 'a') {
            throw new Error(errorMessage);
        }
    }
    ngAfterViewInit() {
        this.handleTargetAttribute();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsButtonComponent, deps: [{ token: i0.ElementRef }, { token: i0.Renderer2 }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.5", type: DsButtonComponent, selector: "button[ds-button], a[ds-button]", inputs: { visuallyHidden: "visuallyHidden", color: "color", variant: "variant", withChevron: "withChevron", microActionIcon: "microActionIcon", hideMicroActionIcon: "hideMicroActionIcon", disabledLink: "disabledLink", isExternalLink: "isExternalLink" }, host: { listeners: { "click": "click($event)", "mouseenter": "onMouseEnter()", "mouseleave": "onMouseLeave()", "focus": "onFocus()", "blur": "onBlur()" }, properties: { "class": "this.class" } }, ngImport: i0, template: "<ng-container>\n  <ds-icon\n    *ngIf=\"showMicroActionIcon\"\n    [icon]=\"_microActionIcon\"\n    [iconStyle]=\"iconStyle\"\n    class=\"ds-btn-icon\"\n    [class.ds-btn-micro-action-icon-with-label]=\"labelText.length > 0\"\n    data-test-id=\"micro-action-icon\"\n  ></ds-icon>\n  <div class=\"d-flex align-items-start flex-grow-1\">\n    <ng-content></ng-content>\n    <span *ngIf=\"visuallyHidden\" data-test-id=\"label-visually-hidden-text\" class=\"ds-visually-hidden\">{{ visuallyHidden }}</span>\n    <ng-container *ngIf=\"isExternalLink\">\n      <span class=\"ds-visually-hidden\" data-test-id=\"external-link-visually-hidden-text\">external</span>\n      <ds-icon\n        [icon]=\"externalLinkIcon\"\n        class=\"ds-btn-icon ds-btn-external-link-icon\"\n        data-test-id=\"external-link-icon\"\n      ></ds-icon>\n    </ng-container>\n    <ds-icon *ngIf=\"showChevron\" [icon]=\"chevronIcon\" class=\"ds-btn-icon ds-btn-chevron\" data-test-id=\"chevron-icon\"></ds-icon>\n  </div>\n</ng-container>\n", dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: DsIconComponent, selector: "ds-icon", inputs: ["icon", "iconStyle", "scale", "fixedWidth", "secondaryColor", "title"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsButtonComponent, decorators: [{
            type: Component,
            args: [{ selector: 'button[ds-button], a[ds-button]', template: "<ng-container>\n  <ds-icon\n    *ngIf=\"showMicroActionIcon\"\n    [icon]=\"_microActionIcon\"\n    [iconStyle]=\"iconStyle\"\n    class=\"ds-btn-icon\"\n    [class.ds-btn-micro-action-icon-with-label]=\"labelText.length > 0\"\n    data-test-id=\"micro-action-icon\"\n  ></ds-icon>\n  <div class=\"d-flex align-items-start flex-grow-1\">\n    <ng-content></ng-content>\n    <span *ngIf=\"visuallyHidden\" data-test-id=\"label-visually-hidden-text\" class=\"ds-visually-hidden\">{{ visuallyHidden }}</span>\n    <ng-container *ngIf=\"isExternalLink\">\n      <span class=\"ds-visually-hidden\" data-test-id=\"external-link-visually-hidden-text\">external</span>\n      <ds-icon\n        [icon]=\"externalLinkIcon\"\n        class=\"ds-btn-icon ds-btn-external-link-icon\"\n        data-test-id=\"external-link-icon\"\n      ></ds-icon>\n    </ng-container>\n    <ds-icon *ngIf=\"showChevron\" [icon]=\"chevronIcon\" class=\"ds-btn-icon ds-btn-chevron\" data-test-id=\"chevron-icon\"></ds-icon>\n  </div>\n</ng-container>\n" }]
        }], ctorParameters: () => [{ type: i0.ElementRef }, { type: i0.Renderer2 }], propDecorators: { class: [{
                type: HostBinding,
                args: ['class']
            }], click: [{
                type: HostListener,
                args: ['click', ['$event']]
            }], visuallyHidden: [{
                type: Input
            }], color: [{
                type: Input
            }], variant: [{
                type: Input
            }], withChevron: [{
                type: Input
            }], microActionIcon: [{
                type: Input
            }], hideMicroActionIcon: [{
                type: Input
            }], disabledLink: [{
                type: Input
            }], isExternalLink: [{
                type: Input
            }], onMouseEnter: [{
                type: HostListener,
                args: ['mouseenter']
            }], onMouseLeave: [{
                type: HostListener,
                args: ['mouseleave']
            }], onFocus: [{
                type: HostListener,
                args: ['focus']
            }], onBlur: [{
                type: HostListener,
                args: ['blur']
            }] } });

class DsFontAwesomeModule {
    constructor(library) {
        library.addIcons(faArrowDownArrowUp, faArrowDownArrowUp$1, faArrowDownArrowUp$2, faArrowDownArrowUp$3);
        library.addIcons(faArrowDownToBracket, faArrowDownToBracket$1, faArrowDownToBracket$2, faArrowDownToBracket$3);
        library.addIcons(faArrowPointer, faArrowPointer$1, faArrowPointer$2, faArrowPointer$3);
        library.addIcons(faArrowProgress, faArrowProgress$1, faArrowProgress$2, faArrowProgress$3);
        library.addIcons(faArrowRightFromBracket, faArrowRightFromBracket$1, faArrowRightFromBracket$2, faArrowRightFromBracket$3);
        library.addIcons(faArrowTrendDown, faArrowTrendDown$1, faArrowTrendDown$2, faArrowTrendDown$3);
        library.addIcons(faArrowTrendUp, faArrowTrendUp$1, faArrowTrendUp$2, faArrowTrendUp$3);
        library.addIcons(faArrowUpFromBracket, faArrowUpFromBracket$1, faArrowUpFromBracket$2, faArrowUpFromBracket$3);
        library.addIcons(faArrowUpFromSquare, faArrowUpFromSquare$1, faArrowUpFromSquare$2, faArrowUpFromSquare$3);
        library.addIcons(faArrowUpRightFromSquare, faArrowUpRightFromSquare$1, faArrowUpRightFromSquare$2, faArrowUpRightFromSquare$3);
        library.addIcons(faArrowsRotate, faArrowsRotate$1, faArrowsRotate$2, faArrowsRotate$3);
        library.addIcons(faArrowsUpDownLeftRight, faArrowsUpDownLeftRight$1, faArrowsUpDownLeftRight$2, faArrowsUpDownLeftRight$3);
        library.addIcons(faAward, faAward$1, faAward$2, faAward$3);
        library.addIcons(faBars, faBars$1, faBars$2, faBars$3);
        library.addIcons(faBolt, faBolt$1, faBolt$2, faBolt$3);
        library.addIcons(faBell, faBell$1, faBell$2, faBell$3);
        library.addIcons(faBook, faBook$1, faBook$2, faBook$3);
        library.addIcons(faBriefcase, faBriefcase$1, faBriefcase$2, faBriefcase$3);
        library.addIcons(faBuilding, faBuilding$1, faBuilding$2, faBuilding$3);
        library.addIcons(faBrowser, faBrowser$1, faBrowser$2, faBrowser$3);
        library.addIcons(faBug, faBug$1, faBug$2, faBug$3);
        library.addIcons(faBullseyePointer, faBullseyePointer$1, faBullseyePointer$2, faBullseyePointer$3);
        library.addIcons(faCalendarClock, faCalendarClock$1, faCalendarClock$2, faCalendarClock$3);
        library.addIcons(faCalendarDays, faCalendarDays$1, faCalendarDays$2, faCalendarDays$3);
        library.addIcons(faCamera, faCamera$1, faCamera$2, faCamera$3);
        library.addIcons(faChartColumn, faChartColumn$1, faChartColumn$2, faChartColumn$3);
        library.addIcons(faCheck, faCheck$1, faCheck$2, faCheck$3);
        library.addIcons(faChevronDown, faChevronDown$1, faChevronDown$2, faChevronDown$3);
        library.addIcons(faChevronLeft, faChevronLeft$1, faChevronLeft$2, faChevronLeft$3);
        library.addIcons(faChevronRight, faChevronRight$1, faChevronRight$2, faChevronRight$3);
        library.addIcons(faChevronUp, faChevronUp$1, faChevronUp$2, faChevronUp$3);
        library.addIcons(faChevronsLeft, faChevronsLeft$1, faChevronsLeft$2, faChevronsLeft$3);
        library.addIcons(faChevronsRight, faChevronsRight$1, faChevronsRight$2, faChevronsRight$3);
        library.addIcons(faChevronsUp, faChevronsUp$1, faChevronsUp$2, faChevronsUp$3);
        library.addIcons(faChevronsDown, faChevronsDown$1, faChevronsDown$2, faChevronsDown$3);
        library.addIcons(faCircle, faCircle$1, faCircle$2, faCircle$3);
        library.addIcons(faCircleCheck, faCircleCheck$1, faCircleCheck$2, faCircleCheck$3);
        library.addIcons(faCircleDot, faCircleDot$1, faCircleDot$2, faCircleDot$3);
        library.addIcons(faCircleExclamation, faCircleExclamation$1, faCircleExclamation$2, faCircleExclamation$3);
        library.addIcons(faCircleHalfStroke, faCircleHalfStroke$1, faCircleHalfStroke$2, faCircleHalfStroke$3);
        library.addIcons(faCircleInfo, faCircleInfo$1, faCircleInfo$2, faCircleInfo$3);
        library.addIcons(faCirclePlay, faCirclePlay$1, faCirclePlay$2, faCirclePlay$3);
        library.addIcons(faCircleQuestion, faCircleQuestion$1, faCircleQuestion$2, faCircleQuestion$3);
        library.addIcons(faCircleStop, faCircleStop$1, faCircleStop$2, faCircleStop$3);
        library.addIcons(faCircleXmark, faCircleXmark$1, faCircleXmark$2, faCircleXmark$3);
        library.addIcons(faClipboardList, faClipboardList$1, faClipboardList$2, faClipboardList$3);
        library.addIcons(faClock, faClock$1, faClock$2, faClock$3);
        library.addIcons(faCog, faCog$1, faCog$2, faCog$3);
        library.addIcons(faComment, faComment$1, faComment$2, faComment$3);
        library.addIcons(faCompassDrafting, faCompassDrafting$1, faCompassDrafting$2, faCompassDrafting$3);
        library.addIcons(faCopy, faCopy$1, faCopy$2, faCopy$3);
        library.addIcons(faEllipsis, faEllipsis$1, faEllipsis$2, faEllipsis$3);
        library.addIcons(faEllipsisVertical, faEllipsisVertical$1, faEllipsisVertical$2, faEllipsisVertical$3);
        library.addIcons(faEmptySet, faEmptySet$1, faEmptySet$2, faEmptySet$3);
        library.addIcons(faEnvelope, faEnvelope$1, faEnvelope$2, faEnvelope$3);
        library.addIcons(faEye, faEye$1, faEye$2, faEye$3);
        library.addIcons(faEyeSlash, faEyeSlash$1, faEyeSlash$2, faEyeSlash$3);
        library.addIcons(faFile, faFile$1, faFile$2, faFile$3);
        library.addIcons(faFileArrowUp, faFileArrowUp$1, faFileArrowUp$2, faFileArrowUp$3);
        library.addIcons(faFileCsv, faFileCsv$1, faFileCsv$2, faFileCsv$3);
        library.addIcons(faFileExcel, faFileExcel$1, faFileExcel$2, faFileExcel$3);
        library.addIcons(faFileInvoice, faFileInvoice$1, faFileInvoice$2, faFileInvoice$3);
        library.addIcons(faFileMagnifyingGlass, faFileMagnifyingGlass$1, faFileMagnifyingGlass$2, faFileMagnifyingGlass$3);
        library.addIcons(faFileMinus, faFileMinus$1, faFileMinus$2, faFileMinus$3);
        library.addIcons(faFilePdf, faFilePdf$1, faFilePdf$2, faFilePdf$3);
        library.addIcons(faFilePlus, faFilePlus$1, faFilePlus$2, faFilePlus$3);
        library.addIcons(faFlag, faFlag$1, faFlag$2, faFlag$3);
        library.addIcons(faFolder, faFolder$1, faFolder$2, faFolder$3);
        library.addIcons(faFolderGear, faFolderGear$1, faFolderGear$2, faFolderGear$3);
        library.addIcons(faFont, faFont$1, faFont$2, faFont$3);
        library.addIcons(faFrame, faFrame$1, faFrame$2, faFrame$3);
        library.addIcons(faGavel, faGavel$1, faGavel$2, faGavel$3);
        library.addIcons(faGear, faGear$1, faGear$2, faGear$3);
        library.addIcons(faGlobe, faGlobe$1, faGlobe$2, faGlobe$3);
        library.addIcons(faGraduationCap, faGraduationCap$1, faGraduationCap$2, faGraduationCap$3);
        library.addIcons(faGrid, faGrid$1, faGrid$2, faGrid$3);
        library.addIcons(faHandPointer, faHandPointer$1, faHandPointer$2, faHandPointer$3);
        library.addIcons(faHeart, faHeart$1, faHeart$2, faHeart$3);
        library.addIcons(faHome, faHome$1, faHome$2, faHome$3);
        library.addIcons(faICursor, faICursor$1, faICursor$2, faICursor$3);
        library.addIcons(faImage, faImage$1, faImage$2, faImage$3);
        library.addIcons(faKerning, faKerning$1, faKerning$2, faKerning$3);
        library.addIcons(faKey, faKey$1, faKey$2, faKey$3);
        library.addIcons(faKeyboard, faKeyboard$1, faKeyboard$2, faKeyboard$3);
        library.addIcons(faLink, faLink$1, faLink$2, faLink$3);
        library.addIcons(faLinkSlash, faLinkSlash$1, faLinkSlash$2, faLinkSlash$3);
        library.addIcons(faListUl, faListUl$1, faListUl$2, faListUl$3);
        library.addIcons(faLock, faLock$1, faLock$2, faLock$3);
        library.addIcons(faLockOpen, faLockOpen$1, faLockOpen$2, faLockOpen$3);
        library.addIcons(faMagnifyingGlass, faMagnifyingGlass$1, faMagnifyingGlass$2, faMagnifyingGlass$3);
        library.addIcons(faMagnifyingGlassMinus, faMagnifyingGlassMinus$1, faMagnifyingGlassMinus$2, faMagnifyingGlassMinus$3);
        library.addIcons(faMagnifyingGlassPlus, faMagnifyingGlassPlus$1, faMagnifyingGlassPlus$2, faMagnifyingGlassPlus$3);
        library.addIcons(faMap, faMap$1, faMap$2, faMap$3);
        library.addIcons(faMessagesQuestion, faMessagesQuestion$1, faMessagesQuestion$2, faMessagesQuestion$3);
        library.addIcons(faMicrochipAi, faMicrochipAi$1, faMicrochipAi$2, faMicrochipAi$3);
        library.addIcons(faMinus, faMinus$1, faMinus$2, faMinus$3);
        library.addIcons(faMobile, faMobile$1, faMobile$2, faMobile$3);
        library.addIcons(faPaperclip, faPaperclip$1, faPaperclip$2, faPaperclip$3);
        library.addIcons(faPencil, faPencil$1, faPencil$2, faPencil$3);
        library.addIcons(faPlus, faPlus$1, faPlus$2, faPlus$3);
        library.addIcons(faPuzzlePiece, faPuzzlePiece$1, faPuzzlePiece$2, faPuzzlePiece$3);
        library.addIcons(faRecordVinyl, faRecordVinyl$1, faRecordVinyl$2, faRecordVinyl$3);
        library.addIcons(faShareNodes, faShareNodes$1, faShareNodes$2, faShareNodes$3);
        library.addIcons(faSliders, faSliders$1, faSliders$2, faSliders$3);
        library.addIcons(faSort, faSort$1, faSort$2, faSort$3);
        library.addIcons(faSortDown, faSortDown$1, faSortDown$2, faSortDown$3);
        library.addIcons(faSortUp, faSortUp$1, faSortUp$2, faSortUp$3);
        library.addIcons(faSparkles, faSparkles$1, faSparkles$2, faSparkles$3);
        library.addIcons(faSquare, faSquare$1, faSquare$2, faSquare$3);
        library.addIcons(faSquareCheck, faSquareCheck$1, faSquareCheck$2, faSquareCheck$3);
        library.addIcons(faSquareChevronDown, faSquareChevronDown$1, faSquareChevronDown$2, faSquareChevronDown$3);
        library.addIcons(faSquareMinus, faSquareMinus$1, faSquareMinus$2, faSquareMinus$3);
        library.addIcons(faStar, faStar$1, faStar$2, faStar$3);
        library.addIcons(faSuitcase, faSuitcase$1, faSuitcase$2, faSuitcase$3);
        library.addIcons(faTag, faTag$1, faTag$2, faTag$3);
        library.addIcons(faTextSize, faTextSize$1, faTextSize$2, faTextSize$3);
        library.addIcons(faThumbsDown, faThumbsDown$1, faThumbsDown$2, faThumbsDown$3);
        library.addIcons(faThumbsUp, faThumbsUp$1, faThumbsUp$2, faThumbsUp$3);
        library.addIcons(faTrashCan, faTrashCan$1, faTrashCan$2, faTrashCan$3);
        library.addIcons(faTriangleExclamation, faTriangleExclamation$1, faTriangleExclamation$2, faTriangleExclamation$3);
        library.addIcons(faUniversalAccess, faUniversalAccess$1, faUniversalAccess$2, faUniversalAccess$3);
        library.addIcons(faUser, faUser$1, faUser$2, faUser$3);
        library.addIcons(faUserCheck, faUserCheck$1, faUserCheck$2, faUserCheck$3);
        library.addIcons(faUserMagnifyingGlass, faUserMagnifyingGlass$1, faUserMagnifyingGlass$2, faUserMagnifyingGlass$3);
        library.addIcons(faUserTag, faUserTag$1, faUserTag$2, faUserTag$3);
        library.addIcons(faUserXmark, faUserXmark$1, faUserXmark$2, faUserXmark$3);
        library.addIcons(faWavePulse, faWavePulse$1, faWavePulse$2, faWavePulse$3);
        library.addIcons(faWrench, faWrench$1, faWrench$2, faWrench$3);
        library.addIcons(faXmark, faXmark$1, faXmark$2, faXmark$3);
        library.addIcons(faCircleMinus, faCircleMinus$1, faCircleMinus$2, faCircleMinus$3);
        library.addIcons(faArrowUp, faArrowUp$1, faArrowUp$2, faArrowUp$3);
        library.addIcons(faArrowDown, faArrowDown$1, faArrowDown$2, faArrowDown$3);
        library.addIcons(faMessageArrowUpRight, faMessageArrowUpRight$1, faMessageArrowUpRight$2, faMessageArrowUpRight$3);
        library.addIcons(faMessageCheck, faMessageCheck$1, faMessageCheck$2, faMessageCheck$3);
        library.addIcons(faArrowUpToLine, faArrowUpToLine$1, faArrowUpToLine$2, faArrowUpToLine$3);
        library.addIcons(faArrowDownToLine, faArrowDownToLine$1, faArrowDownToLine$2, faArrowDownToLine$3);
        library.addIcons(faVolume, faVolume$1, faVolume$2, faVolume$3);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsFontAwesomeModule, deps: [{ token: i2.FaIconLibrary }], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.5", ngImport: i0, type: DsFontAwesomeModule, imports: [CommonModule, FontAwesomeModule], exports: [FontAwesomeModule, CommonModule] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsFontAwesomeModule, imports: [CommonModule, FontAwesomeModule, FontAwesomeModule, CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsFontAwesomeModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, FontAwesomeModule],
                    declarations: [],
                    exports: [FontAwesomeModule, CommonModule],
                }]
        }], ctorParameters: () => [{ type: i2.FaIconLibrary }] });

class DsIconModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsIconModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.5", ngImport: i0, type: DsIconModule, declarations: [DsIconComponent], imports: [CommonModule,
            DsFontAwesomeModule], exports: [DsIconComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsIconModule, imports: [CommonModule,
            DsFontAwesomeModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsIconModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [DsIconComponent],
                    imports: [
                        CommonModule,
                        DsFontAwesomeModule,
                    ],
                    exports: [DsIconComponent],
                }]
        }] });

class DsButtonModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsButtonModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.5", ngImport: i0, type: DsButtonModule, declarations: [DsButtonComponent], imports: [CommonModule, DsIconModule], exports: [DsButtonComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsButtonModule, imports: [CommonModule, DsIconModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsButtonModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [DsButtonComponent],
                    imports: [CommonModule, DsIconModule],
                    exports: [DsButtonComponent],
                }]
        }] });

class DsCheckboxComponent {
    constructor(changeDetectorRef) {
        this.changeDetectorRef = changeDetectorRef;
        this.errorState = false;
        this.required = false;
        this.disabled = false;
        this.indeterminate = false;
        this.checkboxId = this.createUniqueDOMId();
        this.value = '';
        this.isSelected = false;
        this.valueChange = new EventEmitter();
        // @ts-ignore
        this.onTouched = () => { };
        this.onChange = () => { };
        this.errorId = this.createUniqueDOMId();
        this.isHovering = false;
        this.isFocusing = false;
        this.errorIcon = Icons.CircleExclamation;
        this.errorIconStyle = IconStyles.Light;
        this.hostCssClasses = 'ds-checkbox';
    }
    get IconStyle() {
        if (!this.disabled && (this.isHovering || this.isFocusing)) {
            return IconStyles.Regular;
        }
        if (!this.indeterminate && !this.isSelected) {
            return IconStyles.Light;
        }
        return IconStyles.Solid;
    }
    get Icon() {
        if (this.indeterminate) {
            return Icons.SquareMinus;
        }
        if (this.isSelected) {
            return Icons.SquareCheck;
        }
        return Icons.Square;
    }
    writeValue(value) {
        this.isSelected = value;
        this.changeDetectorRef.detectChanges();
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    checkboxChange(value) {
        if (value !== this.isSelected) {
            this.onChange(value);
        }
        this.isSelected = value;
        this.valueChange.emit(value);
        this.changeDetectorRef.detectChanges();
    }
    onMouseEnter() {
        this.isHovering = true;
        this.changeDetectorRef.detectChanges();
    }
    onMouseLeave() {
        this.isHovering = false;
        this.changeDetectorRef.detectChanges();
    }
    createUniqueDOMId() {
        let id;
        do {
            id = `uid_${Math.random()
                .toString(36)
                .substring(2, 2 + 16)}`;
        } while (document.getElementById(id));
        return id;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsCheckboxComponent, deps: [{ token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.5", type: DsCheckboxComponent, selector: "ds-checkbox", inputs: { errorMessage: "errorMessage", errorState: "errorState", label: "label", required: "required", disabled: "disabled", indeterminate: "indeterminate", checkboxId: "checkboxId", value: "value", isSelected: "isSelected" }, outputs: { valueChange: "valueChange" }, host: { properties: { "class": "this.hostCssClasses" } }, providers: [{ provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => DsCheckboxComponent), multi: true }], ngImport: i0, template: "<ng-container>\n  <div>\n    <input\n      type=\"checkbox\"\n      (focus)=\"isFocusing = true\"\n      (blur)=\"isFocusing = false\"\n      (ngModelChange)=\"checkboxChange($event)\"\n      [ngModel]=\"isSelected\"\n      [checked]=\"isSelected\"\n      [value]=\"value\"\n      [required]=\"required\"\n      [indeterminate]=\"indeterminate\"\n      [attr.aria-describedby]=\"errorState ? errorId : ''\"\n      [attr.aria-invalid]=\"errorState\"\n      [disabled]=\"disabled\"\n      (change)=\"$event.stopPropagation()\"\n      id=\"{{ checkboxId }}\"\n    />\n    <label\n      (mouseenter)=\"onMouseEnter()\"\n      (mouseleave)=\"onMouseLeave()\"\n      class=\"ds-checkbox-label form-label\"\n      [class.ds-checkbox-error-border]=\"errorState\"\n      for=\"{{ checkboxId }}\"\n      data-test-id=\"ds-checkbox-label\"\n    >\n      <ds-icon [iconStyle]=\"IconStyle\" [icon]=\"Icon\"></ds-icon>\n      <span>{{ label }}</span\n      ><span *ngIf=\"required\" class=\"ds-checkbox-required\" aria-hidden=\"true\">*</span>\n    </label>\n  </div>\n  <!-- TODO EAP-17082 - Update to use error message component -->\n  <div aria-live=\"polite\" role=\"status\">\n    <div class=\"ds-checkbox-error\" *ngIf=\"errorState\">\n      <ds-icon [iconStyle]=\"errorIconStyle\" [icon]=\"errorIcon\" data-test-id=\"ds-checkbox-error-icon\"></ds-icon>\n      <label id=\"{{ errorId }}\" class=\"form-label\" data-test-id=\"ds-checkbox-error-label\">{{ errorMessage }}</label>\n    </div>\n  </div>\n</ng-container>\n", dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$1.CheckboxControlValueAccessor, selector: "input[type=checkbox][formControlName],input[type=checkbox][formControl],input[type=checkbox][ngModel]" }, { kind: "directive", type: i1$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1$1.CheckboxRequiredValidator, selector: "input[type=checkbox][required][formControlName],input[type=checkbox][required][formControl],input[type=checkbox][required][ngModel]" }, { kind: "directive", type: i1$1.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "component", type: DsIconComponent, selector: "ds-icon", inputs: ["icon", "iconStyle", "scale", "fixedWidth", "secondaryColor", "title"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsCheckboxComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ds-checkbox', providers: [{ provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => DsCheckboxComponent), multi: true }], template: "<ng-container>\n  <div>\n    <input\n      type=\"checkbox\"\n      (focus)=\"isFocusing = true\"\n      (blur)=\"isFocusing = false\"\n      (ngModelChange)=\"checkboxChange($event)\"\n      [ngModel]=\"isSelected\"\n      [checked]=\"isSelected\"\n      [value]=\"value\"\n      [required]=\"required\"\n      [indeterminate]=\"indeterminate\"\n      [attr.aria-describedby]=\"errorState ? errorId : ''\"\n      [attr.aria-invalid]=\"errorState\"\n      [disabled]=\"disabled\"\n      (change)=\"$event.stopPropagation()\"\n      id=\"{{ checkboxId }}\"\n    />\n    <label\n      (mouseenter)=\"onMouseEnter()\"\n      (mouseleave)=\"onMouseLeave()\"\n      class=\"ds-checkbox-label form-label\"\n      [class.ds-checkbox-error-border]=\"errorState\"\n      for=\"{{ checkboxId }}\"\n      data-test-id=\"ds-checkbox-label\"\n    >\n      <ds-icon [iconStyle]=\"IconStyle\" [icon]=\"Icon\"></ds-icon>\n      <span>{{ label }}</span\n      ><span *ngIf=\"required\" class=\"ds-checkbox-required\" aria-hidden=\"true\">*</span>\n    </label>\n  </div>\n  <!-- TODO EAP-17082 - Update to use error message component -->\n  <div aria-live=\"polite\" role=\"status\">\n    <div class=\"ds-checkbox-error\" *ngIf=\"errorState\">\n      <ds-icon [iconStyle]=\"errorIconStyle\" [icon]=\"errorIcon\" data-test-id=\"ds-checkbox-error-icon\"></ds-icon>\n      <label id=\"{{ errorId }}\" class=\"form-label\" data-test-id=\"ds-checkbox-error-label\">{{ errorMessage }}</label>\n    </div>\n  </div>\n</ng-container>\n" }]
        }], ctorParameters: () => [{ type: i0.ChangeDetectorRef }], propDecorators: { errorMessage: [{
                type: Input
            }], errorState: [{
                type: Input
            }], label: [{
                type: Input
            }], required: [{
                type: Input
            }], disabled: [{
                type: Input
            }], indeterminate: [{
                type: Input
            }], checkboxId: [{
                type: Input
            }], value: [{
                type: Input
            }], isSelected: [{
                type: Input
            }], valueChange: [{
                type: Output
            }], hostCssClasses: [{
                type: HostBinding,
                args: ['class']
            }] } });

class DsCheckboxGroupComponent {
    constructor() {
        this.valueChange = new EventEmitter();
        this.class = 'ds-checkbox-group';
        this._isSelectAllActive = false;
        this._value = [];
        this._registeredOnChange = () => { };
        this._registeredOnTouched = () => { };
        this._subscriptions = new Subscription();
        this._checkboxSubscriptions = new Subscription();
    }
    static { this._nextUniqueId = 0; }
    get errorId() {
        return this._errorId;
    }
    set errorState(errorState) {
        this._errorState = errorState;
        this._errorId = errorState ? `ds-checkbox-group-error-${DsCheckboxGroupComponent._nextUniqueId++}` : undefined;
    }
    get errorState() {
        return this._errorState;
    }
    set value(value) {
        this._value = value ?? [];
        this._updateCheckboxValues();
        this._updateSelectAllBox();
    }
    get value() {
        return this._value;
    }
    set selectAllCheckbox(checkbox) {
        this._selectAllCheckbox = checkbox;
        this._updateSelectAllBox();
    }
    get errorIcon() {
        return Icons.CircleExclamation;
    }
    get errorIconStyle() {
        return IconStyles.Light;
    }
    writeValue(obj) {
        this.value = obj;
    }
    registerOnChange(fn) {
        this._registeredOnChange = fn;
    }
    registerOnTouched(fn) {
        this._registeredOnTouched = fn;
    }
    ngOnDestroy() {
        this._subscriptions.unsubscribe();
        this._checkboxSubscriptions.unsubscribe();
    }
    _onCheckboxChange(value, isSelected) {
        let isChanged = false;
        if (isSelected && !this.value.includes(value)) {
            this.value = [...this.value, value];
            isChanged = true;
        }
        else if (!isSelected && this.value.includes(value)) {
            this.value = this.value.filter((item) => item !== value);
            isChanged = true;
        }
        if (isChanged) {
            this._updateSelectAllBox();
            this.valueChange.emit(this.value);
            this._registeredOnChange(this.value);
            this._registeredOnTouched();
        }
    }
    get isAllChecked() {
        return !this._checkboxes.some((checkbox) => !checkbox.disabled && !checkbox.isSelected);
    }
    onSelectAllChange(selectAll) {
        if (CommonUtility.isNullish(this._checkboxes)) {
            return;
        }
        this._isSelectAllActive = selectAll;
        // Note: for disabled checkboxes we don't change the selected status with select all button
        const newValue = this._checkboxes
            .filter((cb) => (cb.disabled && cb.isSelected) || (selectAll && !cb.disabled))
            .map((cb) => cb.value);
        this.value = newValue;
        this._updateCheckboxValues();
        this._updateSelectAllBox();
        this.valueChange.emit(this.value);
        this._registeredOnChange(this.value);
        this._registeredOnTouched();
    }
    get indeterminate() {
        return (this._checkboxes.some((checkbox) => !checkbox.disabled && checkbox.isSelected) && !this.isAllChecked);
    }
    ngAfterContentInit() {
        if (CommonUtility.isNullish(this._checkboxes)) {
            return;
        }
        this._setupCheckboxSubscriptions();
        this._subscriptions.add(this._checkboxes.changes.subscribe(() => {
            const currentValues = this._checkboxes.map((checkbox) => checkbox.value);
            if (this._isSelectAllActive) {
                this.value = currentValues;
            }
            else {
                const newValue = this.value.filter((value) => currentValues.includes(value));
                if (newValue.length !== this.value.length) {
                    this.value = newValue;
                }
            }
            this._updateCheckboxValues();
            this._updateSelectAllBox();
            this._setupCheckboxSubscriptions();
            this.valueChange.emit(this.value);
            this._registeredOnChange(this.value);
            this._registeredOnTouched();
        }));
        this._updateCheckboxValues();
    }
    _setupCheckboxSubscriptions() {
        this._checkboxSubscriptions.unsubscribe();
        this._checkboxSubscriptions = new Subscription();
        this._checkboxes.forEach((checkbox) => {
            this._checkboxSubscriptions.add(checkbox.valueChange.subscribe((isSelected) => {
                this._onCheckboxChange(checkbox.value, isSelected);
            }));
        });
    }
    _updateCheckboxValues() {
        if (CommonUtility.isNullish(this._checkboxes)) {
            return;
        }
        this._checkboxes.forEach((checkbox) => {
            checkbox.writeValue(this.value.includes(checkbox.value));
        });
    }
    _updateSelectAllBox() {
        if (CommonUtility.isNullish(this._selectAllCheckbox) || CommonUtility.isNullish(this._checkboxes)) {
            return;
        }
        this._selectAllCheckbox.writeValue(this.isAllChecked);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsCheckboxGroupComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.5", type: DsCheckboxGroupComponent, selector: "ds-checkbox-group", inputs: { label: "label", required: "required", instructions: "instructions", errorMessage: "errorMessage", hideSelectAll: "hideSelectAll", errorState: "errorState", value: "value" }, outputs: { valueChange: "valueChange" }, host: { properties: { "class": "this.class" } }, providers: [
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => DsCheckboxGroupComponent),
                multi: true,
            },
        ], queries: [{ propertyName: "_checkboxes", predicate: i0.forwardRef(() => DsCheckboxComponent), descendants: true }], viewQueries: [{ propertyName: "selectAllCheckbox", first: true, predicate: ["selectAll"], descendants: true }], ngImport: i0, template: "<fieldset [attr.aria-invalid]=\"errorState\" [attr.aria-describedby]=\"errorId\">\n  <legend [class.required]=\"required\">{{ label }}<span *ngIf=\"required\"> *</span></legend>\n  <div class=\"ds-checkbox-group-instructions\" *ngIf=\"instructions\">\n    {{ instructions }}\n  </div>\n  <div class=\"ds-checkbox-group-items\" [ngClass]=\"{ error: errorState }\">\n    <ds-checkbox\n      *ngIf=\"!hideSelectAll\"\n      label=\"Select all\"\n      (valueChange)=\"onSelectAllChange($event)\"\n      [indeterminate]=\"indeterminate\"\n      #selectAll\n    ></ds-checkbox>\n    <ng-content></ng-content>\n  </div>\n  <div aria-live=\"polite\" role=\"status\">\n    <!-- TODO: replace with ds error message component once it's ready - EAP-17082 -->\n    <div *ngIf=\"errorState\" [id]=\"errorId\" class=\"ds-checkbox-group-error-message\">\n      <ds-icon [iconStyle]=\"errorIconStyle\" [icon]=\"errorIcon\"></ds-icon>\n      <ng-container>{{ errorMessage }}</ng-container>\n    </div>\n  </div>\n</fieldset>\n", dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: DsIconComponent, selector: "ds-icon", inputs: ["icon", "iconStyle", "scale", "fixedWidth", "secondaryColor", "title"] }, { kind: "component", type: DsCheckboxComponent, selector: "ds-checkbox", inputs: ["errorMessage", "errorState", "label", "required", "disabled", "indeterminate", "checkboxId", "value", "isSelected"], outputs: ["valueChange"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsCheckboxGroupComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ds-checkbox-group', providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef(() => DsCheckboxGroupComponent),
                            multi: true,
                        },
                    ], template: "<fieldset [attr.aria-invalid]=\"errorState\" [attr.aria-describedby]=\"errorId\">\n  <legend [class.required]=\"required\">{{ label }}<span *ngIf=\"required\"> *</span></legend>\n  <div class=\"ds-checkbox-group-instructions\" *ngIf=\"instructions\">\n    {{ instructions }}\n  </div>\n  <div class=\"ds-checkbox-group-items\" [ngClass]=\"{ error: errorState }\">\n    <ds-checkbox\n      *ngIf=\"!hideSelectAll\"\n      label=\"Select all\"\n      (valueChange)=\"onSelectAllChange($event)\"\n      [indeterminate]=\"indeterminate\"\n      #selectAll\n    ></ds-checkbox>\n    <ng-content></ng-content>\n  </div>\n  <div aria-live=\"polite\" role=\"status\">\n    <!-- TODO: replace with ds error message component once it's ready - EAP-17082 -->\n    <div *ngIf=\"errorState\" [id]=\"errorId\" class=\"ds-checkbox-group-error-message\">\n      <ds-icon [iconStyle]=\"errorIconStyle\" [icon]=\"errorIcon\"></ds-icon>\n      <ng-container>{{ errorMessage }}</ng-container>\n    </div>\n  </div>\n</fieldset>\n" }]
        }], propDecorators: { label: [{
                type: Input
            }], required: [{
                type: Input
            }], instructions: [{
                type: Input
            }], errorMessage: [{
                type: Input
            }], hideSelectAll: [{
                type: Input
            }], valueChange: [{
                type: Output
            }], class: [{
                type: HostBinding,
                args: ['class']
            }], _checkboxes: [{
                type: ContentChildren,
                args: [forwardRef(() => DsCheckboxComponent), { descendants: true }]
            }], errorState: [{
                type: Input
            }], value: [{
                type: Input
            }], selectAllCheckbox: [{
                type: ViewChild,
                args: ['selectAll']
            }] } });

class DsCheckboxModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsCheckboxModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.5", ngImport: i0, type: DsCheckboxModule, declarations: [DsCheckboxComponent, DsCheckboxGroupComponent], imports: [CommonModule, FormsModule, DsIconModule], exports: [DsCheckboxComponent, DsCheckboxGroupComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsCheckboxModule, imports: [CommonModule, FormsModule, DsIconModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsCheckboxModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [DsCheckboxComponent, DsCheckboxGroupComponent],
                    imports: [CommonModule, FormsModule, DsIconModule],
                    exports: [DsCheckboxComponent, DsCheckboxGroupComponent],
                }]
        }] });

var DsBreakpoints;
(function (DsBreakpoints) {
    DsBreakpoints[DsBreakpoints["Small"] = 575] = "Small";
    DsBreakpoints[DsBreakpoints["Medium"] = 991] = "Medium";
    DsBreakpoints[DsBreakpoints["Large"] = -1] = "Large";
})(DsBreakpoints || (DsBreakpoints = {}));

var MessageBusChannels;
(function (MessageBusChannels) {
    MessageBusChannels["dsTooltipShow"] = "dsTooltipShow";
    MessageBusChannels["dsTooltipHide"] = "dsTooltipHide";
})(MessageBusChannels || (MessageBusChannels = {}));
class MessageBusService {
    constructor() {
        this.channels = {};
        Object.keys(MessageBusChannels).forEach(this.initChannel.bind(this));
    }
    initChannel(channelName) {
        const channel = {
            subject: new Subject(),
        };
        if (typeof this.channels[channelName] === 'object') {
            throw new Error('[MessageBusService.initChannel] channel "' + channel + '" already initialised.');
        }
        this.channels[channelName] = channel;
    }
    from(channel) {
        if (CommonUtility.isNullish(this.channels[channel])) {
            throw new Error('[MessageBusService.from] channel "' + channel + '" does not exist.');
        }
        // Keep async scheduler to preserve order of events for observers
        return this.channels[channel].subject.pipe(observeOn(asyncScheduler));
    }
    to(channel, data) {
        if (CommonUtility.isNullish(this.channels[channel])) {
            throw new Error('[MessageBusService.to] channel "' + channel + '" does not exist.');
        }
        this.channels[channel].subject.next(data);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: MessageBusService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: MessageBusService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: MessageBusService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [] });

class DomUtility {
    static createUniqueDOMId(prefix = 'uid') {
        let id;
        do {
            id = `${prefix}-${CommonUtility.getRandomInsecureString()}`;
        } while (document.getElementById(id));
        return id;
    }
    static getPageScroll() {
        let scrOfX = 0;
        let scrOfY = 0;
        if (typeof window.pageYOffset === 'number') {
            scrOfY = window.pageYOffset;
            scrOfX = window.pageXOffset;
        }
        else if (document.body && (document.body.scrollLeft || document.body.scrollTop)) {
            scrOfY = document.body.scrollTop;
            scrOfX = document.body.scrollLeft;
        }
        else if (document.documentElement && (document.documentElement.scrollLeft || document.documentElement.scrollTop)) {
            scrOfY = document.documentElement.scrollTop;
            scrOfX = document.documentElement.scrollLeft;
        }
        return { scrollX: scrOfX, scrollY: scrOfY };
    }
    static getScreenBreakpoint() {
        if (window.matchMedia(`(max-width: ${DsBreakpoints.Small}px)`).matches) {
            return DsBreakpoints.Small;
        }
        if (window.matchMedia(`(max-width: ${DsBreakpoints.Medium}px)`).matches) {
            return DsBreakpoints.Medium;
        }
        return DsBreakpoints.Large;
    }
    /**
     * Uses the window object to create a MediaQueryList whose query is `(max-width: ${maxWidth}px)`. Then observes its
     * "change" event and maps the resulting observable by returning the "matches" property of the MediaQueryList.
     *
     * @param maxWidth Max width to be used in the media query added to the window object.
     */
    static observeBreakpoint(maxWidth) {
        const mediaQuery = window.matchMedia(`(max-width: ${maxWidth}px)`);
        return fromEvent(mediaQuery, 'change').pipe(startWith(mediaQuery), map((mediaQueryList) => mediaQueryList.matches));
    }
}

var DsModalColorVariant;
(function (DsModalColorVariant) {
    DsModalColorVariant["Default"] = "Default";
    DsModalColorVariant["DarkBlue"] = "DarkBlue";
    DsModalColorVariant["LightBlue"] = "LightBlue";
})(DsModalColorVariant || (DsModalColorVariant = {}));
var DsModalVariant;
(function (DsModalVariant) {
    DsModalVariant["fullScreen"] = "fullScreen";
    DsModalVariant["slideOut"] = "slideOut";
    DsModalVariant["center"] = "center";
})(DsModalVariant || (DsModalVariant = {}));
var DsModalSlideOutAlignment;
(function (DsModalSlideOutAlignment) {
    DsModalSlideOutAlignment["start"] = "start";
    DsModalSlideOutAlignment["end"] = "end";
})(DsModalSlideOutAlignment || (DsModalSlideOutAlignment = {}));

class FocusTrapService {
    createFocusTrap(el) {
        this.deactivate();
        try {
            this.focusTrap = createFocusTrap(el);
            this.focusTrap.activate();
        }
        catch (e) {
            // if there's no focusable elements, then createFocusTrap will error
            this.focusTrap = undefined;
        }
        return this.focusTrap;
    }
    deactivate() {
        if (this.focusTrap !== undefined) {
            this.focusTrap.deactivate();
        }
    }
    getFocusTrap() {
        return this.focusTrap;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: FocusTrapService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: FocusTrapService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: FocusTrapService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }] });

const BOOTSTRAP_SLIDEOUT_DELAY_MS = 5;
class DsModalService {
    constructor(ngbModalService, ngbOffcanvasService, focusTrap) {
        this.ngbModalService = ngbModalService;
        this.ngbOffcanvasService = ngbOffcanvasService;
        this.focusTrap = focusTrap;
        this.subscriptions = new Subscription();
        this.activeModals = [];
        // TODO: EAP-25200 remove these accessibility features after they're implemented in ng-boostrap (may require package update)
        this.subscriptions.add(merge(this.activeSlideoutInstance(), this.activeModalInstances()).subscribe({
            next: () => {
                if (CommonUtility.notNullish(this.focusTrap)) {
                    this.focusTrap.deactivate();
                }
                // timeout required because createFocusTrap can interrupt animations
                setTimeout(() => {
                    // animations shenanigans have to be ignored
                    const allModals = document.querySelectorAll('ngb-offcanvas-panel:not(.hiding), ngb-modal-window.show');
                    if (allModals.length > 0) {
                        const lastModal = allModals.item(allModals.length - 1);
                        const windowModal = lastModal.firstElementChild;
                        this.focusTrap.createFocusTrap(windowModal);
                        windowModal.setAttribute('aria-hidden', 'false');
                        if (allModals.length > 1) {
                            const penultimateModal = allModals.item(allModals.length - 2);
                            const penultimateWindowModal = penultimateModal.firstElementChild;
                            penultimateWindowModal.setAttribute('aria-hidden', 'true');
                        }
                    }
                }, BOOTSTRAP_SLIDEOUT_DELAY_MS);
            },
        }));
    }
    returnFocus() {
        setTimeout(() => {
            if (CommonUtility.notNullish(this.initiatingElement)) {
                this.initiatingElement.focus();
                this.initiatingElement = null;
            }
        }, BOOTSTRAP_SLIDEOUT_DELAY_MS);
        this.activeModals = [];
    }
    onInitialModalClosed(_) {
        this.activeModals = [];
    }
    get modalCount() {
        return this.activeModals.length;
    }
    hasPreviousModal() {
        return this.activeModals.length > 1;
    }
    open(content, modalVariant, slideOutAlignment) {
        let isInitialModal = false;
        if (CommonUtility.isNullishOrEmpty(this.activeModals)) {
            this.initiatingElement = document.activeElement;
            isInitialModal = true;
        }
        let modalRef;
        switch (modalVariant) {
            case DsModalVariant.fullScreen:
                modalRef = this.ngbModalService.open(content, {
                    backdrop: false,
                    fullscreen: true,
                });
                break;
            case DsModalVariant.center:
                modalRef = this.ngbModalService.open(content, {
                    backdrop: true,
                    backdropClass: 'modal-backdrop',
                    centered: true,
                    windowClass: 'modal-window',
                });
                break;
            case DsModalVariant.slideOut:
                modalRef = this.ngbOffcanvasService.open(content, {
                    position: slideOutAlignment ?? DsModalSlideOutAlignment.end,
                    backdrop: true,
                    backdropClass: 'modal-backdrop',
                });
                break;
            default:
                break;
        }
        if (modalRef) {
            if (isInitialModal) {
                this.subscriptions.add(modalRef.closed.subscribe(this.onInitialModalClosed.bind(this)));
                this.subscriptions.add(modalRef.dismissed.subscribe(this.onInitialModalClosed.bind(this)));
            }
            this.activeModals.push(modalRef);
        }
        return modalRef;
    }
    previousModal() {
        if (this.activeModals.length > 0) {
            const currentModal = this.activeModals.pop();
            currentModal.dismiss();
            return this.activeModals[this.activeModals.length - 1];
        }
        this.returnFocus();
        return undefined;
    }
    closeAllModals() {
        this.ngbModalService.dismissAll();
        this.activeModals.forEach((activeModal) => {
            if (activeModal instanceof NgbOffcanvasRef) {
                activeModal.dismiss();
            }
        });
        this.returnFocus();
    }
    activeSlideoutInstance() {
        return this.ngbOffcanvasService.activeInstance;
    }
    activeModalInstances() {
        return this.ngbModalService.activeInstances;
    }
    ngOnDestroy() {
        this.subscriptions?.unsubscribe();
        this.focusTrap.deactivate();
        setTimeout(() => this.focusTrap.deactivate(), BOOTSTRAP_SLIDEOUT_DELAY_MS);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsModalService, deps: [{ token: i4.NgbModal }, { token: i4.NgbOffcanvas }, { token: FocusTrapService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsModalService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsModalService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: i4.NgbModal }, { type: i4.NgbOffcanvas }, { type: FocusTrapService }] });

const tooltipId = 'dsTooltipArea';
const milliSecondsToKeepTooltipOnBlur = 1000;
var DsTooltipPosition;
(function (DsTooltipPosition) {
    DsTooltipPosition["top"] = "top";
    DsTooltipPosition["bottom"] = "bottom";
    DsTooltipPosition["left"] = "left";
    DsTooltipPosition["right"] = "right";
})(DsTooltipPosition || (DsTooltipPosition = {}));
class DsTooltipComponent {
    constructor(messageBusService, router, elementRef) {
        this.messageBusService = messageBusService;
        this.router = router;
        this.elementRef = elementRef;
        this.isHideByBlur = false;
        this.isVisibleByButton = false;
        this.isVisibleByWindow = false;
        this.tooltipId = tooltipId;
        this.milliSecondsToKeepTooltipOnBlur = milliSecondsToKeepTooltipOnBlur;
        this.subscriptions = new Subscription();
        this.text = '';
        this.arrowPosition = DsTooltipPosition.bottom;
        this.adjustingHorizontal = 9; // 7 border width of arrow + 2 border width of left and right
    }
    onMouseover() {
        if (CommonUtility.isNullishOrEmpty(this.text)) {
            return;
        }
        this.isVisibleByWindow = true;
    }
    onMouseOut() {
        this.isVisibleByWindow = false;
        this.hideTooltip();
    }
    /**
     * Set tooltip position once it's rendered with tooltip text.
     *
     * Steps to automate tooltip positioning:
     * - We're getting tooltip width and height. Also, target element's
     *    start position and width and height.
     * - We're calculating cutoff spaces for each direction that tooltip will render.
     *    E.g. when we show tooltip at the top of target element, there are 3 main cutoff direction
     *    such as left, right, top. So we're calculating those cutoff spaces.
     *    If there's enough space, we consider it to zero. We're summing up those cutoff spaces
     *    for each direction.
     * - There'll be 4 total cutoff spaces and sort them out. And if original position has
     *   enough space, then will render in that position. If not, then find best direction that
     *   has the smallest cutoff space.
     *
     * @param targetElement
     * @private
     */
    setPositionBasedOnTargetElement(targetElement) {
        const target = targetElement;
        const targetSizeAndPosition = target.getBoundingClientRect();
        const tooltipElement = this.elementRef.nativeElement.querySelector('ds-tooltip>.ds-tooltip-inner');
        const tooltipSizeAndPosition = tooltipElement.getBoundingClientRect();
        const pageScroll = DomUtility.getPageScroll();
        const viewportWidth = document.documentElement.clientWidth || window.innerWidth;
        const viewportHeight = document.documentElement.clientHeight || window.innerHeight;
        // cutoff space from left and right when tooltip renders on top or bottom
        const horizontalCutoffSpace = Math.min(0, targetSizeAndPosition.left - (tooltipSizeAndPosition.width - targetSizeAndPosition.width) / 2) +
            Math.min(0, viewportWidth - (tooltipSizeAndPosition.width - targetSizeAndPosition.width) / 2 - targetSizeAndPosition.right);
        // cutoff space from top and bottom when tooltip renders on left or right
        const verticalCutoffSpace = Math.min(0, targetSizeAndPosition.top - (tooltipSizeAndPosition.height - targetSizeAndPosition.height) / 2) +
            Math.min(0, viewportHeight - (tooltipSizeAndPosition.height - targetSizeAndPosition.height) / 2 - targetSizeAndPosition.bottom);
        const cutoffSpaceBottom = {
            space: horizontalCutoffSpace + Math.min(0, viewportHeight - tooltipSizeAndPosition.height - targetSizeAndPosition.bottom),
            position: DsTooltipPosition.bottom,
        };
        const cutoffSpaceTop = {
            space: horizontalCutoffSpace + Math.min(0, targetSizeAndPosition.top - tooltipSizeAndPosition.height),
            position: DsTooltipPosition.top,
        };
        const cutoffSpaceLeft = {
            space: verticalCutoffSpace + Math.min(0, targetSizeAndPosition.left - tooltipSizeAndPosition.width),
            position: DsTooltipPosition.left,
        };
        const cutoffSpaceRight = {
            space: verticalCutoffSpace + Math.min(0, viewportWidth - tooltipSizeAndPosition.width - targetSizeAndPosition.right),
            position: DsTooltipPosition.right,
        };
        const directions = [cutoffSpaceLeft, cutoffSpaceRight, cutoffSpaceTop, cutoffSpaceBottom];
        let tooltipPosition = this.tooltipPosition;
        if (CommonUtility.isNullish(directions.find((direction) => direction.position === this.tooltipPosition && direction.space === 0))) {
            directions.sort((a, b) => b.space - a.space);
            tooltipPosition = directions[0].position;
        }
        switch (tooltipPosition) {
            case DsTooltipPosition.right: {
                this.arrowPosition = DsTooltipPosition.left;
                this.left = targetSizeAndPosition.right + this.adjustingHorizontal;
                this.top = targetSizeAndPosition.top + targetSizeAndPosition.height / 2 - tooltipSizeAndPosition.height / 2;
                break;
            }
            case DsTooltipPosition.left: {
                this.arrowPosition = DsTooltipPosition.right;
                this.left = targetSizeAndPosition.left - tooltipSizeAndPosition.width - this.adjustingHorizontal;
                this.top = targetSizeAndPosition.top + targetSizeAndPosition.height / 2 - tooltipSizeAndPosition.height / 2;
                break;
            }
            case DsTooltipPosition.top: {
                this.arrowPosition = DsTooltipPosition.bottom;
                this.top = targetSizeAndPosition.top - tooltipSizeAndPosition.height - this.adjustingHorizontal;
                this.left = targetSizeAndPosition.left + targetSizeAndPosition.width / 2 - tooltipSizeAndPosition.width / 2;
                break;
            }
            case DsTooltipPosition.bottom: {
                this.arrowPosition = DsTooltipPosition.top;
                this.top = targetSizeAndPosition.bottom + this.adjustingHorizontal;
                this.left = targetSizeAndPosition.left + targetSizeAndPosition.width / 2 - tooltipSizeAndPosition.width / 2;
                break;
            }
            default: {
                break;
            }
        }
        // Ensure tooltip stays within viewport bounds
        this.left = Math.max(0, Math.min(viewportWidth - tooltipSizeAndPosition.width, this.left));
        this.top = Math.max(0, Math.min(viewportHeight - tooltipSizeAndPosition.height, this.top));
        this.left += pageScroll.scrollX;
        this.top += pageScroll.scrollY;
    }
    get isOpenedDropdownExists() {
        return CommonUtility.notNullish(document.querySelector('.ds-dropdown-menu.show'));
    }
    showTooltip(data) {
        if (typeof data.text !== 'string' || data.text.length === 0) {
            return;
        }
        if (this.isOpenedDropdownExists) {
            return;
        }
        this.text = data.text;
        this.tooltipPosition = data.position;
        this.isVisibleByButton = true;
        this.isHideByBlur = false;
        // Note: this is needed because we need to give a chance for browser to render a tooltip
        window.setTimeout(this.setPositionBasedOnTargetElement.bind(this, data.event.target));
    }
    hideTooltipByButton(hideType) {
        if (hideType !== 'blur' || this.isHideByBlur) {
            this.isVisibleByButton = false;
            this.hideTooltip();
        }
    }
    hideTooltip() {
        if (this.isVisibleByButton || this.isVisibleByWindow) {
            return;
        }
        this.text = '';
        this.top = 0;
        this.left = 0;
    }
    ngOnInit() {
        const showTooltipSubscription = this.messageBusService
            .from(MessageBusChannels.dsTooltipShow)
            .subscribe(this.showTooltip.bind(this));
        const hideTooltipByNonBlurSubscription = this.messageBusService
            .from(MessageBusChannels.dsTooltipHide)
            .pipe(filter((value) => value !== 'blur'))
            .subscribe(this.hideTooltipByButton.bind(this));
        const hideTooltipByBlurSubscription = this.messageBusService
            .from(MessageBusChannels.dsTooltipHide)
            .pipe(filter((value) => value === 'blur'), tap(() => {
            this.isHideByBlur = true;
        }), delay(this.milliSecondsToKeepTooltipOnBlur))
            .subscribe(this.hideTooltipByButton.bind(this));
        const routeChangedSubscription = this.router.events.subscribe({
            next: () => this.hideTooltipByButton(''),
        });
        this.subscriptions.add(showTooltipSubscription);
        this.subscriptions.add(routeChangedSubscription);
        this.subscriptions.add(hideTooltipByNonBlurSubscription);
        this.subscriptions.add(hideTooltipByBlurSubscription);
    }
    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsTooltipComponent, deps: [{ token: MessageBusService }, { token: i2$1.Router }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.5", type: DsTooltipComponent, selector: "ds-tooltip", inputs: { zIndex: "zIndex" }, host: { listeners: { "mouseover": "onMouseover($event)", "mouseout": "onMouseOut()" } }, ngImport: i0, template: "<div\n  [ngClass]=\"{\n    active: isVisibleByButton || isVisibleByWindow,\n    inactive: isVisibleByButton === false && isVisibleByWindow === false\n  }\"\n  [ngStyle]=\"{\n    'top.px': top,\n    'left.px': left,\n    'z-index': zIndex\n  }\"\n  [id]=\"tooltipId\"\n  role=\"tooltip\"\n  class=\"ds-tooltip-inner\"\n>\n  <div\n    class=\"arrow\"\n    [ngClass]=\"{\n      'top-arrow': arrowPosition === 'top',\n      'bottom-arrow': arrowPosition === 'bottom',\n      'right-arrow': arrowPosition === 'right',\n      'left-arrow': arrowPosition === 'left'\n    }\"\n  >\n    <div class=\"arrow-inner\"></div>\n  </div>\n  {{ text }}\n</div>\n", dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsTooltipComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ds-tooltip', template: "<div\n  [ngClass]=\"{\n    active: isVisibleByButton || isVisibleByWindow,\n    inactive: isVisibleByButton === false && isVisibleByWindow === false\n  }\"\n  [ngStyle]=\"{\n    'top.px': top,\n    'left.px': left,\n    'z-index': zIndex\n  }\"\n  [id]=\"tooltipId\"\n  role=\"tooltip\"\n  class=\"ds-tooltip-inner\"\n>\n  <div\n    class=\"arrow\"\n    [ngClass]=\"{\n      'top-arrow': arrowPosition === 'top',\n      'bottom-arrow': arrowPosition === 'bottom',\n      'right-arrow': arrowPosition === 'right',\n      'left-arrow': arrowPosition === 'left'\n    }\"\n  >\n    <div class=\"arrow-inner\"></div>\n  </div>\n  {{ text }}\n</div>\n" }]
        }], ctorParameters: () => [{ type: MessageBusService }, { type: i2$1.Router }, { type: i0.ElementRef }], propDecorators: { zIndex: [{
                type: Input
            }], onMouseover: [{
                type: HostListener,
                args: ['mouseover', ['$event']]
            }], onMouseOut: [{
                type: HostListener,
                args: ['mouseout']
            }] } });

class DsTooltipDirective {
    get describedBy() {
        return this.tooltipValue ? this.tooltipId : null;
    }
    set tooltipText(text) {
        this.tooltipValue = text;
    }
    constructor(messageBusService) {
        this.messageBusService = messageBusService;
        this.tooltipId = null;
        this.tooltipPlacement = DsTooltipPosition.bottom;
    }
    onActive(event) {
        this.tooltipId = tooltipId;
        this.messageBusService.to(MessageBusChannels.dsTooltipShow, {
            text: this.tooltipValue,
            position: this.tooltipPlacement,
            event: event,
        });
    }
    onBlur() {
        this.tooltipId = null;
        this.messageBusService.to(MessageBusChannels.dsTooltipHide, 'blur');
    }
    onDeActive() {
        this.tooltipId = null;
        this.messageBusService.to(MessageBusChannels.dsTooltipHide, '');
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsTooltipDirective, deps: [{ token: MessageBusService }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.5", type: DsTooltipDirective, selector: "[ds-tooltip]", inputs: { tooltipText: ["ds-tooltip", "tooltipText"], tooltipPlacement: "tooltipPlacement" }, host: { listeners: { "mouseenter": "onActive($event)", "focus": "onActive($event)", "focusout": "onBlur()", "mouseleave": "onBlur()", "document:keydown.escape": "onDeActive()" }, properties: { "attr.aria-describedby": "this.describedBy" } }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsTooltipDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[ds-tooltip]',
                }]
        }], ctorParameters: () => [{ type: MessageBusService }], propDecorators: { describedBy: [{
                type: HostBinding,
                args: ['attr.aria-describedby']
            }], tooltipText: [{
                type: Input,
                args: ['ds-tooltip']
            }], tooltipPlacement: [{
                type: Input
            }], onActive: [{
                type: HostListener,
                args: ['mouseenter', ['$event']]
            }, {
                type: HostListener,
                args: ['focus', ['$event']]
            }], onBlur: [{
                type: HostListener,
                args: ['focusout']
            }, {
                type: HostListener,
                args: ['mouseleave']
            }], onDeActive: [{
                type: HostListener,
                args: ['document:keydown.escape']
            }] } });

var DsLinkType;
(function (DsLinkType) {
    DsLinkType["Href"] = "href";
    DsLinkType["RouterLink"] = "routerLink";
    DsLinkType["Disabled"] = "disabled";
})(DsLinkType || (DsLinkType = {}));
var DsLinkTarget;
(function (DsLinkTarget) {
    DsLinkTarget["Self"] = "_self";
    DsLinkTarget["Blank"] = "_blank";
})(DsLinkTarget || (DsLinkTarget = {}));
class DsLinkComponent {
    set tooltip(tooltip) {
        this._tooltip = tooltip;
    }
    get tooltip() {
        return this.labelText.length === 0 || this.disabled ? this._tooltip : undefined;
    }
    constructor(elRef, changeDetectorRef) {
        this.elRef = elRef;
        this.changeDetectorRef = changeDetectorRef;
        this.activated = new EventEmitter();
        this.disabled = false;
        this.standalone = false;
        this.skip = false;
        this.icon = null;
        this.linkColor = DsLinkColor.Default;
        this.hovered = false;
        this.focused = false;
        this.LinkType = DsLinkType;
        this.externalLinkIcon = Icons.ArrowUpRightFromSquare;
        this.linkColors = {
            black: DsLinkColor.Black,
            white: DsLinkColor.White,
            dark: DsLinkColor.Dark,
        };
    }
    get linkType() {
        if (this.disabled) {
            return DsLinkType.Disabled;
        }
        if (CommonUtility.notNullishOrEmpty(this.rtLink)) {
            return DsLinkType.RouterLink;
        }
        return DsLinkType.Href;
    }
    get target() {
        return this.external ? DsLinkTarget.Blank : null;
    }
    onMouseEnter() {
        this.hovered = true;
    }
    onMouseLeave() {
        this.hovered = false;
    }
    onFocus() {
        this.focused = true;
    }
    onBlur() {
        this.focused = false;
    }
    onLinkTriggered(e) {
        if (this.linkType === DsLinkType.Disabled) {
            e.preventDefault();
            return;
        }
        if (this.skip) {
            const targetElement = document.querySelector(this.href);
            if (targetElement) {
                targetElement.focus();
                e.preventDefault();
            }
        }
        this.activated.emit(e);
    }
    get iconStyle() {
        if (!this.disabled && (this.hovered || this.focused)) {
            return IconStyles.Solid;
        }
        return IconStyles.Light;
    }
    get labelText() {
        return this.elRef.nativeElement.innerText.trim();
    }
    ngAfterViewInit() {
        if (this.labelText) {
            this.changeDetectorRef.detectChanges();
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsLinkComponent, deps: [{ token: i0.ElementRef }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.5", type: DsLinkComponent, selector: "ds-link", inputs: { href: "href", rtLink: "rtLink", fragment: "fragment", queryParams: "queryParams", queryParamsHandling: "queryParamsHandling", disabled: "disabled", external: "external", standalone: "standalone", skip: "skip", role: "role", tabindex: "tabindex", icon: "icon", iconTitle: "iconTitle", tooltipPlacement: "tooltipPlacement", linkColor: "linkColor", ariaCurrent: "ariaCurrent", ariaLabel: "ariaLabel", tooltip: "tooltip" }, outputs: { activated: "activated" }, host: { listeners: { "mouseenter": "onMouseEnter()", "mouseleave": "onMouseLeave()", "focus": "onFocus()", "blur": "onBlur()" } }, ngImport: i0, template: "<ng-template #linkContent>\n  <ds-icon\n    *ngIf=\"icon\"\n    [icon]=\"icon\"\n    class=\"ds-link-icon\"\n    [iconStyle]=\"iconStyle\"\n    [title]=\"iconTitle\"\n    [class.ds-link-icon-with-label]=\"labelText.length > 0\"\n  ></ds-icon>\n  <ng-content></ng-content>\n  <ds-icon *ngIf=\"external\" [icon]=\"externalLinkIcon\" class=\"ds-link-external-icon\" aria-label=\"opens in new tab\"></ds-icon>\n</ng-template>\n\n<ng-container [ngSwitch]=\"linkType\">\n  <a\n    *ngSwitchCase=\"LinkType.RouterLink\"\n    [ds-tooltip]=\"tooltip\"\n    [tooltipPlacement]=\"tooltipPlacement\"\n    (focus)=\"onFocus()\"\n    (blur)=\"onBlur()\"\n    [href]=\"href\"\n    [routerLink]=\"rtLink\"\n    [fragment]=\"fragment\"\n    [queryParams]=\"queryParams\"\n    [queryParamsHandling]=\"queryParamsHandling\"\n    [class.external-link]=\"external\"\n    [class.standalone]=\"standalone\"\n    [class.inline]=\"!standalone\"\n    [class.ds-skip-link]=\"skip\"\n    [class.link-black-color-variant]=\"linkColor === linkColors.black\"\n    [class.link-white-color-variant]=\"linkColor === linkColors.white\"\n    [class.link-dark-color-variant]=\"linkColor === linkColors.dark\"\n    [attr.target]=\"target\"\n    [attr.role]=\"role\"\n    [attr.aria-current]=\"ariaCurrent\"\n    [attr.aria-label]=\"ariaLabel\"\n    [tabindex]=\"tabindex\"\n    (click)=\"onLinkTriggered($event)\"\n    (keydown.enter)=\"onLinkTriggered($event)\"\n    class=\"ds-link\"\n  >\n    <ng-container *ngTemplateOutlet=\"linkContent\"></ng-container>\n  </a>\n\n  <a\n    *ngSwitchCase=\"LinkType.Disabled\"\n    class=\"disabled-link ds-link\"\n    [ds-tooltip]=\"tooltip\"\n    [tooltipPlacement]=\"tooltipPlacement\"\n    [attr.role]=\"role\"\n    [tabindex]=\"tabindex\"\n    [class.external-link]=\"external\"\n    [class.standalone]=\"standalone\"\n    [class.inline]=\"!standalone\"\n    [class.link-black-color-variant]=\"linkColor === linkColors.black\"\n    [class.link-white-color-variant]=\"linkColor === linkColors.white\"\n    [class.link-dark-color-variant]=\"linkColor === linkColors.dark\"\n    href=\"#\"\n    (click)=\"onLinkTriggered($event)\"\n    (keydown.enter)=\"onLinkTriggered($event)\"\n  >\n    <ng-container *ngTemplateOutlet=\"linkContent\"></ng-container>\n  </a>\n\n  <a\n    *ngSwitchDefault\n    (focus)=\"onFocus()\"\n    (blur)=\"onBlur()\"\n    [href]=\"href\"\n    [ds-tooltip]=\"tooltip\"\n    [tabindex]=\"tabindex\"\n    [tooltipPlacement]=\"tooltipPlacement\"\n    [class.external-link]=\"external\"\n    [class.standalone]=\"standalone\"\n    [class.inline]=\"!standalone\"\n    [class.ds-skip-link]=\"skip\"\n    [attr.target]=\"target\"\n    [attr.role]=\"role\"\n    [class.link-black-color-variant]=\"linkColor === linkColors.black\"\n    [class.link-white-color-variant]=\"linkColor === linkColors.white\"\n    [class.link-dark-color-variant]=\"linkColor === linkColors.dark\"\n    class=\"ds-link\"\n    (click)=\"onLinkTriggered($event)\"\n    (keydown.enter)=\"onLinkTriggered($event)\"\n    [attr.aria-current]=\"ariaCurrent\"\n    [attr.aria-label]=\"ariaLabel\"\n  >\n    <ng-container *ngTemplateOutlet=\"linkContent\"></ng-container>\n  </a>\n</ng-container>\n", dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "directive", type: i1.NgSwitch, selector: "[ngSwitch]", inputs: ["ngSwitch"] }, { kind: "directive", type: i1.NgSwitchCase, selector: "[ngSwitchCase]", inputs: ["ngSwitchCase"] }, { kind: "directive", type: i1.NgSwitchDefault, selector: "[ngSwitchDefault]" }, { kind: "directive", type: i2$1.RouterLink, selector: "[routerLink]", inputs: ["target", "queryParams", "fragment", "queryParamsHandling", "state", "info", "relativeTo", "preserveFragment", "skipLocationChange", "replaceUrl", "routerLink"] }, { kind: "component", type: DsIconComponent, selector: "ds-icon", inputs: ["icon", "iconStyle", "scale", "fixedWidth", "secondaryColor", "title"] }, { kind: "directive", type: DsTooltipDirective, selector: "[ds-tooltip]", inputs: ["ds-tooltip", "tooltipPlacement"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsLinkComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ds-link', template: "<ng-template #linkContent>\n  <ds-icon\n    *ngIf=\"icon\"\n    [icon]=\"icon\"\n    class=\"ds-link-icon\"\n    [iconStyle]=\"iconStyle\"\n    [title]=\"iconTitle\"\n    [class.ds-link-icon-with-label]=\"labelText.length > 0\"\n  ></ds-icon>\n  <ng-content></ng-content>\n  <ds-icon *ngIf=\"external\" [icon]=\"externalLinkIcon\" class=\"ds-link-external-icon\" aria-label=\"opens in new tab\"></ds-icon>\n</ng-template>\n\n<ng-container [ngSwitch]=\"linkType\">\n  <a\n    *ngSwitchCase=\"LinkType.RouterLink\"\n    [ds-tooltip]=\"tooltip\"\n    [tooltipPlacement]=\"tooltipPlacement\"\n    (focus)=\"onFocus()\"\n    (blur)=\"onBlur()\"\n    [href]=\"href\"\n    [routerLink]=\"rtLink\"\n    [fragment]=\"fragment\"\n    [queryParams]=\"queryParams\"\n    [queryParamsHandling]=\"queryParamsHandling\"\n    [class.external-link]=\"external\"\n    [class.standalone]=\"standalone\"\n    [class.inline]=\"!standalone\"\n    [class.ds-skip-link]=\"skip\"\n    [class.link-black-color-variant]=\"linkColor === linkColors.black\"\n    [class.link-white-color-variant]=\"linkColor === linkColors.white\"\n    [class.link-dark-color-variant]=\"linkColor === linkColors.dark\"\n    [attr.target]=\"target\"\n    [attr.role]=\"role\"\n    [attr.aria-current]=\"ariaCurrent\"\n    [attr.aria-label]=\"ariaLabel\"\n    [tabindex]=\"tabindex\"\n    (click)=\"onLinkTriggered($event)\"\n    (keydown.enter)=\"onLinkTriggered($event)\"\n    class=\"ds-link\"\n  >\n    <ng-container *ngTemplateOutlet=\"linkContent\"></ng-container>\n  </a>\n\n  <a\n    *ngSwitchCase=\"LinkType.Disabled\"\n    class=\"disabled-link ds-link\"\n    [ds-tooltip]=\"tooltip\"\n    [tooltipPlacement]=\"tooltipPlacement\"\n    [attr.role]=\"role\"\n    [tabindex]=\"tabindex\"\n    [class.external-link]=\"external\"\n    [class.standalone]=\"standalone\"\n    [class.inline]=\"!standalone\"\n    [class.link-black-color-variant]=\"linkColor === linkColors.black\"\n    [class.link-white-color-variant]=\"linkColor === linkColors.white\"\n    [class.link-dark-color-variant]=\"linkColor === linkColors.dark\"\n    href=\"#\"\n    (click)=\"onLinkTriggered($event)\"\n    (keydown.enter)=\"onLinkTriggered($event)\"\n  >\n    <ng-container *ngTemplateOutlet=\"linkContent\"></ng-container>\n  </a>\n\n  <a\n    *ngSwitchDefault\n    (focus)=\"onFocus()\"\n    (blur)=\"onBlur()\"\n    [href]=\"href\"\n    [ds-tooltip]=\"tooltip\"\n    [tabindex]=\"tabindex\"\n    [tooltipPlacement]=\"tooltipPlacement\"\n    [class.external-link]=\"external\"\n    [class.standalone]=\"standalone\"\n    [class.inline]=\"!standalone\"\n    [class.ds-skip-link]=\"skip\"\n    [attr.target]=\"target\"\n    [attr.role]=\"role\"\n    [class.link-black-color-variant]=\"linkColor === linkColors.black\"\n    [class.link-white-color-variant]=\"linkColor === linkColors.white\"\n    [class.link-dark-color-variant]=\"linkColor === linkColors.dark\"\n    class=\"ds-link\"\n    (click)=\"onLinkTriggered($event)\"\n    (keydown.enter)=\"onLinkTriggered($event)\"\n    [attr.aria-current]=\"ariaCurrent\"\n    [attr.aria-label]=\"ariaLabel\"\n  >\n    <ng-container *ngTemplateOutlet=\"linkContent\"></ng-container>\n  </a>\n</ng-container>\n" }]
        }], ctorParameters: () => [{ type: i0.ElementRef }, { type: i0.ChangeDetectorRef }], propDecorators: { activated: [{
                type: Output
            }], href: [{
                type: Input
            }], rtLink: [{
                type: Input
            }], fragment: [{
                type: Input
            }], queryParams: [{
                type: Input
            }], queryParamsHandling: [{
                type: Input
            }], disabled: [{
                type: Input
            }], external: [{
                type: Input
            }], standalone: [{
                type: Input
            }], skip: [{
                type: Input
            }], role: [{
                type: Input
            }], tabindex: [{
                type: Input
            }], icon: [{
                type: Input
            }], iconTitle: [{
                type: Input
            }], tooltipPlacement: [{
                type: Input
            }], linkColor: [{
                type: Input
            }], ariaCurrent: [{
                type: Input
            }], ariaLabel: [{
                type: Input
            }], tooltip: [{
                type: Input
            }], onMouseEnter: [{
                type: HostListener,
                args: ['mouseenter']
            }], onMouseLeave: [{
                type: HostListener,
                args: ['mouseleave']
            }], onFocus: [{
                type: HostListener,
                args: ['focus']
            }], onBlur: [{
                type: HostListener,
                args: ['blur']
            }] } });

const defaultMaxWidthPercentage = 80;
class DsModalSlideOutFooterDirective {
    constructor(templateRef) {
        this.templateRef = templateRef;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsModalSlideOutFooterDirective, deps: [{ token: i0.TemplateRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.5", type: DsModalSlideOutFooterDirective, selector: "[ds-modal-slide-out-footer]", ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsModalSlideOutFooterDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[ds-modal-slide-out-footer]',
                }]
        }], ctorParameters: () => [{ type: i0.TemplateRef }] });
class DsModalComponent {
    get class() {
        let modalClass = '';
        switch (this.colorVariant) {
            case DsModalColorVariant.DarkBlue: {
                modalClass += 'ds-modal-dark-blue-color-variant';
                break;
            }
            case DsModalColorVariant.LightBlue: {
                modalClass += 'ds-modal-light-blue-color-variant';
                break;
            }
            default: {
                break;
            }
        }
        return modalClass;
    }
    set backNavLabel(value) {
        if (this.modalService.hasPreviousModal()) {
            this._backNavLabel = value;
        }
    }
    get backNavLabel() {
        return this._backNavLabel;
    }
    set maxWidthPercentage(value) {
        this._maxWidthPercentage = value;
        this.setMaxWidthPercentage(value);
    }
    get maxWidthPercentage() {
        return this._maxWidthPercentage;
    }
    constructor(modalService, elementRef) {
        this.modalService = modalService;
        this.elementRef = elementRef;
        this._ngbModalTagNames = ['ngb-modal-window', 'ngb-offcanvas-panel'];
        this._modalId = DomUtility.createUniqueDOMId();
        this._maxWidthPercentage = defaultMaxWidthPercentage;
        this.back = new EventEmitter();
        this.modalClosed = new EventEmitter();
        this.DsButtonVariants = DsButtonVariants;
        this.Icons = Icons;
        this.DsModalColorVariant = DsModalColorVariant;
    }
    get titleId() {
        return `${this._modalId}_title`;
    }
    get contentId() {
        return `${this._modalId}_content`;
    }
    get closeButtonId() {
        return `${this._modalId}_close_button`;
    }
    get closeButtonAriaLabel() {
        return !this.modalService.hasPreviousModal() ? `Close ${this.title ?? ''}`.trim() : 'Close all open dialogs';
    }
    _findParentModalElement(element) {
        let parentElement = element;
        while (parentElement) {
            if (this._ngbModalTagNames.includes(parentElement.tagName.toLowerCase())) {
                return parentElement;
            }
            parentElement = parentElement.parentElement;
        }
        return null;
    }
    onBack() {
        this.modalService.previousModal();
        this.back.emit();
    }
    onClose() {
        this.modalService.closeAllModals();
        this.modalClosed.emit();
    }
    get buttonColorVariant() {
        if (this.colorVariant === DsModalColorVariant.DarkBlue) {
            return DsButtonColor.White;
        }
        return DsButtonColor.Default;
    }
    get headerIconStyle() {
        return IconStyles.Regular;
    }
    ngOnInit() {
        const modalOuterElement = this._findParentModalElement(this.elementRef.nativeElement);
        if (CommonUtility.notNullish(modalOuterElement)) {
            modalOuterElement.setAttribute('aria-labelledby', this.titleId);
            const dialogDiv = modalOuterElement.querySelector('div.modal-dialog');
            // Removing role="document" from .modal-dialog prevents double announcements by screen readers
            if (dialogDiv && dialogDiv.getAttribute('role') === 'document' && modalOuterElement.getAttribute('role') === 'dialog') {
                dialogDiv.removeAttribute('role');
            }
        }
    }
    ngOnChanges(changes) {
        if (changes.maxWidthPercentage) {
            this.setMaxWidthPercentage(changes.maxWidthPercentage.currentValue);
        }
    }
    setMaxWidthPercentage(widthPercentage) {
        const outerEl = this._findParentModalElement(this.elementRef.nativeElement);
        if (CommonUtility.notNullish(outerEl) && outerEl.classList.contains('offcanvas')) {
            setWidth(outerEl, widthPercentage);
        }
        else if (CommonUtility.notNullish(outerEl)) {
            const dialogDiv = outerEl.querySelector('.modal-window .modal-dialog');
            if (CommonUtility.notNullish(dialogDiv)) {
                setWidth(dialogDiv, widthPercentage);
            }
        }
        function setWidth(dialogDiv, percentage) {
            if (!percentage) {
                dialogDiv.style.maxWidth = `${defaultMaxWidthPercentage}%`;
                dialogDiv.style.width = 'unset';
            }
            else {
                dialogDiv.style.maxWidth = `${percentage}%`;
                dialogDiv.style.width = 'fit-content';
            }
        }
    }
    get isOffcanvas() {
        return this.modal instanceof NgbActiveOffcanvas;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsModalComponent, deps: [{ token: DsModalService }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.5", type: DsModalComponent, selector: "ds-modal", inputs: { modal: "modal", backNavLabel: "backNavLabel", maxWidthPercentage: "maxWidthPercentage", title: "title", colorVariant: "colorVariant", headerIcon: "headerIcon" }, outputs: { back: "back", modalClosed: "modalClosed" }, host: { listeners: { "document:keydown.escape": "onClose()" }, properties: { "class": "this.class" } }, queries: [{ propertyName: "footerContent", first: true, predicate: DsModalSlideOutFooterDirective, descendants: true }], usesOnChanges: true, ngImport: i0, template: "<div class=\"modal-header ds-modal-inline-title-header\" role=\"region\" aria-label=\"Dialog header\">\n  <h2 class=\"modal-title\" [id]=\"titleId\">\n    <ds-icon *ngIf=\"headerIcon\" [iconStyle]=\"headerIconStyle\" [icon]=\"headerIcon\" class=\"modal-title-icon\"></ds-icon>\n    {{ title }}\n  </h2>\n  <button\n    ds-button\n    [variant]=\"DsButtonVariants.microActionHorizontalLayout\"\n    [microActionIcon]=\"Icons.XMark\"\n    data-test-id=\"ds-modal-close-button\"\n    [id]=\"closeButtonId\"\n    [color]=\"buttonColorVariant\"\n    [attr.aria-label]=\"closeButtonAriaLabel\"\n    (click)=\"onClose()\"\n  >\n    Close\n  </button>\n</div>\n<div class=\"modal-body\" role=\"region\" aria-label=\"Dialog body\" [attr.tabindex]=\"isOffcanvas ? 0 : null\">\n  <div *ngIf=\"backNavLabel\" class=\"back-navigation inline-back-navigation\">\n    <button\n      ds-button\n      data-test-id=\"ds-modal-back-nav-button\"\n      [variant]=\"DsButtonVariants.microActionHorizontalLayout\"\n      [microActionIcon]=\"Icons.ChevronLeft\"\n      (click)=\"onBack()\"\n      [color]=\"buttonColorVariant\"\n    >\n      {{ backNavLabel }}\n    </button>\n  </div>\n  <div\n    class=\"modal-content\"\n    [id]=\"contentId\"\n    [class.ds-modal-content-dark-blue]=\"colorVariant === DsModalColorVariant.DarkBlue\"\n    [class.ds-modal-content-light-blue]=\"colorVariant === DsModalColorVariant.LightBlue\"\n  >\n    <ng-content></ng-content>\n  </div>\n</div>\n<div *ngIf=\"isOffcanvas && footerContent\" class=\"modal-footer\" role=\"region\" aria-label=\"Dialog footer\">\n  <ng-container [ngTemplateOutlet]=\"footerContent.templateRef\"></ng-container>\n</div>\n", dependencies: [{ kind: "component", type: DsButtonComponent, selector: "button[ds-button], a[ds-button]", inputs: ["visuallyHidden", "color", "variant", "withChevron", "microActionIcon", "hideMicroActionIcon", "disabledLink", "isExternalLink"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "component", type: DsIconComponent, selector: "ds-icon", inputs: ["icon", "iconStyle", "scale", "fixedWidth", "secondaryColor", "title"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsModalComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ds-modal', template: "<div class=\"modal-header ds-modal-inline-title-header\" role=\"region\" aria-label=\"Dialog header\">\n  <h2 class=\"modal-title\" [id]=\"titleId\">\n    <ds-icon *ngIf=\"headerIcon\" [iconStyle]=\"headerIconStyle\" [icon]=\"headerIcon\" class=\"modal-title-icon\"></ds-icon>\n    {{ title }}\n  </h2>\n  <button\n    ds-button\n    [variant]=\"DsButtonVariants.microActionHorizontalLayout\"\n    [microActionIcon]=\"Icons.XMark\"\n    data-test-id=\"ds-modal-close-button\"\n    [id]=\"closeButtonId\"\n    [color]=\"buttonColorVariant\"\n    [attr.aria-label]=\"closeButtonAriaLabel\"\n    (click)=\"onClose()\"\n  >\n    Close\n  </button>\n</div>\n<div class=\"modal-body\" role=\"region\" aria-label=\"Dialog body\" [attr.tabindex]=\"isOffcanvas ? 0 : null\">\n  <div *ngIf=\"backNavLabel\" class=\"back-navigation inline-back-navigation\">\n    <button\n      ds-button\n      data-test-id=\"ds-modal-back-nav-button\"\n      [variant]=\"DsButtonVariants.microActionHorizontalLayout\"\n      [microActionIcon]=\"Icons.ChevronLeft\"\n      (click)=\"onBack()\"\n      [color]=\"buttonColorVariant\"\n    >\n      {{ backNavLabel }}\n    </button>\n  </div>\n  <div\n    class=\"modal-content\"\n    [id]=\"contentId\"\n    [class.ds-modal-content-dark-blue]=\"colorVariant === DsModalColorVariant.DarkBlue\"\n    [class.ds-modal-content-light-blue]=\"colorVariant === DsModalColorVariant.LightBlue\"\n  >\n    <ng-content></ng-content>\n  </div>\n</div>\n<div *ngIf=\"isOffcanvas && footerContent\" class=\"modal-footer\" role=\"region\" aria-label=\"Dialog footer\">\n  <ng-container [ngTemplateOutlet]=\"footerContent.templateRef\"></ng-container>\n</div>\n" }]
        }], ctorParameters: () => [{ type: DsModalService }, { type: i0.ElementRef }], propDecorators: { class: [{
                type: HostBinding,
                args: ['class']
            }], modal: [{
                type: Input
            }], backNavLabel: [{
                type: Input
            }], maxWidthPercentage: [{
                type: Input
            }], title: [{
                type: Input
            }], colorVariant: [{
                type: Input
            }], headerIcon: [{
                type: Input
            }], back: [{
                type: Output
            }], modalClosed: [{
                type: Output
            }], footerContent: [{
                type: ContentChild,
                args: [DsModalSlideOutFooterDirective]
            }], onClose: [{
                type: HostListener,
                args: ['document:keydown.escape']
            }] } });

class DsDropdownComponent {
    constructor(elementRef, messageBusService, modalService) {
        this.elementRef = elementRef;
        this.messageBusService = messageBusService;
        this.modalService = modalService;
        this.dropdownId = DomUtility.createUniqueDOMId('dropdown');
        this.DsButtonVariants = DsButtonVariants;
        this.skipShowingTooltip = false;
        this.shouldDisplayModalSubscription = new Subscription();
    }
    get toggleComponentAriaLabelledBy() {
        if (CommonUtility.notNullishOrEmpty(this.toggleComponent.ariaLabelledBy)) {
            return this.dropdownId + '-toggle ' + this.toggleComponent.ariaLabelledBy;
        }
        return this.dropdownId + '-toggle';
    }
    /**
     * Replaces ng-bootstrap dropdown default css classes with design system classes to avoid CSS conflicts
     *
     * @private
     */
    replaceBootstrapClasses() {
        this.dropdownToggleBtn.elRef.nativeElement.classList.remove('dropdown-toggle');
        this.dropdownToggleBtn.elRef.nativeElement.classList.add('ds-dropdown-toggle');
        this.ngbDropdownMenu?.nativeElement.classList.remove('dropdown-menu');
        this.ngbDropdownMenu?.nativeElement.classList.add('ds-dropdown-menu');
        this.ngbDropdownItems.forEach((item) => {
            item.nativeElement.classList.remove('dropdown-item');
            item.nativeElement.classList.add('ds-dropdown-item');
        });
    }
    /**
     * Elements within a dropdown widget are not navigable by Tabs.
     * Navigation is by arrow keys and ng-boostrap handles that
     *
     * @private
     */
    makeMenuItemsNotTabbable() {
        this.ngbDropdownItems.forEach((item) => {
            if (!this.shouldDisplayModal) {
                item.nativeElement.tabIndex = -1;
            }
            item.nativeElement.querySelectorAll('a').forEach((element) => {
                element.tabIndex = -1;
            });
        });
    }
    /**
     * Checks all menu items to find the one with a value that matches the value provided as a parameter and assigns its index to selectedMenuItemIndex
     *
     * @param value Value of the menu item to be selected
     * @private
     */
    selectedMenuItemByValue(value) {
        const selectedIndex = Array.from(this.menuComponent?.items ?? []).findIndex((menuItem) => CommonUtility.notNullishOrEmpty(menuItem.value) && menuItem.value === value);
        this.selectedMenuItemIndex = selectedIndex > -1 ? selectedIndex : undefined;
    }
    get hasSelectedMenuItemIndex() {
        return this.selectedMenuItemIndex >= 0;
    }
    isMenuItemChecked(index) {
        return this.hasSelectedMenuItemIndex ? this.selectedMenuItemIndex === index : false;
    }
    /**
     * Since the dropdown toggle button is an interactive child element it will receive
     * the focus instead of the host element (`ds-dropdown`). This is a problem because
     * `ds-tooltip` directive is applied to the host element, and it listens for "focus"
     * event on the host element to show the tooltip. But since the focus lands on the
     * child dropdown toggle button the tooltip will not show up.
     *
     * This method is used to fire "focus" event on the host element (`ds-dropdown`)
     * when focus lands on the child dropdown toggle button to show the tooltip.
     *
     * See {@link DsTooltipDirective#onActive} for more details.
     */
    onDropdownToggleButtonFocused() {
        // we need tooltips only for the toggle buttons without labels specified for now
        // this might change in the future
        if (CommonUtility.isNullishOrEmpty(this.toggleComponent?.label) && !this.skipShowingTooltip) {
            this.elementRef.nativeElement.dispatchEvent(new Event('focus'));
        }
        this.skipShowingTooltip = false;
    }
    ngAfterViewInit() {
        this.replaceBootstrapClasses();
        this.makeMenuItemsNotTabbable();
    }
    ngOnInit() {
        this.shouldDisplayModalSubscription.add(DomUtility.observeBreakpoint(DsBreakpoints.Small).subscribe((value) => {
            this.shouldDisplayModal = value;
        }));
    }
    ngOnDestroy() {
        this.shouldDisplayModalSubscription.unsubscribe();
    }
    ngAfterContentInit() {
        this.selectedMenuItemByValue(this.selectedValue);
    }
    ngOnChanges(changes) {
        if (CommonUtility.notNullish(changes.selectedValue)) {
            this.selectedMenuItemByValue(changes.selectedValue.currentValue);
        }
    }
    onMenuItemSelected(index) {
        this.selectedMenuItemIndex = index;
        this.menuComponent.items.get(index).select();
        this.dropdownToggleBtn.elRef.nativeElement.focus();
        this.modalRef?.close();
        if (this.ngbDropdown.isOpen()) {
            this.ngbDropdown.toggle();
        }
    }
    onDropdownOpenChange(isOpen) {
        if (isOpen) {
            if (this.shouldDisplayModal) {
                this.modalRef = this.modalService.open(this.modalContent, DsModalVariant.fullScreen);
            }
            this.messageBusService.to(MessageBusChannels.dsTooltipHide, '');
            this.skipShowingTooltip = true;
        }
        setTimeout(() => {
            if (isOpen) {
                this.ngbDropdownItems.get(this.selectedMenuItemIndex ?? 0)?.nativeElement.focus();
                this.replaceBootstrapClasses();
                this.makeMenuItemsNotTabbable();
            }
            // ds-button toggles its chevron only when its host is clicked. This line manually toggles it on external changes.
            if (this.dropdownToggleBtn.isChevronCollapsed === isOpen) {
                this.dropdownToggleBtn.toggleChevron();
            }
        }, 0);
    }
    /**
     * This method forwards the keydown.Enter and keydown.Space events from the ds-link to the actual anchor element.
     *
     * ds-link elements render a wrapper around the actual anchor element, it is different from how ds-button renders.
     * Because of that, when navigating by arrow (behaviour implemented by the ng-bootstrap directives) the element that receives
     * the focus is not the actual anchor element.
     *
     * @param event Keyboard event
     */
    onLinkKeydown(event) {
        event.preventDefault();
        const currentTarget = event.currentTarget;
        currentTarget.querySelector('a')?.click();
    }
    onTabKeyPressedInMenu(event) {
        event.preventDefault();
        this.ngbDropdown.close();
        this.dropdownToggleBtn.elRef.nativeElement.focus();
    }
    onCloseModal() {
        if (this.ngbDropdown.isOpen()) {
            this.ngbDropdown.toggle();
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsDropdownComponent, deps: [{ token: i0.ElementRef }, { token: MessageBusService }, { token: DsModalService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.5", type: DsDropdownComponent, selector: "ds-dropdown", inputs: { dropdownId: "dropdownId", selectedMenuItemIndex: "selectedMenuItemIndex", selectedValue: "selectedValue", modalTitle: "modalTitle" }, queries: [{ propertyName: "menuComponent", first: true, predicate: i0.forwardRef(() => DsDropdownMenuDirective), descendants: true }, { propertyName: "toggleComponent", first: true, predicate: i0.forwardRef(() => DsDropdownToggleComponent), descendants: true }], viewQueries: [{ propertyName: "ngbDropdown", first: true, predicate: NgbDropdown, descendants: true }, { propertyName: "dropdownToggleBtn", first: true, predicate: ["dropdownToggleBtn"], descendants: true }, { propertyName: "ngbDropdownMenu", first: true, predicate: NgbDropdownMenu, descendants: true }, { propertyName: "modalContent", first: true, predicate: ["modalContent"], descendants: true }, { propertyName: "ngbDropdownItems", predicate: NgbDropdownItem, descendants: true }], usesOnChanges: true, ngImport: i0, template: "<div ngbDropdown dropdownClass=\"ds-dropdown\" (openChange)=\"onDropdownOpenChange($event)\" [id]=\"dropdownId\">\n  <button\n    ds-button\n    [variant]=\"toggleComponent.variant\"\n    [microActionIcon]=\"toggleComponent.icon\"\n    [withChevron]=\"true\"\n    *ngIf=\"toggleComponent\"\n    ngbDropdownToggle\n    [id]=\"dropdownId + '-toggle'\"\n    [attr.aria-label]=\"toggleComponent.ariaLabel\"\n    [attr.aria-labelledby]=\"toggleComponentAriaLabelledBy\"\n    [attr.aria-controls]=\"dropdownId + '-menu'\"\n    aria-haspopup=\"menu\"\n    (focus)=\"onDropdownToggleButtonFocused()\"\n    #dropdownToggleBtn\n  >\n    {{ toggleComponent.label }}\n  </button>\n  <div\n    ngbDropdownMenu\n    [id]=\"dropdownId + '-menu'\"\n    [attr.aria-labelledby]=\"dropdownId + '-toggle'\"\n    role=\"menu list\"\n    [attr.aria-activedescendant]=\"hasSelectedMenuItemIndex ? dropdownId + '-menu-item-' + selectedMenuItemIndex : undefined\"\n    (keydown.tab)=\"onTabKeyPressedInMenu($event)\"\n    (keydown.shift.tab)=\"onTabKeyPressedInMenu($event)\"\n    [class.d-none]=\"shouldDisplayModal\"\n  >\n    <ng-template *ngIf=\"shouldDisplayModal; else menuItems\" #modalContent let-modal>\n      <ds-modal\n        class=\"ds-dropdown-modal\"\n        [modal]=\"modal\"\n        [title]=\"modalTitle ?? toggleComponent.label\"\n        (modalClosed)=\"onCloseModal()\"\n      >\n        <ng-container *ngTemplateOutlet=\"menuItems\"></ng-container>\n      </ds-modal>\n    </ng-template>\n    <ng-template #menuItems>\n      <ng-container *ngFor=\"let menuItem of menuComponent.items; let index = index\">\n        <ds-link\n          *ngIf=\"menuItem.isLink; else buttonMenuItem\"\n          standalone=\"true\"\n          [disabled]=\"menuItem.disabled\"\n          [href]=\"menuItem.isExternalLink ? menuItem.href : undefined\"\n          [rtLink]=\"menuItem.isExternalLink ? undefined : menuItem.href\"\n          [queryParams]=\"menuItem.isExternalLink ? undefined : menuItem.queryParams\"\n          [external]=\"menuItem.isExternalLink\"\n          [icon]=\"menuItem.icon\"\n          ngbDropdownItem\n          class=\"ds-link-menu-item\"\n          [attr.aria-checked]=\"isMenuItemChecked(index)\"\n          [attr.data-test-id]=\"menuItem.dataTestId\"\n          (activated)=\"onMenuItemSelected(index)\"\n          [role]=\"'link'\"\n          role=\"menuitemradio listitem\"\n          [id]=\"dropdownId + '-menu-item-' + index\"\n          tabindex=\"-1\"\n          (keydown.space)=\"onLinkKeydown($event)\"\n          (keydown.enter)=\"onLinkKeydown($event)\"\n        >\n          {{ menuItem.label }}\n        </ds-link>\n        <ng-template #buttonMenuItem>\n          <button\n            ds-button\n            [disabled]=\"menuItem.disabled\"\n            [variant]=\"shouldDisplayModal ? DsButtonVariants.microActionHorizontalLayout : DsButtonVariants.microAction\"\n            [microActionIcon]=\"menuItem.icon\"\n            [hideMicroActionIcon]=\"!menuItem.icon\"\n            ngbDropdownItem\n            [attr.aria-checked]=\"isMenuItemChecked(index)\"\n            [attr.data-test-id]=\"menuItem.dataTestId\"\n            [attr.aria-label]=\"menuItem.ariaLabel\"\n            (click)=\"onMenuItemSelected(index)\"\n            role=\"menuitemradio listitem\"\n            [id]=\"dropdownId + '-menu-item-' + index\"\n            tabindex=\"-1\"\n          >\n            {{ menuItem.label }}\n          </button>\n        </ng-template>\n      </ng-container>\n    </ng-template>\n  </div>\n</div>\n", dependencies: [{ kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "directive", type: i4.NgbDropdown, selector: "[ngbDropdown]", inputs: ["autoClose", "dropdownClass", "open", "placement", "popperOptions", "container", "display"], outputs: ["openChange"], exportAs: ["ngbDropdown"] }, { kind: "directive", type: i4.NgbDropdownToggle, selector: "[ngbDropdownToggle]" }, { kind: "directive", type: i4.NgbDropdownMenu, selector: "[ngbDropdownMenu]" }, { kind: "directive", type: i4.NgbDropdownItem, selector: "[ngbDropdownItem]", inputs: ["tabindex", "disabled"] }, { kind: "directive", type: i4.NgbDropdownButtonItem, selector: "button[ngbDropdownItem]" }, { kind: "component", type: DsButtonComponent, selector: "button[ds-button], a[ds-button]", inputs: ["visuallyHidden", "color", "variant", "withChevron", "microActionIcon", "hideMicroActionIcon", "disabledLink", "isExternalLink"] }, { kind: "component", type: DsLinkComponent, selector: "ds-link", inputs: ["href", "rtLink", "fragment", "queryParams", "queryParamsHandling", "disabled", "external", "standalone", "skip", "role", "tabindex", "icon", "iconTitle", "tooltipPlacement", "linkColor", "ariaCurrent", "ariaLabel", "tooltip"], outputs: ["activated"] }, { kind: "component", type: DsModalComponent, selector: "ds-modal", inputs: ["modal", "backNavLabel", "maxWidthPercentage", "title", "colorVariant", "headerIcon"], outputs: ["back", "modalClosed"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsDropdownComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ds-dropdown', template: "<div ngbDropdown dropdownClass=\"ds-dropdown\" (openChange)=\"onDropdownOpenChange($event)\" [id]=\"dropdownId\">\n  <button\n    ds-button\n    [variant]=\"toggleComponent.variant\"\n    [microActionIcon]=\"toggleComponent.icon\"\n    [withChevron]=\"true\"\n    *ngIf=\"toggleComponent\"\n    ngbDropdownToggle\n    [id]=\"dropdownId + '-toggle'\"\n    [attr.aria-label]=\"toggleComponent.ariaLabel\"\n    [attr.aria-labelledby]=\"toggleComponentAriaLabelledBy\"\n    [attr.aria-controls]=\"dropdownId + '-menu'\"\n    aria-haspopup=\"menu\"\n    (focus)=\"onDropdownToggleButtonFocused()\"\n    #dropdownToggleBtn\n  >\n    {{ toggleComponent.label }}\n  </button>\n  <div\n    ngbDropdownMenu\n    [id]=\"dropdownId + '-menu'\"\n    [attr.aria-labelledby]=\"dropdownId + '-toggle'\"\n    role=\"menu list\"\n    [attr.aria-activedescendant]=\"hasSelectedMenuItemIndex ? dropdownId + '-menu-item-' + selectedMenuItemIndex : undefined\"\n    (keydown.tab)=\"onTabKeyPressedInMenu($event)\"\n    (keydown.shift.tab)=\"onTabKeyPressedInMenu($event)\"\n    [class.d-none]=\"shouldDisplayModal\"\n  >\n    <ng-template *ngIf=\"shouldDisplayModal; else menuItems\" #modalContent let-modal>\n      <ds-modal\n        class=\"ds-dropdown-modal\"\n        [modal]=\"modal\"\n        [title]=\"modalTitle ?? toggleComponent.label\"\n        (modalClosed)=\"onCloseModal()\"\n      >\n        <ng-container *ngTemplateOutlet=\"menuItems\"></ng-container>\n      </ds-modal>\n    </ng-template>\n    <ng-template #menuItems>\n      <ng-container *ngFor=\"let menuItem of menuComponent.items; let index = index\">\n        <ds-link\n          *ngIf=\"menuItem.isLink; else buttonMenuItem\"\n          standalone=\"true\"\n          [disabled]=\"menuItem.disabled\"\n          [href]=\"menuItem.isExternalLink ? menuItem.href : undefined\"\n          [rtLink]=\"menuItem.isExternalLink ? undefined : menuItem.href\"\n          [queryParams]=\"menuItem.isExternalLink ? undefined : menuItem.queryParams\"\n          [external]=\"menuItem.isExternalLink\"\n          [icon]=\"menuItem.icon\"\n          ngbDropdownItem\n          class=\"ds-link-menu-item\"\n          [attr.aria-checked]=\"isMenuItemChecked(index)\"\n          [attr.data-test-id]=\"menuItem.dataTestId\"\n          (activated)=\"onMenuItemSelected(index)\"\n          [role]=\"'link'\"\n          role=\"menuitemradio listitem\"\n          [id]=\"dropdownId + '-menu-item-' + index\"\n          tabindex=\"-1\"\n          (keydown.space)=\"onLinkKeydown($event)\"\n          (keydown.enter)=\"onLinkKeydown($event)\"\n        >\n          {{ menuItem.label }}\n        </ds-link>\n        <ng-template #buttonMenuItem>\n          <button\n            ds-button\n            [disabled]=\"menuItem.disabled\"\n            [variant]=\"shouldDisplayModal ? DsButtonVariants.microActionHorizontalLayout : DsButtonVariants.microAction\"\n            [microActionIcon]=\"menuItem.icon\"\n            [hideMicroActionIcon]=\"!menuItem.icon\"\n            ngbDropdownItem\n            [attr.aria-checked]=\"isMenuItemChecked(index)\"\n            [attr.data-test-id]=\"menuItem.dataTestId\"\n            [attr.aria-label]=\"menuItem.ariaLabel\"\n            (click)=\"onMenuItemSelected(index)\"\n            role=\"menuitemradio listitem\"\n            [id]=\"dropdownId + '-menu-item-' + index\"\n            tabindex=\"-1\"\n          >\n            {{ menuItem.label }}\n          </button>\n        </ng-template>\n      </ng-container>\n    </ng-template>\n  </div>\n</div>\n" }]
        }], ctorParameters: () => [{ type: i0.ElementRef }, { type: MessageBusService }, { type: DsModalService }], propDecorators: { dropdownId: [{
                type: Input
            }], selectedMenuItemIndex: [{
                type: Input
            }], selectedValue: [{
                type: Input
            }], modalTitle: [{
                type: Input
            }], ngbDropdown: [{
                type: ViewChild,
                args: [NgbDropdown]
            }], dropdownToggleBtn: [{
                type: ViewChild,
                args: ['dropdownToggleBtn']
            }], ngbDropdownMenu: [{
                type: ViewChild,
                args: [NgbDropdownMenu]
            }], ngbDropdownItems: [{
                type: ViewChildren,
                args: [NgbDropdownItem]
            }], modalContent: [{
                type: ViewChild,
                args: ['modalContent']
            }], menuComponent: [{
                type: ContentChild,
                args: [forwardRef(() => DsDropdownMenuDirective)]
            }], toggleComponent: [{
                type: ContentChild,
                args: [forwardRef(() => DsDropdownToggleComponent)]
            }] } });
class DsDropdownToggleComponent {
    constructor(dsDropdown) {
        this.dsDropdown = dsDropdown;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsDropdownToggleComponent, deps: [{ token: forwardRef(() => DsDropdownComponent) }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.5", type: DsDropdownToggleComponent, selector: "ds-dropdown-toggle", inputs: { variant: "variant", icon: "icon", label: "label", ariaLabel: "ariaLabel", ariaLabelledBy: "ariaLabelledBy" }, ngImport: i0, template: '', isInline: true }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsDropdownToggleComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'ds-dropdown-toggle',
                    template: '',
                }]
        }], ctorParameters: () => [{ type: DsDropdownComponent, decorators: [{
                    type: Inject,
                    args: [forwardRef(() => DsDropdownComponent)]
                }] }], propDecorators: { variant: [{
                type: Input
            }], icon: [{
                type: Input
            }], label: [{
                type: Input
            }], ariaLabel: [{
                type: Input
            }], ariaLabelledBy: [{
                type: Input
            }] } });
class DsDropdownItemComponent {
    constructor(dsDropdown, elRef) {
        this.dsDropdown = dsDropdown;
        this.elRef = elRef;
        this.selected = new EventEmitter();
    }
    select() {
        this.selected.emit();
    }
    get isLink() {
        return CommonUtility.notNullishOrEmpty(this.href);
    }
    get dataTestId() {
        return this.elRef.nativeElement.getAttribute('data-test-id');
    }
    get ariaLabel() {
        return this.elRef.nativeElement.getAttribute('aria-label');
    }
    get isExternalLink() {
        return CommonUtility.notNullishOrEmpty(this.href) && CommonUtility.isValidUrl(this.href);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsDropdownItemComponent, deps: [{ token: forwardRef(() => DsDropdownComponent) }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.5", type: DsDropdownItemComponent, selector: "ds-dropdown-item", inputs: { label: "label", icon: "icon", href: "href", queryParams: "queryParams", value: "value", disabled: "disabled" }, outputs: { selected: "selected" }, ngImport: i0, template: '', isInline: true }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsDropdownItemComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'ds-dropdown-item',
                    template: '',
                }]
        }], ctorParameters: () => [{ type: DsDropdownComponent, decorators: [{
                    type: Inject,
                    args: [forwardRef(() => DsDropdownComponent)]
                }] }, { type: i0.ElementRef }], propDecorators: { label: [{
                type: Input
            }], icon: [{
                type: Input
            }], href: [{
                type: Input
            }], queryParams: [{
                type: Input
            }], value: [{
                type: Input
            }], disabled: [{
                type: Input
            }], selected: [{
                type: Output
            }] } });
class DsDropdownMenuDirective {
    constructor(dsDropdown) {
        this.dsDropdown = dsDropdown;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsDropdownMenuDirective, deps: [{ token: forwardRef(() => DsDropdownComponent) }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.5", type: DsDropdownMenuDirective, selector: "[ds-dropdown-menu]", queries: [{ propertyName: "items", predicate: i0.forwardRef(() => DsDropdownItemComponent) }], ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsDropdownMenuDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[ds-dropdown-menu]',
                }]
        }], ctorParameters: () => [{ type: DsDropdownComponent, decorators: [{
                    type: Inject,
                    args: [forwardRef(() => DsDropdownComponent)]
                }] }], propDecorators: { items: [{
                type: ContentChildren,
                args: [forwardRef(() => DsDropdownItemComponent)]
            }] } });

class DsTooltipModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsTooltipModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.5", ngImport: i0, type: DsTooltipModule, declarations: [DsTooltipComponent,
            DsTooltipDirective], imports: [CommonModule,
            RouterModule], exports: [DsTooltipComponent,
            DsTooltipDirective] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsTooltipModule, imports: [CommonModule,
            RouterModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsTooltipModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        DsTooltipComponent,
                        DsTooltipDirective,
                    ],
                    imports: [
                        CommonModule,
                        RouterModule,
                    ],
                    exports: [
                        DsTooltipComponent,
                        DsTooltipDirective,
                    ],
                }]
        }] });

class DsLinkModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsLinkModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.5", ngImport: i0, type: DsLinkModule, declarations: [DsLinkComponent], imports: [CommonModule,
            RouterModule,
            DsIconModule,
            DsTooltipModule], exports: [DsLinkComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsLinkModule, imports: [CommonModule,
            RouterModule,
            DsIconModule,
            DsTooltipModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsLinkModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        DsLinkComponent,
                    ],
                    imports: [
                        CommonModule,
                        RouterModule,
                        DsIconModule,
                        DsTooltipModule,
                    ],
                    exports: [
                        DsLinkComponent,
                    ],
                }]
        }] });

class DsModalModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsModalModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.5", ngImport: i0, type: DsModalModule, declarations: [DsModalComponent, DsModalSlideOutFooterDirective], imports: [NgbModule, NgbModalModule, NgbOffcanvasModule, DsButtonModule, CommonModule, DsIconModule], exports: [DsModalComponent, DsModalSlideOutFooterDirective] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsModalModule, imports: [NgbModule, NgbModalModule, NgbOffcanvasModule, DsButtonModule, CommonModule, DsIconModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsModalModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [DsModalComponent, DsModalSlideOutFooterDirective],
                    imports: [NgbModule, NgbModalModule, NgbOffcanvasModule, DsButtonModule, CommonModule, DsIconModule],
                    exports: [DsModalComponent, DsModalSlideOutFooterDirective],
                }]
        }] });

class DsDropdownModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsDropdownModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.5", ngImport: i0, type: DsDropdownModule, declarations: [DsDropdownComponent, DsDropdownToggleComponent, DsDropdownItemComponent, DsDropdownMenuDirective], imports: [CommonModule, NgbDropdownModule, DsIconModule, DsButtonModule, DsLinkModule, DsModalModule], exports: [DsDropdownComponent, DsDropdownToggleComponent, DsDropdownItemComponent, DsDropdownMenuDirective] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsDropdownModule, imports: [CommonModule, NgbDropdownModule, DsIconModule, DsButtonModule, DsLinkModule, DsModalModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsDropdownModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [DsDropdownComponent, DsDropdownToggleComponent, DsDropdownItemComponent, DsDropdownMenuDirective],
                    imports: [CommonModule, NgbDropdownModule, DsIconModule, DsButtonModule, DsLinkModule, DsModalModule],
                    exports: [DsDropdownComponent, DsDropdownToggleComponent, DsDropdownItemComponent, DsDropdownMenuDirective],
                }]
        }] });

class DsInputFieldDirective {
    constructor() {
        this.class = 'ds-input-content ds-override-focus-indicator';
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsInputFieldDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.5", type: DsInputFieldDirective, selector: "input[ds-input-field], textarea[ds-input-field], select[ds-input-field]", host: { properties: { "class": "this.class" } }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsInputFieldDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'input[ds-input-field], textarea[ds-input-field], select[ds-input-field]',
                }]
        }], propDecorators: { class: [{
                type: HostBinding,
                args: ['class']
            }] } });

const dsInputErrorBorderClassName = 'ds-input-error-border';
const dsInputInactiveClassName = 'ds-input-inactive';
const announcementDelayInMs = 300;
const nearMaxLimitPercentage = 0.1;
var DsInputStates;
(function (DsInputStates) {
    DsInputStates["active"] = "active";
    DsInputStates["inactive"] = "inactive";
    DsInputStates["nonEditable"] = "nonEditable";
    DsInputStates["inline"] = "inline";
    DsInputStates["inlineInactive"] = "inlineInactive";
})(DsInputStates || (DsInputStates = {}));
class DsInputComponent {
    static { this._nextUniqueId = 0; }
    set required(required) {
        this._required = required;
        this.handleRequiredAttribute();
    }
    get required() {
        return this._required;
    }
    set state(state) {
        this._state = state;
        this.setInputLength();
        this.handleInputState();
    }
    set errorState(errorState) {
        this._errorState = errorState;
        this.handleErrorBorder();
    }
    get errorState() {
        return this._errorState;
    }
    get isInactive() {
        return this._inactiveStates.includes(this._state);
    }
    get isNonEditable() {
        return this._state === DsInputStates.nonEditable;
    }
    get isInline() {
        return this._inlineStates.includes(this._state);
    }
    get length() {
        return this._length;
    }
    get errorIcon() {
        return Icons.CircleExclamation;
    }
    get errorIconStyle() {
        return IconStyles.Light;
    }
    constructor(changeDetectorRef, renderer) {
        this.changeDetectorRef = changeDetectorRef;
        this.renderer = renderer;
        this._state = DsInputStates.active;
        this._inlineStates = [DsInputStates.inline, DsInputStates.inlineInactive];
        this._inactiveStates = [DsInputStates.inactive, DsInputStates.inlineInactive];
        this.class = 'ds-input';
        this.id = `ds-input-${DsInputComponent._nextUniqueId++}`;
        this.showRequiredAsterisk = true;
        this.characterCountId = `ds-input-character-count-${DsInputComponent._nextUniqueId++}`;
        this.labelId = `ds-input-label-${DsInputComponent._nextUniqueId++}`;
        this.instructionsId = `ds-input-instructions-${DsInputComponent._nextUniqueId++}`;
        this.errorMessageId = `ds-input-error-message-${DsInputComponent._nextUniqueId++}`;
    }
    handleIdAttribute() {
        if (CommonUtility.notNullishOrEmpty(this.input.nativeElement.id)) {
            this.id = this.input.nativeElement.id;
            this.changeDetectorRef.detectChanges();
        }
        else {
            this.renderer.setAttribute(this.input.nativeElement, 'id', this.id);
        }
    }
    handleErrorBorder() {
        if (CommonUtility.notNullish(this.input)) {
            if (this._errorState) {
                this.renderer.addClass(this.input.nativeElement, dsInputErrorBorderClassName);
                this.renderer.setAttribute(this.input.nativeElement, 'aria-invalid', 'true');
                this.renderer.setAttribute(this.input.nativeElement, 'aria-errormessage', this.errorMessageId);
            }
            else {
                this.renderer.removeClass(this.input.nativeElement, dsInputErrorBorderClassName);
                this.renderer.setAttribute(this.input.nativeElement, 'aria-invalid', 'false');
                this.renderer.removeAttribute(this.input.nativeElement, 'aria-errormessage');
            }
            this.setAriaLabelledByAttribute();
        }
    }
    handleInputState() {
        if (CommonUtility.notNullish(this.input)) {
            if (this.isInactive) {
                this.renderer.addClass(this.input.nativeElement, dsInputInactiveClassName);
                this.renderer.setAttribute(this.input.nativeElement, 'disabled', '');
            }
            else {
                this.renderer.removeClass(this.input.nativeElement, dsInputInactiveClassName);
                this.renderer.removeAttribute(this.input.nativeElement, 'disabled');
            }
        }
    }
    handleRequiredAttribute() {
        if (CommonUtility.notNullish(this.input?.nativeElement) && CommonUtility.notNullish(this.renderer)) {
            if (CommonUtility.isNullish(this.required)) {
                const elementIsRequired = this.input.nativeElement.hasAttribute('required') || this.input.nativeElement.getAttribute('aria-required') === 'true';
                this._required = elementIsRequired;
                this.changeDetectorRef.detectChanges();
            }
            if (this.required) {
                this.renderer.setAttribute(this.input.nativeElement, 'aria-required', 'true');
            }
            else {
                this.renderer.removeAttribute(this.input.nativeElement, 'aria-required');
            }
        }
    }
    setAriaLabelledByAttribute() {
        let attrValue = this.labelId;
        if (this.displayCharacterCount) {
            attrValue += ` ${this.characterCountId}`;
        }
        if (this.errorState) {
            attrValue += ` ${this.errorMessageId}`;
        }
        this.renderer.setAttribute(this.input.nativeElement, 'aria-labelledby', attrValue);
    }
    setDescribedByAttribute() {
        if (this.displayInstructions) {
            this.renderer.setAttribute(this.input.nativeElement, 'aria-describedby', `${this.instructionsId}`);
        }
    }
    handleCharacterCountLiveRegion() {
        const nearMaxLimit = this.maxLength - this.maxLength * nearMaxLimitPercentage;
        if (this.length >= nearMaxLimit) {
            this._characterCountToAnnounce = `${this.length}/${this.maxLength}`;
        }
    }
    setInputLength() {
        if (CommonUtility.notNullish(this.input)) {
            this._length = this.input.nativeElement.value.length;
        }
    }
    onInputChanged(event) {
        const inputElement = event.target;
        setTimeout(() => {
            this._length = inputElement.value.length;
            this.handleCharacterCountLiveRegion();
            this.changeDetectorRef.detectChanges();
        }, announcementDelayInMs);
    }
    get maxLength() {
        return CommonUtility.notNullish(this.input) ? this.input.nativeElement.maxLength : -1;
    }
    get characterCountToAnnounce() {
        return this._characterCountToAnnounce;
    }
    get inputText() {
        return CommonUtility.notNullish(this.input) ? this.input.nativeElement.value : '';
    }
    get displayInstructions() {
        const hasInstructions = CommonUtility.notNullish(this.instructions?.trim()) && this.instructions.length > 0;
        return hasInstructions && !this.isInline;
    }
    get displayCharacterCount() {
        return this.maxLength > 0;
    }
    triggerHandlers() {
        this.handleInputState();
        this.handleErrorBorder();
        this.handleIdAttribute();
        this.handleRequiredAttribute();
    }
    ngAfterViewInit() {
        this.setInputLength();
        this.setAriaLabelledByAttribute();
        this.setDescribedByAttribute();
        this.triggerHandlers();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsInputComponent, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.Renderer2 }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.5", type: DsInputComponent, selector: "ds-input", inputs: { id: "id", label: "label", instructions: "instructions", errorMessage: "errorMessage", inactiveInfoMessage: "inactiveInfoMessage", showRequiredAsterisk: "showRequiredAsterisk", required: "required", state: "state", errorState: "errorState" }, host: { properties: { "class": "this.class" } }, queries: [{ propertyName: "input", first: true, predicate: DsInputFieldDirective, descendants: true, read: ElementRef }], ngImport: i0, template: "<ng-container>\n  <ng-container *ngIf=\"displayInstructions\">\n    <ng-template [ngTemplateOutlet]=\"inputLabel\"></ng-template>\n  </ng-container>\n  <div class=\"ds-input-row\">\n    <ng-container *ngIf=\"!displayInstructions\">\n      <ng-template [ngTemplateOutlet]=\"inputLabel\"></ng-template>\n    </ng-container>\n    <span\n      *ngIf=\"displayInstructions\"\n      [id]=\"instructionsId\"\n      class=\"ds-input-instructions\"\n      [ngClass]=\"{ 'ds-input-inactive': isInactive }\"\n    >\n      {{ instructions }}\n    </span>\n    <span\n      *ngIf=\"this.displayCharacterCount\"\n      [id]=\"characterCountId\"\n      class=\"ds-input-character-count\"\n      [ngClass]=\"{ 'ds-input-inactive': isInactive }\"\n    >\n      {{ length }}/{{ maxLength }}\n    </span>\n    <ng-container *ngIf=\"isInline\">\n      <ng-template [ngTemplateOutlet]=\"input\"></ng-template>\n    </ng-container>\n  </div>\n  <ng-container *ngIf=\"!isInline\">\n    <ng-template [ngTemplateOutlet]=\"input\"></ng-template>\n  </ng-container>\n  <span *ngIf=\"this.displayCharacterCount\" class=\"ds-visually-hidden\" aria-live=\"polite\">{{ characterCountToAnnounce }}</span>\n  <!-- TODO EAP-17082 - Update to use error message component -->\n  <div *ngIf=\"errorState\" class=\"ds-input-error-message\" [id]=\"errorMessageId\">\n    <ds-icon [iconStyle]=\"errorIconStyle\" [icon]=\"errorIcon\" aria-label=\"error\"></ds-icon>\n    {{ errorMessage }}\n  </div>\n  <div *ngIf=\"isInactive && inactiveInfoMessage\">\n    <span class=\"ds-input-non-editable-info\">{{ inactiveInfoMessage }}</span>\n  </div>\n</ng-container>\n\n<ng-template #inputLabel>\n  <label\n    [id]=\"labelId\"\n    class=\"ds-input-label\"\n    [ngClass]=\"{ 'ds-input-inactive': isInactive, 'no-instructions': !displayInstructions, inline: isInline }\"\n    [for]=\"id\"\n  >\n    {{ label }}<span *ngIf=\"required && showRequiredAsterisk\" class=\"ds-input-required\" aria-hidden=\"true\">*</span>\n  </label>\n</ng-template>\n\n<ng-template #input>\n  <div class=\"ds-input-content-container\" (input)=\"onInputChanged($event)\">\n    <ng-container *ngIf=\"isNonEditable; else isEditable\">\n      <span class=\"ds-input-non-editable-text\">{{ inputText }}</span>\n    </ng-container>\n    <ng-template #isEditable>\n      <ng-content></ng-content>\n    </ng-template>\n  </div>\n</ng-template>\n", dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "component", type: DsIconComponent, selector: "ds-icon", inputs: ["icon", "iconStyle", "scale", "fixedWidth", "secondaryColor", "title"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsInputComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ds-input', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-container>\n  <ng-container *ngIf=\"displayInstructions\">\n    <ng-template [ngTemplateOutlet]=\"inputLabel\"></ng-template>\n  </ng-container>\n  <div class=\"ds-input-row\">\n    <ng-container *ngIf=\"!displayInstructions\">\n      <ng-template [ngTemplateOutlet]=\"inputLabel\"></ng-template>\n    </ng-container>\n    <span\n      *ngIf=\"displayInstructions\"\n      [id]=\"instructionsId\"\n      class=\"ds-input-instructions\"\n      [ngClass]=\"{ 'ds-input-inactive': isInactive }\"\n    >\n      {{ instructions }}\n    </span>\n    <span\n      *ngIf=\"this.displayCharacterCount\"\n      [id]=\"characterCountId\"\n      class=\"ds-input-character-count\"\n      [ngClass]=\"{ 'ds-input-inactive': isInactive }\"\n    >\n      {{ length }}/{{ maxLength }}\n    </span>\n    <ng-container *ngIf=\"isInline\">\n      <ng-template [ngTemplateOutlet]=\"input\"></ng-template>\n    </ng-container>\n  </div>\n  <ng-container *ngIf=\"!isInline\">\n    <ng-template [ngTemplateOutlet]=\"input\"></ng-template>\n  </ng-container>\n  <span *ngIf=\"this.displayCharacterCount\" class=\"ds-visually-hidden\" aria-live=\"polite\">{{ characterCountToAnnounce }}</span>\n  <!-- TODO EAP-17082 - Update to use error message component -->\n  <div *ngIf=\"errorState\" class=\"ds-input-error-message\" [id]=\"errorMessageId\">\n    <ds-icon [iconStyle]=\"errorIconStyle\" [icon]=\"errorIcon\" aria-label=\"error\"></ds-icon>\n    {{ errorMessage }}\n  </div>\n  <div *ngIf=\"isInactive && inactiveInfoMessage\">\n    <span class=\"ds-input-non-editable-info\">{{ inactiveInfoMessage }}</span>\n  </div>\n</ng-container>\n\n<ng-template #inputLabel>\n  <label\n    [id]=\"labelId\"\n    class=\"ds-input-label\"\n    [ngClass]=\"{ 'ds-input-inactive': isInactive, 'no-instructions': !displayInstructions, inline: isInline }\"\n    [for]=\"id\"\n  >\n    {{ label }}<span *ngIf=\"required && showRequiredAsterisk\" class=\"ds-input-required\" aria-hidden=\"true\">*</span>\n  </label>\n</ng-template>\n\n<ng-template #input>\n  <div class=\"ds-input-content-container\" (input)=\"onInputChanged($event)\">\n    <ng-container *ngIf=\"isNonEditable; else isEditable\">\n      <span class=\"ds-input-non-editable-text\">{{ inputText }}</span>\n    </ng-container>\n    <ng-template #isEditable>\n      <ng-content></ng-content>\n    </ng-template>\n  </div>\n</ng-template>\n" }]
        }], ctorParameters: () => [{ type: i0.ChangeDetectorRef }, { type: i0.Renderer2 }], propDecorators: { class: [{
                type: HostBinding,
                args: ['class']
            }], input: [{
                type: ContentChild,
                args: [DsInputFieldDirective, { read: ElementRef }]
            }], id: [{
                type: Input
            }], label: [{
                type: Input
            }], instructions: [{
                type: Input
            }], errorMessage: [{
                type: Input
            }], inactiveInfoMessage: [{
                type: Input
            }], showRequiredAsterisk: [{
                type: Input
            }], required: [{
                type: Input
            }], state: [{
                type: Input
            }], errorState: [{
                type: Input
            }] } });

class DsInputModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsInputModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.5", ngImport: i0, type: DsInputModule, declarations: [DsInputComponent,
            DsInputFieldDirective], imports: [CommonModule,
            DsIconModule], exports: [DsInputComponent,
            DsInputFieldDirective] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsInputModule, imports: [CommonModule,
            DsIconModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsInputModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        DsInputComponent,
                        DsInputFieldDirective,
                    ],
                    imports: [
                        CommonModule,
                        DsIconModule,
                    ],
                    exports: [
                        DsInputComponent,
                        DsInputFieldDirective,
                    ],
                }]
        }] });

class DsRadioComponent {
    static { this._nextUniqueId = 0; }
    constructor(_changeDetector) {
        this._changeDetector = _changeDetector;
        this._hasFocus = false;
        this._isHovering = false;
        this._isDisabled = false;
        this.id = `ds-radio-${DsRadioComponent._nextUniqueId++}`;
        this.name = '';
        this.value = '';
        this.checked = false;
        this.required = false;
        this.valueChange = new EventEmitter();
        this.class = 'ds-radio';
    }
    get disabled() {
        return this._isDisabled;
    }
    set disabled(disabled) {
        this._isDisabled = disabled;
    }
    get icon() {
        return this.checked ? Icons.CircleDot : Icons.Circle;
    }
    get iconStyle() {
        if (this._hasFocus || this._isHovering) {
            return IconStyles.Regular;
        }
        if (this.checked) {
            return IconStyles.Solid;
        }
        return IconStyles.Light;
    }
    markForCheck() {
        this._changeDetector.markForCheck();
    }
    onBlur() {
        this._hasFocus = false;
        this.markForCheck();
    }
    onFocus() {
        this._hasFocus = true;
        this.markForCheck();
    }
    onChange(event) {
        event.stopPropagation();
        if (this.disabled) {
            event.preventDefault();
            return;
        }
        this._inputElRef.nativeElement.focus();
        if (this.checked) {
            return;
        }
        this.checked = true;
        this.valueChange.emit(this.value);
        this.markForCheck();
    }
    onClick() {
        const event = new Event('change', { bubbles: false });
        this._inputElRef.nativeElement.dispatchEvent(event);
    }
    onMouseEnter() {
        if (this.disabled) {
            return;
        }
        this._isHovering = true;
        this.markForCheck();
    }
    onMouseLeave() {
        if (this.disabled) {
            return;
        }
        this._isHovering = false;
        this.markForCheck();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsRadioComponent, deps: [{ token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.5", type: DsRadioComponent, selector: "ds-radio", inputs: { id: "id", name: "name", value: "value", checked: "checked", required: "required", label: "label", ariaLabel: "ariaLabel", ariaLabelledBy: "ariaLabelledBy", instructions: "instructions", disabled: "disabled" }, outputs: { valueChange: "valueChange" }, host: { listeners: { "click": "onClick()", "mouseenter": "onMouseEnter()", "mouseleave": "onMouseLeave()" }, properties: { "class.ds-radio-focus": "this._hasFocus", "class.ds-radio-hover": "this._isHovering", "class.ds-radio-disabled": "this._isDisabled", "class": "this.class" } }, viewQueries: [{ propertyName: "_inputElRef", first: true, predicate: ["inputEl"], descendants: true }], ngImport: i0, template: "<ng-container>\n  <input\n    #inputEl\n    type=\"radio\"\n    [id]=\"id\"\n    [name]=\"name\"\n    [value]=\"value\"\n    [checked]=\"checked\"\n    [required]=\"required\"\n    [disabled]=\"disabled\"\n    [attr.aria-label]=\"ariaLabel\"\n    [attr.aria-labelledby]=\"ariaLabelledBy\"\n    (blur)=\"onBlur()\"\n    (focus)=\"onFocus()\"\n    (change)=\"onChange($event)\"\n  />\n  <label [for]=\"id\" id=\"label-{{ id }}\" class=\"ds-radio-label form-label\">\n    <ds-icon class=\"ds-radio-icon\" [icon]=\"icon\" [iconStyle]=\"iconStyle\"></ds-icon>\n    <div class=\"d-flex flex-column\">\n      <span>{{ label }}</span>\n      <span *ngIf=\"instructions\">{{ instructions }}</span>\n    </div>\n  </label>\n</ng-container>\n", dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: DsIconComponent, selector: "ds-icon", inputs: ["icon", "iconStyle", "scale", "fixedWidth", "secondaryColor", "title"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsRadioComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ds-radio', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-container>\n  <input\n    #inputEl\n    type=\"radio\"\n    [id]=\"id\"\n    [name]=\"name\"\n    [value]=\"value\"\n    [checked]=\"checked\"\n    [required]=\"required\"\n    [disabled]=\"disabled\"\n    [attr.aria-label]=\"ariaLabel\"\n    [attr.aria-labelledby]=\"ariaLabelledBy\"\n    (blur)=\"onBlur()\"\n    (focus)=\"onFocus()\"\n    (change)=\"onChange($event)\"\n  />\n  <label [for]=\"id\" id=\"label-{{ id }}\" class=\"ds-radio-label form-label\">\n    <ds-icon class=\"ds-radio-icon\" [icon]=\"icon\" [iconStyle]=\"iconStyle\"></ds-icon>\n    <div class=\"d-flex flex-column\">\n      <span>{{ label }}</span>\n      <span *ngIf=\"instructions\">{{ instructions }}</span>\n    </div>\n  </label>\n</ng-container>\n" }]
        }], ctorParameters: () => [{ type: i0.ChangeDetectorRef }], propDecorators: { _hasFocus: [{
                type: HostBinding,
                args: ['class.ds-radio-focus']
            }], _isHovering: [{
                type: HostBinding,
                args: ['class.ds-radio-hover']
            }], _isDisabled: [{
                type: HostBinding,
                args: ['class.ds-radio-disabled']
            }], _inputElRef: [{
                type: ViewChild,
                args: ['inputEl']
            }], id: [{
                type: Input
            }], name: [{
                type: Input
            }], value: [{
                type: Input
            }], checked: [{
                type: Input
            }], required: [{
                type: Input
            }], label: [{
                type: Input
            }], ariaLabel: [{
                type: Input
            }], ariaLabelledBy: [{
                type: Input
            }], instructions: [{
                type: Input
            }], valueChange: [{
                type: Output
            }], class: [{
                type: HostBinding,
                args: ['class']
            }], disabled: [{
                type: Input
            }], onClick: [{
                type: HostListener,
                args: ['click']
            }], onMouseEnter: [{
                type: HostListener,
                args: ['mouseenter']
            }], onMouseLeave: [{
                type: HostListener,
                args: ['mouseleave']
            }] } });

class DsRadioGroupComponent {
    constructor() {
        this._name = `ds-radio-group-${DsRadioGroupComponent._nextUniqueId++}`;
        this._registeredOnChange = () => { };
        this._registeredOnTouched = () => { };
        this._subscriptions = new Subscription();
        this.valueChange = new EventEmitter();
        this.class = 'ds-radio-group';
    }
    static { this._nextUniqueId = 0; }
    _isNullish(obj) {
        return typeof obj === 'undefined' || obj === null;
    }
    _isNullishOrEmpty(obj) {
        return this._isNullish(obj) || obj.length === 0;
    }
    _updateRadioNames(name) {
        if (this._isNullish(this._radios)) {
            return;
        }
        this._radios.forEach((radio) => {
            radio.name = name;
            radio.markForCheck();
        });
    }
    _updateRadioValues() {
        if (this._isNullish(this._radios)) {
            return;
        }
        this._radios.forEach((radio) => {
            radio.checked = radio.value === this._value;
            radio.markForCheck();
        });
    }
    _updateRadiosRequired(required) {
        if (this._isNullish(this._radios)) {
            return;
        }
        this._radios.forEach((radio) => {
            radio.required = required;
            radio.markForCheck();
        });
    }
    _onRadioChange(value) {
        if (this.value === value) {
            return;
        }
        this.value = value;
        this.valueChange.emit(value);
        this._registeredOnChange(value);
        this._registeredOnTouched();
    }
    get errorIcon() {
        return Icons.CircleExclamation;
    }
    get errorIconStyle() {
        return IconStyles.Light;
    }
    get name() {
        return this._name;
    }
    set name(name) {
        this._name = name;
        this._updateRadioNames(name);
    }
    get value() {
        return this._value;
    }
    set value(value) {
        this._value = value;
        this._updateRadioValues();
    }
    get required() {
        return this._required;
    }
    set required(required) {
        this._required = required;
        this._updateRadiosRequired(required);
    }
    get errorId() {
        return this._errorId;
    }
    get errorState() {
        return this._errorState;
    }
    set errorState(errorState) {
        this._errorState = errorState;
        this._errorId = errorState ? `ds-radio-group-error-${DsRadioGroupComponent._nextUniqueId++}` : undefined;
    }
    ngAfterContentInit() {
        if (this._isNullish(this._radios)) {
            return;
        }
        this._radios.forEach((radio) => {
            this._subscriptions.add(radio.valueChange.subscribe(this._onRadioChange.bind(this)));
        });
        if (this._isNullishOrEmpty(this._value)) {
            this._value = this._radios.get(0)?.value;
        }
        this._updateRadioValues();
        this._updateRadioNames(this._name);
        this._updateRadiosRequired(this._required);
    }
    ngOnDestroy() {
        this._subscriptions.unsubscribe();
    }
    registerOnChange(fn) {
        this._registeredOnChange = fn;
    }
    registerOnTouched(fn) {
        this._registeredOnTouched = fn;
    }
    writeValue(obj) {
        this.value = obj;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsRadioGroupComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.5", type: DsRadioGroupComponent, selector: "ds-radio-group", inputs: { label: "label", instructions: "instructions", errorMessage: "errorMessage", name: "name", value: "value", required: "required", errorState: "errorState" }, outputs: { valueChange: "valueChange" }, host: { properties: { "class": "this.class" } }, providers: [
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => DsRadioGroupComponent),
                multi: true,
            },
        ], queries: [{ propertyName: "_radios", predicate: i0.forwardRef(() => DsRadioComponent) }], ngImport: i0, template: "<fieldset [attr.aria-invalid]=\"errorState\" [attr.aria-describedby]=\"errorId\">\n  <legend>\n    {{ label }}\n    <span *ngIf=\"required\" aria-hidden=\"true\">*</span>\n  </legend>\n  <div class=\"ds-radio-group-instructions\" *ngIf=\"instructions\">\n    {{ instructions }}\n  </div>\n  <div class=\"ds-radio-group-items\" [ngClass]=\"{ error: errorState }\">\n    <ng-content></ng-content>\n  </div>\n  <div aria-live=\"polite\" role=\"status\">\n    <!-- TODO EAP-17082 - Update to use error message component -->\n    <div *ngIf=\"errorState\" [id]=\"errorId\" class=\"ds-radio-group-error-message\">\n      <ds-icon [iconStyle]=\"errorIconStyle\" [icon]=\"errorIcon\"></ds-icon>\n      <ng-container>{{ errorMessage }}</ng-container>\n    </div>\n  </div>\n</fieldset>\n", dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: DsIconComponent, selector: "ds-icon", inputs: ["icon", "iconStyle", "scale", "fixedWidth", "secondaryColor", "title"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsRadioGroupComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ds-radio-group', providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef(() => DsRadioGroupComponent),
                            multi: true,
                        },
                    ], template: "<fieldset [attr.aria-invalid]=\"errorState\" [attr.aria-describedby]=\"errorId\">\n  <legend>\n    {{ label }}\n    <span *ngIf=\"required\" aria-hidden=\"true\">*</span>\n  </legend>\n  <div class=\"ds-radio-group-instructions\" *ngIf=\"instructions\">\n    {{ instructions }}\n  </div>\n  <div class=\"ds-radio-group-items\" [ngClass]=\"{ error: errorState }\">\n    <ng-content></ng-content>\n  </div>\n  <div aria-live=\"polite\" role=\"status\">\n    <!-- TODO EAP-17082 - Update to use error message component -->\n    <div *ngIf=\"errorState\" [id]=\"errorId\" class=\"ds-radio-group-error-message\">\n      <ds-icon [iconStyle]=\"errorIconStyle\" [icon]=\"errorIcon\"></ds-icon>\n      <ng-container>{{ errorMessage }}</ng-container>\n    </div>\n  </div>\n</fieldset>\n" }]
        }], propDecorators: { _radios: [{
                type: ContentChildren,
                args: [forwardRef(() => DsRadioComponent)]
            }], label: [{
                type: Input
            }], instructions: [{
                type: Input
            }], errorMessage: [{
                type: Input
            }], valueChange: [{
                type: Output
            }], class: [{
                type: HostBinding,
                args: ['class']
            }], name: [{
                type: Input
            }], value: [{
                type: Input
            }], required: [{
                type: Input
            }], errorState: [{
                type: Input
            }] } });

class DsRadioModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsRadioModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.5", ngImport: i0, type: DsRadioModule, declarations: [DsRadioComponent,
            DsRadioGroupComponent], imports: [CommonModule,
            DsIconModule], exports: [DsRadioComponent,
            DsRadioGroupComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsRadioModule, imports: [CommonModule,
            DsIconModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsRadioModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        DsRadioComponent,
                        DsRadioGroupComponent,
                    ],
                    imports: [
                        CommonModule,
                        DsIconModule,
                    ],
                    exports: [
                        DsRadioComponent,
                        DsRadioGroupComponent,
                    ],
                }]
        }] });

class DsHeaderPrimaryActionDirective {
    constructor() {
        this.class = 'ds-btn ds-header-primary-action';
        this.dataTestId = 'ds-header-primary-action';
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsHeaderPrimaryActionDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.5", type: DsHeaderPrimaryActionDirective, selector: "[ds-header-primary-action]", host: { properties: { "class": "this.class", "attr.data-test-id": "this.dataTestId" } }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsHeaderPrimaryActionDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[ds-header-primary-action]',
                }]
        }], propDecorators: { class: [{
                type: HostBinding,
                args: ['class']
            }], dataTestId: [{
                type: HostBinding,
                args: ['attr.data-test-id']
            }] } });
class DsHeaderSecondaryMicroActionDirective {
    constructor() {
        this.class = 'ds-btn ds-btn-micro-action ds-header-secondary-micro-action';
        this.dataTestId = 'ds-header-secondary-micro-action';
        /** This is used determine if the micro action is for a close action **/
        this.close = false;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsHeaderSecondaryMicroActionDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.5", type: DsHeaderSecondaryMicroActionDirective, selector: "[ds-header-secondary-micro-action]", inputs: { close: "close" }, host: { properties: { "class": "this.class", "attr.data-test-id": "this.dataTestId" } }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsHeaderSecondaryMicroActionDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[ds-header-secondary-micro-action]',
                }]
        }], propDecorators: { class: [{
                type: HostBinding,
                args: ['class']
            }], dataTestId: [{
                type: HostBinding,
                args: ['attr.data-test-id']
            }], close: [{
                type: Input
            }] } });
class DsHeaderBarComponent {
    set title(title) {
        if (CommonUtility.isNullishOrEmpty(title)) {
            throw new Error('Title is a mandatory field.');
        }
        this._title = title;
    }
    constructor(changeDetector) {
        this.changeDetector = changeDetector;
        this.displayMicroActionButtons = true;
        this.displayPrimaryActionButtons = true;
        // close button is only applicable in a child context (i.e modal, slide-out, dropdowns) but not pages
        // TODO: EAP-16983 Revisit once we work on the slide out component
        this.displayCloseButton = false;
        this.buttonsInView = [];
        /** Header bar heading properties **/
        this.titleHeadingLevel = 'h1';
        /** Header bar badge properties **/
        this.badge = 'default';
        this.infoItems = [];
    }
    validateViewContent() {
        const primaryButtonsAllowedInView = 1;
        const secondaryButtonsAllowedInView = 2;
        this.buttonsInView = Array.from(this.actionButtons.nativeElement.querySelectorAll('button[ds-button]'));
        const primaryButtonsInView = this.buttonsInView.filter((el) => el.getAttribute('ng-reflect-variant') === DsButtonVariants.primary);
        const secondaryButtonsInView = this.buttonsInView.filter((el) => el.getAttribute('ng-reflect-variant') === DsButtonVariants.microAction);
        const closeButtonInView = secondaryButtonsInView.filter((el) => el.getAttribute('ng-reflect-micro-action-icon') === Icons.XMark)
            .length > 0;
        // micro button count exceeds if there are more than two secondary microAction buttons aside from the close button in the view
        const microButtonsCountExceeded = secondaryButtonsInView.length > secondaryButtonsAllowedInView && !closeButtonInView;
        const primaryButtonsCountExceeded = primaryButtonsInView.length > primaryButtonsAllowedInView;
        if (microButtonsCountExceeded) {
            this.displayMicroActionButtons = false;
            this.changeDetector.detectChanges();
            throw new Error(`[DsHeaderBarComponent]: The maximum allowed DsHeaderBarMicroActionButtonComponent is ${secondaryButtonsAllowedInView}.`);
        }
        if (primaryButtonsCountExceeded) {
            this.displayPrimaryActionButtons = false;
            this.changeDetector.detectChanges();
            throw new Error(`[DsHeaderBarComponent]: The maximum allowed DsHeaderBarPrimaryButtonComponent is ${primaryButtonsAllowedInView}.`);
        }
    }
    ngAfterViewInit() {
        this.validateViewContent();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsHeaderBarComponent, deps: [{ token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.5", type: DsHeaderBarComponent, selector: "ds-header-bar", inputs: { titleHeadingLevel: "titleHeadingLevel", title: "title", badge: "badge", infoItems: "infoItems", description: "description" }, viewQueries: [{ propertyName: "actionButtons", first: true, predicate: ["actionButtons"], descendants: true }], ngImport: i0, template: "<header class=\"ds-header-bar\">\n  <div class=\"ds-header-bar-heading\">\n    <ng-container *ngIf=\"_title\" [ngSwitch]=\"titleHeadingLevel\">\n      <h1 *ngSwitchCase=\"'h1'\">{{ _title }}</h1>\n      <h2 *ngSwitchCase=\"'h2'\">{{ _title }}</h2>\n      <h3 *ngSwitchCase=\"'h3'\">{{ _title }}</h3>\n      <h4 *ngSwitchCase=\"'h4'\">{{ _title }}</h4>\n      <h5 *ngSwitchCase=\"'h5'\">{{ _title }}</h5>\n      <h6 *ngSwitchCase=\"'h6'\">{{ _title }}</h6>\n      <h1 *ngSwitchDefault>{{ _title }}</h1>\n    </ng-container>\n  </div>\n  <p *ngIf=\"description\" class=\"ds-header-bar-description\" data-test-id=\"ds-header-bar-description\">{{ description }}</p>\n  <div class=\"ds-header-bar-badge\" *ngIf=\"badge && infoItems?.length > 0\">\n    <span [class.badge-type]=\"badge === 'default'\" data-test-id=\"badge-type\">{{ badge }}</span>\n    <ng-container *ngFor=\"let item of infoItems; last as isLast\">\n      <span class=\"badge-item\" data-test-id=\"badge-item\"> {{ item }} </span>\n      <span *ngIf=\"!isLast\" class=\"badge-item-separator\" aria-hidden=\"true\">|</span>\n    </ng-container>\n  </div>\n  <div class=\"ds-header-bar-action-buttons\" #actionButtons>\n    <div *ngIf=\"displayMicroActionButtons\" class=\"ds-header-bar-micro-action-button\">\n      <ng-content select=\"[ds-header-secondary-micro-action]\"></ng-content>\n    </div>\n    <ng-container *ngIf=\"displayPrimaryActionButtons\">\n      <ng-content select=\"[ds-header-primary-action]\"></ng-content>\n    </ng-container>\n    <ng-content select=\"[ds-header-secondary-micro-action][close]\"></ng-content>\n  </div>\n</header>\n", dependencies: [{ kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgSwitch, selector: "[ngSwitch]", inputs: ["ngSwitch"] }, { kind: "directive", type: i1.NgSwitchCase, selector: "[ngSwitchCase]", inputs: ["ngSwitchCase"] }, { kind: "directive", type: i1.NgSwitchDefault, selector: "[ngSwitchDefault]" }], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsHeaderBarComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ds-header-bar', changeDetection: ChangeDetectionStrategy.OnPush, encapsulation: ViewEncapsulation.None, template: "<header class=\"ds-header-bar\">\n  <div class=\"ds-header-bar-heading\">\n    <ng-container *ngIf=\"_title\" [ngSwitch]=\"titleHeadingLevel\">\n      <h1 *ngSwitchCase=\"'h1'\">{{ _title }}</h1>\n      <h2 *ngSwitchCase=\"'h2'\">{{ _title }}</h2>\n      <h3 *ngSwitchCase=\"'h3'\">{{ _title }}</h3>\n      <h4 *ngSwitchCase=\"'h4'\">{{ _title }}</h4>\n      <h5 *ngSwitchCase=\"'h5'\">{{ _title }}</h5>\n      <h6 *ngSwitchCase=\"'h6'\">{{ _title }}</h6>\n      <h1 *ngSwitchDefault>{{ _title }}</h1>\n    </ng-container>\n  </div>\n  <p *ngIf=\"description\" class=\"ds-header-bar-description\" data-test-id=\"ds-header-bar-description\">{{ description }}</p>\n  <div class=\"ds-header-bar-badge\" *ngIf=\"badge && infoItems?.length > 0\">\n    <span [class.badge-type]=\"badge === 'default'\" data-test-id=\"badge-type\">{{ badge }}</span>\n    <ng-container *ngFor=\"let item of infoItems; last as isLast\">\n      <span class=\"badge-item\" data-test-id=\"badge-item\"> {{ item }} </span>\n      <span *ngIf=\"!isLast\" class=\"badge-item-separator\" aria-hidden=\"true\">|</span>\n    </ng-container>\n  </div>\n  <div class=\"ds-header-bar-action-buttons\" #actionButtons>\n    <div *ngIf=\"displayMicroActionButtons\" class=\"ds-header-bar-micro-action-button\">\n      <ng-content select=\"[ds-header-secondary-micro-action]\"></ng-content>\n    </div>\n    <ng-container *ngIf=\"displayPrimaryActionButtons\">\n      <ng-content select=\"[ds-header-primary-action]\"></ng-content>\n    </ng-container>\n    <ng-content select=\"[ds-header-secondary-micro-action][close]\"></ng-content>\n  </div>\n</header>\n" }]
        }], ctorParameters: () => [{ type: i0.ChangeDetectorRef }], propDecorators: { titleHeadingLevel: [{
                type: Input
            }], title: [{
                type: Input
            }], badge: [{
                type: Input
            }], infoItems: [{
                type: Input
            }], description: [{
                type: Input
            }], actionButtons: [{
                type: ViewChild,
                args: ['actionButtons']
            }] } });

class DsHeaderBarModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsHeaderBarModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.5", ngImport: i0, type: DsHeaderBarModule, declarations: [DsHeaderBarComponent, DsHeaderPrimaryActionDirective, DsHeaderSecondaryMicroActionDirective], imports: [CommonModule, DsIconModule, DsButtonModule], exports: [DsHeaderBarComponent, DsHeaderPrimaryActionDirective, DsHeaderSecondaryMicroActionDirective] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsHeaderBarModule, imports: [CommonModule, DsIconModule, DsButtonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsHeaderBarModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [DsHeaderBarComponent, DsHeaderPrimaryActionDirective, DsHeaderSecondaryMicroActionDirective],
                    imports: [CommonModule, DsIconModule, DsButtonModule],
                    exports: [DsHeaderBarComponent, DsHeaderPrimaryActionDirective, DsHeaderSecondaryMicroActionDirective],
                }]
        }] });

class DsToolbarComponent {
    constructor() {
        this.itemCount = 0;
    }
    ngAfterContentInit() {
        if (this.skipLink.length > 1) {
            throw new Error('[DsToolbarComponent] Only one ds-link component may be used within the root of this component');
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsToolbarComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.5", type: DsToolbarComponent, selector: "ds-toolbar", inputs: { itemCount: "itemCount" }, queries: [{ propertyName: "skipLink", predicate: DsLinkComponent }], ngImport: i0, template: "<div class=\"ds-toolbar\">\n  <div class=\"row g-0\">\n    <div class=\"col-12 header-bar\">\n      <!-- TODO EAP-14870 & EAP-16279 & EAP-16764 - Update selector if it changes during implementation -->\n      <ng-content select=\"[ds-toolbar-header]\"></ng-content>\n    </div>\n  </div>\n  <div *ngIf=\"skipLink\" class=\"row g-0\">\n    <div class=\"col-12 d-none d-sm-block skip-link\">\n      <ng-content select=\"ds-link\"></ng-content>\n    </div>\n  </div>\n  <div class=\"row g-0\">\n    <div class=\"col-sm-5 d-none d-sm-block search\">\n      <!-- TODO EAP-14867 & EAP-16766 - Update selector if it changes during implementation -->\n      <ng-content select=\"[ds-toolbar-search]\"></ng-content>\n    </div>\n    <div class=\"col-sm-7 col-xs-12 actions\">\n      <!-- TODO EAP-16769 & EAP-16772 - Update selector if it changes during implementation -->\n      <ng-content select=\"[ds-toolbar-actions]\"></ng-content>\n    </div>\n  </div>\n  <div class=\"row g-0\">\n    <div class=\"col\">\n      <span class=\"item-count\" [ngPlural]=\"itemCount\">\n        <ng-template ngPluralCase=\"=1\">1 item</ng-template>\n        <ng-template ngPluralCase=\"other\">{{ itemCount + ' items' }}</ng-template>\n      </span>\n    </div>\n  </div>\n</div>\n", dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgPlural, selector: "[ngPlural]", inputs: ["ngPlural"] }, { kind: "directive", type: i1.NgPluralCase, selector: "[ngPluralCase]" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsToolbarComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ds-toolbar', template: "<div class=\"ds-toolbar\">\n  <div class=\"row g-0\">\n    <div class=\"col-12 header-bar\">\n      <!-- TODO EAP-14870 & EAP-16279 & EAP-16764 - Update selector if it changes during implementation -->\n      <ng-content select=\"[ds-toolbar-header]\"></ng-content>\n    </div>\n  </div>\n  <div *ngIf=\"skipLink\" class=\"row g-0\">\n    <div class=\"col-12 d-none d-sm-block skip-link\">\n      <ng-content select=\"ds-link\"></ng-content>\n    </div>\n  </div>\n  <div class=\"row g-0\">\n    <div class=\"col-sm-5 d-none d-sm-block search\">\n      <!-- TODO EAP-14867 & EAP-16766 - Update selector if it changes during implementation -->\n      <ng-content select=\"[ds-toolbar-search]\"></ng-content>\n    </div>\n    <div class=\"col-sm-7 col-xs-12 actions\">\n      <!-- TODO EAP-16769 & EAP-16772 - Update selector if it changes during implementation -->\n      <ng-content select=\"[ds-toolbar-actions]\"></ng-content>\n    </div>\n  </div>\n  <div class=\"row g-0\">\n    <div class=\"col\">\n      <span class=\"item-count\" [ngPlural]=\"itemCount\">\n        <ng-template ngPluralCase=\"=1\">1 item</ng-template>\n        <ng-template ngPluralCase=\"other\">{{ itemCount + ' items' }}</ng-template>\n      </span>\n    </div>\n  </div>\n</div>\n" }]
        }], ctorParameters: () => [], propDecorators: { itemCount: [{
                type: Input
            }], skipLink: [{
                type: ContentChildren,
                args: [DsLinkComponent]
            }] } });

class DsToolbarModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsToolbarModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.5", ngImport: i0, type: DsToolbarModule, declarations: [DsToolbarComponent], imports: [CommonModule,
            DsLinkModule], exports: [DsToolbarComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsToolbarModule, imports: [CommonModule,
            DsLinkModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsToolbarModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        DsToolbarComponent,
                    ],
                    imports: [
                        CommonModule,
                        DsLinkModule,
                    ],
                    exports: [
                        DsToolbarComponent,
                    ],
                }]
        }] });

class DsBreadcrumbComponent {
    constructor() {
        this.DsLinkColor = DsLinkColor;
        this.Icons = Icons;
        this.IconStyles = IconStyles;
        this.IconScale = IconScale;
        this.class = 'ds-breadcrumb';
        this.breadcrumbs = [];
    }
    getColor() {
        if (!this.color) {
            return '';
        }
        return this.color.toLowerCase();
    }
    truncateText(text) {
        if (!this.maxCharacters || text.length <= this.maxCharacters) {
            return null;
        }
        return text.slice(0, this.maxCharacters) + '...';
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsBreadcrumbComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.5", type: DsBreadcrumbComponent, selector: "ds-breadcrumb", inputs: { breadcrumbs: "breadcrumbs", dividerIcon: "dividerIcon", lastBold: "lastBold", color: "color", maxCharacters: "maxCharacters" }, host: { properties: { "class": "this.class" } }, ngImport: i0, template: "<ng-template #breadcrumbLabel let-breadcrumb=\"breadcrumb\" let-last=\"last\">\n  <span\n    class=\"ds-breadcrumb-label\"\n    data-test-id=\"ds-breadcrumb-label\"\n    [style.font-weight]=\"last && lastBold ? 'bold' : 'normal'\"\n    [class]=\"color ? 'ds-breadcrumb-' + getColor() : ''\"\n    [ds-tooltip]=\"truncateText(breadcrumb.label) ? breadcrumb.label : null\"\n    tooltipPlacement=\"bottom\"\n    [attr.aria-label]=\"breadcrumb.label\"\n    >{{ truncateText(breadcrumb.label) || breadcrumb.label }}</span\n  >\n</ng-template>\n\n<nav aria-label=\"breadcrumb\">\n  <ol class=\"ds-breadcrumb-item-container\">\n    <li\n      *ngFor=\"let breadcrumb of breadcrumbs; let last = last\"\n      [ngClass]=\"{ 'ds-breadcrumb-item': !last, 'ds-breadcrumb-last-item': last }\"\n      [attr.data-test-id]=\"!last ? 'ds-breadcrumb-item' : 'ds-breadcrumb-last-item'\"\n    >\n      <ds-link\n        *ngIf=\"breadcrumb.rtLink || breadcrumb.href; else noAccess\"\n        [href]=\"breadcrumb.href\"\n        [rtLink]=\"breadcrumb.rtLink\"\n        [queryParams]=\"breadcrumb.queryParams\"\n        [fragment]=\"breadcrumb.fragment\"\n        [standalone]=\"true\"\n        [ariaCurrent]=\"last ? 'page' : undefined\"\n        [linkColor]=\"color || (last ? DsLinkColor.Dark : DsLinkColor.Default)\"\n        [icon]=\"breadcrumb.icon\"\n        [attr.data-test-id]=\"breadcrumb.icon ? 'ds-breadcrumb-icon-' + breadcrumb.icon : undefined\"\n      >\n        <ng-container *ngTemplateOutlet=\"breadcrumbLabel; context: { breadcrumb: breadcrumb, last: last }\"></ng-container>\n      </ds-link>\n      <ng-template #noAccess>\n        <ng-container *ngTemplateOutlet=\"breadcrumbLabel; context: { breadcrumb: breadcrumb, last: last }\"></ng-container>\n      </ng-template>\n      <ng-container *ngIf=\"!last\">\n        <ds-icon\n          *ngIf=\"dividerIcon\"\n          [icon]=\"dividerIcon\"\n          [iconStyle]=\"IconStyles.Light\"\n          [scale]=\"IconScale.FA_1X\"\n          [fixedWidth]=\"false\"\n          class=\"ds-breadcrumb-divider\"\n          [style.color]=\"color === DsLinkColor.Default ? '#333333' : color\"\n          aria-hidden=\"true\"\n        ></ds-icon\n        ><span\n          *ngIf=\"!dividerIcon\"\n          class=\"ds-breadcrumb-divider\"\n          [class]=\"color ? 'ds-breadcrumb-' + getColor() : ''\"\n          aria-hidden=\"true\"\n          >/</span\n        >\n      </ng-container>\n    </li>\n  </ol>\n</nav>\n", dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "component", type: DsLinkComponent, selector: "ds-link", inputs: ["href", "rtLink", "fragment", "queryParams", "queryParamsHandling", "disabled", "external", "standalone", "skip", "role", "tabindex", "icon", "iconTitle", "tooltipPlacement", "linkColor", "ariaCurrent", "ariaLabel", "tooltip"], outputs: ["activated"] }, { kind: "component", type: DsIconComponent, selector: "ds-icon", inputs: ["icon", "iconStyle", "scale", "fixedWidth", "secondaryColor", "title"] }, { kind: "directive", type: DsTooltipDirective, selector: "[ds-tooltip]", inputs: ["ds-tooltip", "tooltipPlacement"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsBreadcrumbComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ds-breadcrumb', template: "<ng-template #breadcrumbLabel let-breadcrumb=\"breadcrumb\" let-last=\"last\">\n  <span\n    class=\"ds-breadcrumb-label\"\n    data-test-id=\"ds-breadcrumb-label\"\n    [style.font-weight]=\"last && lastBold ? 'bold' : 'normal'\"\n    [class]=\"color ? 'ds-breadcrumb-' + getColor() : ''\"\n    [ds-tooltip]=\"truncateText(breadcrumb.label) ? breadcrumb.label : null\"\n    tooltipPlacement=\"bottom\"\n    [attr.aria-label]=\"breadcrumb.label\"\n    >{{ truncateText(breadcrumb.label) || breadcrumb.label }}</span\n  >\n</ng-template>\n\n<nav aria-label=\"breadcrumb\">\n  <ol class=\"ds-breadcrumb-item-container\">\n    <li\n      *ngFor=\"let breadcrumb of breadcrumbs; let last = last\"\n      [ngClass]=\"{ 'ds-breadcrumb-item': !last, 'ds-breadcrumb-last-item': last }\"\n      [attr.data-test-id]=\"!last ? 'ds-breadcrumb-item' : 'ds-breadcrumb-last-item'\"\n    >\n      <ds-link\n        *ngIf=\"breadcrumb.rtLink || breadcrumb.href; else noAccess\"\n        [href]=\"breadcrumb.href\"\n        [rtLink]=\"breadcrumb.rtLink\"\n        [queryParams]=\"breadcrumb.queryParams\"\n        [fragment]=\"breadcrumb.fragment\"\n        [standalone]=\"true\"\n        [ariaCurrent]=\"last ? 'page' : undefined\"\n        [linkColor]=\"color || (last ? DsLinkColor.Dark : DsLinkColor.Default)\"\n        [icon]=\"breadcrumb.icon\"\n        [attr.data-test-id]=\"breadcrumb.icon ? 'ds-breadcrumb-icon-' + breadcrumb.icon : undefined\"\n      >\n        <ng-container *ngTemplateOutlet=\"breadcrumbLabel; context: { breadcrumb: breadcrumb, last: last }\"></ng-container>\n      </ds-link>\n      <ng-template #noAccess>\n        <ng-container *ngTemplateOutlet=\"breadcrumbLabel; context: { breadcrumb: breadcrumb, last: last }\"></ng-container>\n      </ng-template>\n      <ng-container *ngIf=\"!last\">\n        <ds-icon\n          *ngIf=\"dividerIcon\"\n          [icon]=\"dividerIcon\"\n          [iconStyle]=\"IconStyles.Light\"\n          [scale]=\"IconScale.FA_1X\"\n          [fixedWidth]=\"false\"\n          class=\"ds-breadcrumb-divider\"\n          [style.color]=\"color === DsLinkColor.Default ? '#333333' : color\"\n          aria-hidden=\"true\"\n        ></ds-icon\n        ><span\n          *ngIf=\"!dividerIcon\"\n          class=\"ds-breadcrumb-divider\"\n          [class]=\"color ? 'ds-breadcrumb-' + getColor() : ''\"\n          aria-hidden=\"true\"\n          >/</span\n        >\n      </ng-container>\n    </li>\n  </ol>\n</nav>\n" }]
        }], propDecorators: { class: [{
                type: HostBinding,
                args: ['class']
            }], breadcrumbs: [{
                type: Input
            }], dividerIcon: [{
                type: Input
            }], lastBold: [{
                type: Input
            }], color: [{
                type: Input
            }], maxCharacters: [{
                type: Input
            }] } });

class DsBreadcrumbModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsBreadcrumbModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.5", ngImport: i0, type: DsBreadcrumbModule, declarations: [DsBreadcrumbComponent], imports: [CommonModule, DsLinkModule, DsIconModule, DsTooltipModule], exports: [DsBreadcrumbComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsBreadcrumbModule, imports: [CommonModule, DsLinkModule, DsIconModule, DsTooltipModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsBreadcrumbModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [DsBreadcrumbComponent],
                    imports: [CommonModule, DsLinkModule, DsIconModule, DsTooltipModule],
                    exports: [DsBreadcrumbComponent],
                }]
        }] });

class DsPaginationComponent {
    constructor() {
        /**
         * Use if there is another pagination on the page, to give each pagination a unique label.
         */
        this.ariaLabel = 'pagination';
        this.resultsName = 'results';
        this.hidePaginationNavigation = false;
        this.pageSize = 10;
        this.DsButtonVariants = DsButtonVariants;
        this.Icons = Icons;
        this.lastPage = 0;
        this.subscriptions = new Subscription();
        this.pageChange = new EventEmitter();
    }
    ngOnInit() {
        this.subscriptions.add(this.lastPage$.subscribe((lastPage) => (this.lastPage = lastPage)));
    }
    get collectionSize$() {
        if (isObservable(this.collectionSize)) {
            return this.collectionSize;
        }
        return of(this.collectionSize);
    }
    get startIndex$() {
        return this.collectionSize$.pipe(map((size) => Math.min(size, this.page * this.pageSize - this.pageSize + 1)));
    }
    get lastIndex$() {
        return this.collectionSize$.pipe(map((size) => Math.min(size, this.page * this.pageSize)));
    }
    get lastPage$() {
        return this.collectionSize$.pipe(map((size) => Math.ceil(size / this.pageSize)));
    }
    get displayPaginationNavigation() {
        return !this.hidePaginationNavigation && this.lastPage > 1;
    }
    handlePageChange(page) {
        this.pageChange.emit(page);
    }
    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsPaginationComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.5", type: DsPaginationComponent, selector: "ds-pagination", inputs: { ariaLabel: "ariaLabel", resultsName: "resultsName", collectionSize: "collectionSize", page: "page", hidePaginationNavigation: "hidePaginationNavigation", pageSize: "pageSize" }, outputs: { pageChange: "pageChange" }, ngImport: i0, template: "<div class=\"ds-pagination\">\n  <div aria-live=\"polite\" class=\"ds-results-count\">\n    {{ startIndex$ | async\n    }}<!--\n    ---><span aria-hidden=\"true\" data-test-id=\"ds-pagination-dash\">-</span\n    ><!--\n    ---><span class=\"ds-visually-hidden\" data-test-id=\"ds-pagination-to\">to</span\n    ><!--\n    --->{{ lastIndex$ | async }} of {{ collectionSize$ | async }} {{ resultsName }}\n  </div>\n  <nav [attr.aria-label]=\"ariaLabel\" class=\"ds-pagination-navigation\" *ngIf=\"displayPaginationNavigation\">\n    <button\n      type=\"button\"\n      class=\"ds-pagination-prev-button\"\n      (click)=\"handlePageChange(page - 1)\"\n      [disabled]=\"page === 1\"\n      ds-button\n      data-test-id=\"ds-pagination-prev-button\"\n      [variant]=\"DsButtonVariants.microActionHorizontalLayout\"\n      [microActionIcon]=\"Icons.ChevronLeft\"\n    >\n      <span aria-hidden=\"true\" data-test-id=\"ds-pagination-prev\">Prev</span>\n      <span class=\"ds-visually-hidden\" data-test-id=\"ds-pagination-previous-page\">Previous page</span>\n    </button>\n    <span aria-live=\"polite\" class=\"ds-page-count\"> Page {{ page }} of {{ lastPage$ | async }} </span>\n    <button\n      type=\"button\"\n      class=\"ds-pagination-next-button\"\n      [disabled]=\"page === lastPage\"\n      ds-button\n      data-test-id=\"ds-pagination-next-button\"\n      (click)=\"handlePageChange(page + 1)\"\n      [variant]=\"DsButtonVariants.microActionWithChevronRight\"\n      [hideMicroActionIcon]=\"true\"\n      [microActionIcon]=\"Icons.ChevronRight\"\n    >\n      Next\n      <span class=\"ds-visually-hidden\" data-test-id=\"ds-pagination-page\">page</span>\n    </button>\n  </nav>\n</div>\n", dependencies: [{ kind: "component", type: DsButtonComponent, selector: "button[ds-button], a[ds-button]", inputs: ["visuallyHidden", "color", "variant", "withChevron", "microActionIcon", "hideMicroActionIcon", "disabledLink", "isExternalLink"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "pipe", type: i1.AsyncPipe, name: "async" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsPaginationComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ds-pagination', template: "<div class=\"ds-pagination\">\n  <div aria-live=\"polite\" class=\"ds-results-count\">\n    {{ startIndex$ | async\n    }}<!--\n    ---><span aria-hidden=\"true\" data-test-id=\"ds-pagination-dash\">-</span\n    ><!--\n    ---><span class=\"ds-visually-hidden\" data-test-id=\"ds-pagination-to\">to</span\n    ><!--\n    --->{{ lastIndex$ | async }} of {{ collectionSize$ | async }} {{ resultsName }}\n  </div>\n  <nav [attr.aria-label]=\"ariaLabel\" class=\"ds-pagination-navigation\" *ngIf=\"displayPaginationNavigation\">\n    <button\n      type=\"button\"\n      class=\"ds-pagination-prev-button\"\n      (click)=\"handlePageChange(page - 1)\"\n      [disabled]=\"page === 1\"\n      ds-button\n      data-test-id=\"ds-pagination-prev-button\"\n      [variant]=\"DsButtonVariants.microActionHorizontalLayout\"\n      [microActionIcon]=\"Icons.ChevronLeft\"\n    >\n      <span aria-hidden=\"true\" data-test-id=\"ds-pagination-prev\">Prev</span>\n      <span class=\"ds-visually-hidden\" data-test-id=\"ds-pagination-previous-page\">Previous page</span>\n    </button>\n    <span aria-live=\"polite\" class=\"ds-page-count\"> Page {{ page }} of {{ lastPage$ | async }} </span>\n    <button\n      type=\"button\"\n      class=\"ds-pagination-next-button\"\n      [disabled]=\"page === lastPage\"\n      ds-button\n      data-test-id=\"ds-pagination-next-button\"\n      (click)=\"handlePageChange(page + 1)\"\n      [variant]=\"DsButtonVariants.microActionWithChevronRight\"\n      [hideMicroActionIcon]=\"true\"\n      [microActionIcon]=\"Icons.ChevronRight\"\n    >\n      Next\n      <span class=\"ds-visually-hidden\" data-test-id=\"ds-pagination-page\">page</span>\n    </button>\n  </nav>\n</div>\n" }]
        }], ctorParameters: () => [], propDecorators: { ariaLabel: [{
                type: Input
            }], resultsName: [{
                type: Input
            }], collectionSize: [{
                type: Input
            }], page: [{
                type: Input
            }], hidePaginationNavigation: [{
                type: Input
            }], pageSize: [{
                type: Input
            }], pageChange: [{
                type: Output
            }] } });

class DsPaginationModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsPaginationModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.5", ngImport: i0, type: DsPaginationModule, declarations: [DsPaginationComponent], imports: [DsButtonModule, CommonModule], exports: [DsPaginationComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsPaginationModule, imports: [DsButtonModule, CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsPaginationModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [DsPaginationComponent],
                    imports: [DsButtonModule, CommonModule],
                    exports: [DsPaginationComponent],
                }]
        }] });

var DsChipColorVariant;
(function (DsChipColorVariant) {
    DsChipColorVariant["LightBlue"] = "LightBlue";
    DsChipColorVariant["Gray"] = "Gray";
    DsChipColorVariant["LightGray"] = "LightGray";
    DsChipColorVariant["Purple"] = "Purple";
    DsChipColorVariant["Green"] = "Green";
    DsChipColorVariant["Orange"] = "Orange";
    DsChipColorVariant["Red"] = "Red";
})(DsChipColorVariant || (DsChipColorVariant = {}));
const colorVariantToCssModifier = {
    [DsChipColorVariant.LightBlue]: 'light-blue-variant',
    [DsChipColorVariant.Gray]: 'gray-variant',
    [DsChipColorVariant.LightGray]: 'light-gray-variant',
    [DsChipColorVariant.Purple]: 'purple-variant',
    [DsChipColorVariant.Green]: 'green-variant',
    [DsChipColorVariant.Orange]: 'orange-variant',
    [DsChipColorVariant.Red]: 'red-variant',
};
class DsChipComponent {
    constructor() {
        this.chipId = DomUtility.createUniqueDOMId();
        this.additionalId = '';
    }
    get colorVariantToCssModifier() {
        return colorVariantToCssModifier[this.colorVariant] ?? '';
    }
    get labelledBy() {
        if (CommonUtility.notNullishOrEmpty(this.additionalId)) {
            return this.additionalId.trim();
        }
        return null;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsChipComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.5", type: DsChipComponent, selector: "ds-chip", inputs: { text: "text", colorVariant: "colorVariant", chipId: "chipId", additionalId: "additionalId" }, ngImport: i0, template: "<div class=\"ds-chip\" [ngClass]=\"colorVariantToCssModifier\" [id]=\"chipId\" [attr.aria-labelledby]=\"labelledBy\">\n  <span>{{ text }}</span>\n</div>\n", dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsChipComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ds-chip', template: "<div class=\"ds-chip\" [ngClass]=\"colorVariantToCssModifier\" [id]=\"chipId\" [attr.aria-labelledby]=\"labelledBy\">\n  <span>{{ text }}</span>\n</div>\n" }]
        }], propDecorators: { text: [{
                type: Input
            }], colorVariant: [{
                type: Input
            }], chipId: [{
                type: Input
            }], additionalId: [{
                type: Input
            }] } });

var DsCardVariant;
(function (DsCardVariant) {
    DsCardVariant["Standard"] = "Standard";
    DsCardVariant["StatusChip"] = "StatusChip";
})(DsCardVariant || (DsCardVariant = {}));
const VariantClass = Object.freeze({
    [DsCardVariant.Standard]: 'ds-standard-card',
    [DsCardVariant.StatusChip]: 'ds-status-chip-card',
});
class DsCardComponent {
    set footer(value) {
        this._footer = value;
        this.updateHasFooter();
    }
    get footer() {
        return this._footer;
    }
    set footerAction(value) {
        this._footerAction = value;
        this.updateHasFooter();
    }
    get footerAction() {
        return this._footerAction;
    }
    set variant(value) {
        this._variant = value || DsCardVariant.Standard;
        this.variantClass = VariantClass[this._variant];
    }
    get variant() {
        return this._variant;
    }
    set cardId(value) {
        if (CommonUtility.notNullishOrEmpty(value)) {
            this._cardId = value;
        }
        this.cardIdChange.emit(this._cardId);
    }
    get cardId() {
        return this._cardId;
    }
    constructor() {
        this.tooltipPlacement = DsTooltipPosition.right;
        this._cardId = `card-${DomUtility.createUniqueDOMId()}`;
        this.cardIdChange = new EventEmitter();
        this.hasFooter = false;
        this.DsButtonVariants = DsButtonVariants;
        this.DsCardVariant = DsCardVariant;
        this.DsChipColorVariant = DsChipColorVariant;
        this.Icons = Icons;
        this.DsTooltipPosition = DsTooltipPosition;
        this._variant = DsCardVariant.Standard;
        this.variantClass = VariantClass[this._variant];
        this.footerActionClicked = new EventEmitter();
    }
    onFooterActionClicked() {
        this.footerActionClicked.emit();
    }
    updateHasFooter() {
        this.hasFooter = CommonUtility.notNullishOrEmpty(this.footer) || CommonUtility.notNullish(this.footerAction);
    }
    get showTooltip() {
        return CommonUtility.notNullishOrEmpty(this.infoButtonTooltipText);
    }
    get onlyActions() {
        return !this.showTooltip && this.showHeaderAction;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsCardComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.5", type: DsCardComponent, selector: "ds-card", inputs: { title: "title", titleHeadingLevel: "titleHeadingLevel", infoButtonTooltipText: "infoButtonTooltipText", tooltipPlacement: "tooltipPlacement", height: "height", footer: "footer", footerAction: "footerAction", variant: "variant", showHeaderAction: "showHeaderAction", cardId: "cardId" }, outputs: { cardIdChange: "cardIdChange", footerActionClicked: "footerActionClicked" }, ngImport: i0, template: "<div class=\"ds-card\" [ngClass]=\"variantClass\" [style.height]=\"height\">\n  <div class=\"ds-card-header\" [class.ds-card-header-title-actions]=\"onlyActions\">\n    <div class=\"ds-card-header-title\" [id]=\"cardId + '-title'\">\n      <ng-container [ngSwitch]=\"titleHeadingLevel\">\n        <h1 *ngSwitchCase=\"'h1'\">{{ title }}</h1>\n        <h2 *ngSwitchCase=\"'h2'\">{{ title }}</h2>\n        <h3 *ngSwitchCase=\"'h3'\">{{ title }}</h3>\n        <h4 *ngSwitchCase=\"'h4'\">{{ title }}</h4>\n        <h5 *ngSwitchCase=\"'h5'\">{{ title }}</h5>\n        <h6 *ngSwitchCase=\"'h6'\">{{ title }}</h6>\n        <h1 *ngSwitchDefault>{{ title }}</h1>\n      </ng-container>\n    </div>\n\n    <div class=\"ds-card-header-buttons\" [class.ds-card-header-no-tooltip]=\"!showTooltip\">\n      <button\n        *ngIf=\"showTooltip\"\n        ds-button\n        [id]=\"cardId + '-info'\"\n        [attr.aria-labelledby]=\"cardId + '-info ' + cardId + '-title'\"\n        [ds-tooltip]=\"infoButtonTooltipText\"\n        [variant]=\"DsButtonVariants.microActionHorizontalLayout\"\n        [tooltipPlacement]=\"tooltipPlacement\"\n        [microActionIcon]=\"Icons.CircleInfo\"\n        data-test-id=\"ds-card-header-buttons-info\"\n      >\n        Info\n      </button>\n\n      <ng-content *ngIf=\"showHeaderAction\" select=\"[ds-card-header-action]\"></ng-content>\n    </div>\n  </div>\n  <div class=\"ds-card-body\">\n    <ng-content select=\"[ds-card-body]\"></ng-content>\n  </div>\n  <div *ngIf=\"hasFooter\" class=\"ds-card-footer\">\n    <ng-container *ngIf=\"footer\">\n      <ng-container [ngSwitch]=\"variant\">\n        <p *ngSwitchCase=\"DsCardVariant.Standard\" class=\"ds-card-footer-text\" data-test-id=\"ds-card-footer-text\">{{ footer }}</p>\n        <ds-chip *ngSwitchCase=\"DsCardVariant.StatusChip\" [text]=\"footer\" [colorVariant]=\"DsChipColorVariant.LightBlue\"></ds-chip>\n      </ng-container>\n    </ng-container>\n    <div *ngIf=\"footerAction\" class=\"ds-card-footer-action\">\n      <button\n        ds-button\n        [id]=\"cardId + '-footer'\"\n        [attr.aria-labelledby]=\"footerAction.ariaLabel ? null : cardId + '-footer ' + cardId + '-title'\"\n        [attr.aria-label]=\"footerAction.ariaLabel ? footerAction.ariaLabel : null\"\n        [variant]=\"DsButtonVariants.microActionHorizontalLayout\"\n        [microActionIcon]=\"footerAction.icon\"\n        (click)=\"onFooterActionClicked()\"\n      >\n        {{ footerAction.text }}\n      </button>\n    </div>\n  </div>\n</div>\n", dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgSwitch, selector: "[ngSwitch]", inputs: ["ngSwitch"] }, { kind: "directive", type: i1.NgSwitchCase, selector: "[ngSwitchCase]", inputs: ["ngSwitchCase"] }, { kind: "directive", type: i1.NgSwitchDefault, selector: "[ngSwitchDefault]" }, { kind: "component", type: DsButtonComponent, selector: "button[ds-button], a[ds-button]", inputs: ["visuallyHidden", "color", "variant", "withChevron", "microActionIcon", "hideMicroActionIcon", "disabledLink", "isExternalLink"] }, { kind: "component", type: DsChipComponent, selector: "ds-chip", inputs: ["text", "colorVariant", "chipId", "additionalId"] }, { kind: "directive", type: DsTooltipDirective, selector: "[ds-tooltip]", inputs: ["ds-tooltip", "tooltipPlacement"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsCardComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ds-card', template: "<div class=\"ds-card\" [ngClass]=\"variantClass\" [style.height]=\"height\">\n  <div class=\"ds-card-header\" [class.ds-card-header-title-actions]=\"onlyActions\">\n    <div class=\"ds-card-header-title\" [id]=\"cardId + '-title'\">\n      <ng-container [ngSwitch]=\"titleHeadingLevel\">\n        <h1 *ngSwitchCase=\"'h1'\">{{ title }}</h1>\n        <h2 *ngSwitchCase=\"'h2'\">{{ title }}</h2>\n        <h3 *ngSwitchCase=\"'h3'\">{{ title }}</h3>\n        <h4 *ngSwitchCase=\"'h4'\">{{ title }}</h4>\n        <h5 *ngSwitchCase=\"'h5'\">{{ title }}</h5>\n        <h6 *ngSwitchCase=\"'h6'\">{{ title }}</h6>\n        <h1 *ngSwitchDefault>{{ title }}</h1>\n      </ng-container>\n    </div>\n\n    <div class=\"ds-card-header-buttons\" [class.ds-card-header-no-tooltip]=\"!showTooltip\">\n      <button\n        *ngIf=\"showTooltip\"\n        ds-button\n        [id]=\"cardId + '-info'\"\n        [attr.aria-labelledby]=\"cardId + '-info ' + cardId + '-title'\"\n        [ds-tooltip]=\"infoButtonTooltipText\"\n        [variant]=\"DsButtonVariants.microActionHorizontalLayout\"\n        [tooltipPlacement]=\"tooltipPlacement\"\n        [microActionIcon]=\"Icons.CircleInfo\"\n        data-test-id=\"ds-card-header-buttons-info\"\n      >\n        Info\n      </button>\n\n      <ng-content *ngIf=\"showHeaderAction\" select=\"[ds-card-header-action]\"></ng-content>\n    </div>\n  </div>\n  <div class=\"ds-card-body\">\n    <ng-content select=\"[ds-card-body]\"></ng-content>\n  </div>\n  <div *ngIf=\"hasFooter\" class=\"ds-card-footer\">\n    <ng-container *ngIf=\"footer\">\n      <ng-container [ngSwitch]=\"variant\">\n        <p *ngSwitchCase=\"DsCardVariant.Standard\" class=\"ds-card-footer-text\" data-test-id=\"ds-card-footer-text\">{{ footer }}</p>\n        <ds-chip *ngSwitchCase=\"DsCardVariant.StatusChip\" [text]=\"footer\" [colorVariant]=\"DsChipColorVariant.LightBlue\"></ds-chip>\n      </ng-container>\n    </ng-container>\n    <div *ngIf=\"footerAction\" class=\"ds-card-footer-action\">\n      <button\n        ds-button\n        [id]=\"cardId + '-footer'\"\n        [attr.aria-labelledby]=\"footerAction.ariaLabel ? null : cardId + '-footer ' + cardId + '-title'\"\n        [attr.aria-label]=\"footerAction.ariaLabel ? footerAction.ariaLabel : null\"\n        [variant]=\"DsButtonVariants.microActionHorizontalLayout\"\n        [microActionIcon]=\"footerAction.icon\"\n        (click)=\"onFooterActionClicked()\"\n      >\n        {{ footerAction.text }}\n      </button>\n    </div>\n  </div>\n</div>\n" }]
        }], ctorParameters: () => [], propDecorators: { title: [{
                type: Input
            }], titleHeadingLevel: [{
                type: Input
            }], infoButtonTooltipText: [{
                type: Input
            }], tooltipPlacement: [{
                type: Input
            }], height: [{
                type: Input
            }], footer: [{
                type: Input
            }], footerAction: [{
                type: Input
            }], variant: [{
                type: Input
            }], showHeaderAction: [{
                type: Input
            }], cardId: [{
                type: Input
            }], cardIdChange: [{
                type: Output
            }], footerActionClicked: [{
                type: Output
            }] } });

class DsChipModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsChipModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.5", ngImport: i0, type: DsChipModule, declarations: [DsChipComponent], imports: [CommonModule], exports: [DsChipComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsChipModule, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsChipModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [DsChipComponent],
                    imports: [CommonModule],
                    exports: [DsChipComponent],
                }]
        }] });

class DsCardModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsCardModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.5", ngImport: i0, type: DsCardModule, declarations: [DsCardComponent], imports: [CommonModule, DsIconModule, DsButtonModule, DsChipModule, DsDropdownModule, DsTooltipModule], exports: [DsCardComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsCardModule, imports: [CommonModule, DsIconModule, DsButtonModule, DsChipModule, DsDropdownModule, DsTooltipModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsCardModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [DsCardComponent],
                    imports: [CommonModule, DsIconModule, DsButtonModule, DsChipModule, DsDropdownModule, DsTooltipModule],
                    exports: [DsCardComponent],
                }]
        }] });

class DsTabComponent {
    constructor() {
        this._isActive = false;
        this.tabId = 0;
        this.label = '';
    }
    set isActive(value) {
        this._isActive = value;
    }
    get isActive() {
        return this._isActive;
    }
    get headingLabel() {
        return this.heading ?? 'Tab ' + (this.tabId + 1) + ' content heading';
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsTabComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.5", type: DsTabComponent, selector: "ds-tab", inputs: { label: "label", heading: "heading", headingLevel: "headingLevel" }, viewQueries: [{ propertyName: "tabContent", first: true, predicate: ["tabContent"], descendants: true, static: true }], ngImport: i0, template: `
    <ng-template #tabContent>
      <ng-container [ngSwitch]="headingLevel">
        <h1 *ngSwitchCase="1">{{ headingLabel }}</h1>
        <h2 *ngSwitchCase="2">{{ headingLabel }}</h2>
        <h3 *ngSwitchCase="3">{{ headingLabel }}</h3>
        <h4 *ngSwitchCase="4">{{ headingLabel }}</h4>
        <h5 *ngSwitchCase="5">{{ headingLabel }}</h5>
        <h6 *ngSwitchCase="6">{{ headingLabel }}</h6>
        <ng-container *ngSwitchDefault>
          <h2>{{ headingLabel }}</h2>
        </ng-container>
      </ng-container>
      <ng-content></ng-content>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: i1.NgSwitch, selector: "[ngSwitch]", inputs: ["ngSwitch"] }, { kind: "directive", type: i1.NgSwitchCase, selector: "[ngSwitchCase]", inputs: ["ngSwitchCase"] }, { kind: "directive", type: i1.NgSwitchDefault, selector: "[ngSwitchDefault]" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsTabComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'ds-tab',
                    template: `
    <ng-template #tabContent>
      <ng-container [ngSwitch]="headingLevel">
        <h1 *ngSwitchCase="1">{{ headingLabel }}</h1>
        <h2 *ngSwitchCase="2">{{ headingLabel }}</h2>
        <h3 *ngSwitchCase="3">{{ headingLabel }}</h3>
        <h4 *ngSwitchCase="4">{{ headingLabel }}</h4>
        <h5 *ngSwitchCase="5">{{ headingLabel }}</h5>
        <h6 *ngSwitchCase="6">{{ headingLabel }}</h6>
        <ng-container *ngSwitchDefault>
          <h2>{{ headingLabel }}</h2>
        </ng-container>
      </ng-container>
      <ng-content></ng-content>
    </ng-template>
  `,
                }]
        }], propDecorators: { tabContent: [{
                type: ViewChild,
                args: ['tabContent', { static: true }]
            }], label: [{
                type: Input
            }], heading: [{
                type: Input
            }], headingLevel: [{
                type: Input
            }] } });
class DsTabsComponent {
    set activeId(value) {
        if (CommonUtility.notNullish(value) && value !== this._activeId) {
            this._activeId = value;
            this.activeIdChange.emit(this._activeId);
        }
    }
    get activeId() {
        return this._activeId;
    }
    constructor(elementRef) {
        this.elementRef = elementRef;
        this._activeId = 0;
        this.Icons = Icons;
        this.tablistLabelledBy = '';
        /**
         * If true, inactive tab content will be unloaded from the DOM.
         */
        this.destroyOnHide = true;
        /**
         * If true, opt out of switching to mobile view on medium & small screens.
         */
        this.optOutOfResponsiveBehaviour = false;
        this.activeIdChange = new EventEmitter();
    }
    setTabIds() {
        this.tabs.forEach((tab, index) => {
            tab.tabId = index;
        });
    }
    setActiveTab(activeId) {
        this.activeId = activeId ?? this.activeId;
        this.tabs.forEach((tab, index) => {
            tab.isActive = index === this.activeId;
            if (tab.isActive) {
                this.activeTab = tab;
            }
        });
    }
    tabIsActive(tabId) {
        return tabId === this.activeId;
    }
    moveFocusToTab(tabIdToFocus) {
        const tabToFocus = this.tablistButtons.find((_, index) => index === tabIdToFocus);
        if (CommonUtility.notNullish(tabToFocus)) {
            tabToFocus.nativeElement.focus();
        }
    }
    moveFocusRight(event, eventTargetIndex) {
        event.preventDefault();
        const tabIdToFocus = (eventTargetIndex + 1) % this.tabs.length;
        this.moveFocusToTab(tabIdToFocus);
    }
    moveFocusLeft(event, eventTargetIndex) {
        event.preventDefault();
        // adjustment for mod with negative numbers
        const tabIdToFocus = (eventTargetIndex - 1 + this.tabs.length) % this.tabs.length;
        this.moveFocusToTab(tabIdToFocus);
    }
    focusFirstTab(event) {
        event.preventDefault();
        this.moveFocusToTab(0);
    }
    focusLastTab(event) {
        event.preventDefault();
        this.moveFocusToTab(this.tabs.length - 1);
    }
    ngOnChanges() {
        if (this.optOutOfResponsiveBehaviour) {
            this.elementRef.nativeElement.classList.add('ds-responsive-opt-out');
        }
        else {
            this.elementRef.nativeElement.classList.remove('ds-responsive-opt-out');
        }
    }
    ngAfterContentInit() {
        if (CommonUtility.isNullishOrEmpty(this.tablistLabelledBy)) {
            throw new Error(`tablistLabelledBy can't be empty`);
        }
        this.setTabIds();
        this.setActiveTab();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsTabsComponent, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.5", type: DsTabsComponent, selector: "ds-tabs", inputs: { tablistLabelledBy: "tablistLabelledBy", destroyOnHide: "destroyOnHide", optOutOfResponsiveBehaviour: "optOutOfResponsiveBehaviour", activeId: "activeId" }, outputs: { activeIdChange: "activeIdChange" }, queries: [{ propertyName: "tabs", predicate: DsTabComponent, descendants: true }], viewQueries: [{ propertyName: "tablistButtons", predicate: ["tablistButton"], descendants: true }], usesOnChanges: true, ngImport: i0, template: `
    <div class="ds-tablist" role="tablist" [attr.aria-labelledby]="tablistLabelledBy">
      <button
        *ngFor="let tab of tabs; let i = index"
        class="ds-override-focus-indicator"
        role="tab"
        [attr.aria-selected]="tabIsActive(i)"
        [tabindex]="tabIsActive(i) ? 0 : -1"
        [id]="'tab-' + i"
        [attr.aria-controls]="'tabpanel-' + i"
        (click)="$event.preventDefault(); setActiveTab(i)"
        (keydown.arrowRight)="moveFocusRight($event, i)"
        (keydown.arrowLeft)="moveFocusLeft($event, i)"
        (keydown.home)="focusFirstTab($event)"
        (keydown.end)="focusLastTab($event)"
        #tablistButton
      >
        <span class="focus">
          {{ tab.label }}
        </span>
      </button>
    </div>
    <ng-container *ngFor="let tab of tabs; let i = index">
      <button
        class="ds-mobile-tab"
        (click)="$event.preventDefault(); setActiveTab(i)"
        [attr.aria-expanded]="tabIsActive(i)"
        [attr.aria-controls]="'tabpanel-' + i"
        [id]="'mobile-tab-' + i"
      >
        <span class="focus">
          {{ tab.label }}
        </span>
        <span>
          <ds-icon [icon]="tabIsActive(i) ? Icons.ChevronUp : Icons.ChevronDown"></ds-icon>
        </span>
      </button>
      <div
        class="ds-tabpanel ds-override-focus-indicator"
        [class.is-hidden]="!tabIsActive(i)"
        role="tabpanel"
        [id]="'tabpanel-' + i"
        [attr.aria-labelledby]="'tab-' + i"
        [tabindex]="tabIsActive(i) ? 0 : undefined"
      >
        <ng-container *ngIf="!destroyOnHide || tabIsActive(i)">
          <ng-template [ngTemplateOutlet]="tab.tabContent"></ng-template>
        </ng-container>
      </div>
    </ng-container>
  `, isInline: true, dependencies: [{ kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "component", type: DsIconComponent, selector: "ds-icon", inputs: ["icon", "iconStyle", "scale", "fixedWidth", "secondaryColor", "title"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsTabsComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'ds-tabs',
                    template: `
    <div class="ds-tablist" role="tablist" [attr.aria-labelledby]="tablistLabelledBy">
      <button
        *ngFor="let tab of tabs; let i = index"
        class="ds-override-focus-indicator"
        role="tab"
        [attr.aria-selected]="tabIsActive(i)"
        [tabindex]="tabIsActive(i) ? 0 : -1"
        [id]="'tab-' + i"
        [attr.aria-controls]="'tabpanel-' + i"
        (click)="$event.preventDefault(); setActiveTab(i)"
        (keydown.arrowRight)="moveFocusRight($event, i)"
        (keydown.arrowLeft)="moveFocusLeft($event, i)"
        (keydown.home)="focusFirstTab($event)"
        (keydown.end)="focusLastTab($event)"
        #tablistButton
      >
        <span class="focus">
          {{ tab.label }}
        </span>
      </button>
    </div>
    <ng-container *ngFor="let tab of tabs; let i = index">
      <button
        class="ds-mobile-tab"
        (click)="$event.preventDefault(); setActiveTab(i)"
        [attr.aria-expanded]="tabIsActive(i)"
        [attr.aria-controls]="'tabpanel-' + i"
        [id]="'mobile-tab-' + i"
      >
        <span class="focus">
          {{ tab.label }}
        </span>
        <span>
          <ds-icon [icon]="tabIsActive(i) ? Icons.ChevronUp : Icons.ChevronDown"></ds-icon>
        </span>
      </button>
      <div
        class="ds-tabpanel ds-override-focus-indicator"
        [class.is-hidden]="!tabIsActive(i)"
        role="tabpanel"
        [id]="'tabpanel-' + i"
        [attr.aria-labelledby]="'tab-' + i"
        [tabindex]="tabIsActive(i) ? 0 : undefined"
      >
        <ng-container *ngIf="!destroyOnHide || tabIsActive(i)">
          <ng-template [ngTemplateOutlet]="tab.tabContent"></ng-template>
        </ng-container>
      </div>
    </ng-container>
  `,
                }]
        }], ctorParameters: () => [{ type: i0.ElementRef }], propDecorators: { tablistButtons: [{
                type: ViewChildren,
                args: ['tablistButton']
            }], tabs: [{
                type: ContentChildren,
                args: [DsTabComponent, { descendants: true }]
            }], tablistLabelledBy: [{
                type: Input
            }], destroyOnHide: [{
                type: Input
            }], optOutOfResponsiveBehaviour: [{
                type: Input
            }], activeId: [{
                type: Input
            }], activeIdChange: [{
                type: Output
            }] } });

class DsTabsModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsTabsModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.5", ngImport: i0, type: DsTabsModule, declarations: [DsTabComponent, DsTabsComponent], imports: [CommonModule, DsIconModule], exports: [DsTabComponent, DsTabsComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsTabsModule, imports: [CommonModule, DsIconModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsTabsModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [DsTabComponent, DsTabsComponent],
                    imports: [CommonModule, DsIconModule],
                    exports: [DsTabComponent, DsTabsComponent],
                }]
        }] });

const secondActionVariants = [DsButtonVariants.secondary, DsButtonVariants.microAction];
class DsButtonGroupComponent {
    constructor() {
        this.toggleButton = {
            label: 'More',
            ariaLabel: 'More actions',
            icon: Icons.Plus,
        };
        this.DsButtonVariants = DsButtonVariants;
        this.Icons = Icons;
        this.primaryActionClicked = new EventEmitter();
        this.secondActionClicked = new EventEmitter();
    }
    onPrimaryActionClicked() {
        this.primaryActionClicked.emit();
    }
    onSecondaryActionClicked() {
        this.secondActionClicked.emit();
    }
    get isSecondActionExist() {
        return CommonUtility.notNullish(this.secondAction) && secondActionVariants.includes(this.secondAction.variant);
    }
    validateContent() {
        if (!this.isSecondActionExist && this.microActionContent?.items?.length > 0) {
            throw new Error('Should set a valid second action before passing ds-button-group-micro elements');
        }
    }
    ngAfterViewInit() {
        this.validateContent();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsButtonGroupComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.5", type: DsButtonGroupComponent, selector: "ds-button-group", inputs: { primaryAction: "primaryAction", secondAction: "secondAction", toggleButton: "toggleButton" }, outputs: { primaryActionClicked: "primaryActionClicked", secondActionClicked: "secondActionClicked" }, queries: [{ propertyName: "microActionContent", first: true, predicate: i0.forwardRef(() => DsButtonGroupMenuDirective), descendants: true }], ngImport: i0, template: "<div class=\"ds-button-group\">\n  <button\n    ds-button\n    [variant]=\"DsButtonVariants.primary\"\n    [attr.aria-label]=\"primaryAction?.ariaLabel\"\n    (click)=\"onPrimaryActionClicked()\"\n    [disabled]=\"primaryAction?.disabled\"\n    [attr.type]=\"primaryAction?.type\"\n    data-test-id=\"button-group-primary\"\n  >\n    {{ primaryAction?.label }}\n  </button>\n\n  <ng-container *ngIf=\"secondAction?.variant === DsButtonVariants.secondary\">\n    <button\n      ds-button\n      class=\"ds-btn-secondary\"\n      [variant]=\"DsButtonVariants.secondary\"\n      [attr.aria-label]=\"secondAction?.ariaLabel\"\n      [disabled]=\"secondAction.disabled\"\n      [attr.type]=\"secondAction.type\"\n      data-test-id=\"button-group-second\"\n      (click)=\"onSecondaryActionClicked()\"\n    >\n      {{ secondAction?.label }}\n    </button>\n  </ng-container>\n\n  <div\n    class=\"ds-micro-action-wrapper\"\n    [class.ds-more-button]=\"microActionContent?.items?.length > 1\"\n    [class.ds-more-button-only]=\"secondAction?.variant !== DsButtonVariants.microAction && microActionContent?.items?.length > 1\"\n  >\n    <div class=\"ds-micro-action-wrapper\">\n      <ng-container *ngIf=\"secondAction?.variant === DsButtonVariants.microAction\">\n        <button\n          ds-button\n          class=\"ds-btn-group-micro-action\"\n          [variant]=\"secondAction?.variant\"\n          [attr.aria-label]=\"secondAction?.ariaLabel\"\n          [disabled]=\"secondAction.disabled\"\n          [attr.type]=\"secondAction.type\"\n          [microActionIcon]=\"secondAction?.icon ?? Icons.Bug\"\n          data-test-id=\"button-group-second\"\n          (click)=\"onSecondaryActionClicked()\"\n        >\n          {{ secondAction?.label }}\n        </button>\n      </ng-container>\n      <ng-container *ngIf=\"isSecondActionExist && microActionContent?.items?.length === 1\">\n        <button\n          ds-button\n          class=\"ds-btn-group-micro-action\"\n          [variant]=\"DsButtonVariants.microAction\"\n          [microActionIcon]=\"microActionContent.items.get(0).icon ?? Icons.Bug\"\n          [attr.aria-label]=\"microActionContent.items.get(0).ariaLabel\"\n          [disabled]=\"microActionContent.items.get(0).disabled\"\n        >\n          {{ microActionContent.items.get(0).label }}\n        </button>\n      </ng-container>\n    </div>\n\n    <ng-container *ngIf=\"isSecondActionExist && microActionContent?.items?.length > 1\" class=\"ds-btn-group-micro-action\">\n      <ds-dropdown class=\"ds-btn-group-micro-action\">\n        <ds-dropdown-toggle\n          [variant]=\"DsButtonVariants.microAction\"\n          [icon]=\"toggleButton?.icon ?? Icons.Plus\"\n          [label]=\"toggleButton?.label\"\n          [attr.aria-label]=\"toggleButton?.ariaLabel\"\n        >\n        </ds-dropdown-toggle>\n        <div ds-dropdown-menu>\n          <ds-dropdown-item\n            *ngFor=\"let microAction of microActionContent.items\"\n            [icon]=\"microAction.icon ?? Icons.Bug\"\n            [label]=\"microAction.label\"\n            [disabled]=\"microAction.disabled\"\n            (selected)=\"microAction.onMicroActionClicked()\"\n          >\n          </ds-dropdown-item>\n        </div>\n      </ds-dropdown>\n    </ng-container>\n  </div>\n</div>\n", dependencies: [{ kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: DsDropdownComponent, selector: "ds-dropdown", inputs: ["dropdownId", "selectedMenuItemIndex", "selectedValue", "modalTitle"] }, { kind: "component", type: DsDropdownToggleComponent, selector: "ds-dropdown-toggle", inputs: ["variant", "icon", "label", "ariaLabel", "ariaLabelledBy"] }, { kind: "component", type: DsDropdownItemComponent, selector: "ds-dropdown-item", inputs: ["label", "icon", "href", "queryParams", "value", "disabled"], outputs: ["selected"] }, { kind: "directive", type: DsDropdownMenuDirective, selector: "[ds-dropdown-menu]" }, { kind: "component", type: DsButtonComponent, selector: "button[ds-button], a[ds-button]", inputs: ["visuallyHidden", "color", "variant", "withChevron", "microActionIcon", "hideMicroActionIcon", "disabledLink", "isExternalLink"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsButtonGroupComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ds-button-group', template: "<div class=\"ds-button-group\">\n  <button\n    ds-button\n    [variant]=\"DsButtonVariants.primary\"\n    [attr.aria-label]=\"primaryAction?.ariaLabel\"\n    (click)=\"onPrimaryActionClicked()\"\n    [disabled]=\"primaryAction?.disabled\"\n    [attr.type]=\"primaryAction?.type\"\n    data-test-id=\"button-group-primary\"\n  >\n    {{ primaryAction?.label }}\n  </button>\n\n  <ng-container *ngIf=\"secondAction?.variant === DsButtonVariants.secondary\">\n    <button\n      ds-button\n      class=\"ds-btn-secondary\"\n      [variant]=\"DsButtonVariants.secondary\"\n      [attr.aria-label]=\"secondAction?.ariaLabel\"\n      [disabled]=\"secondAction.disabled\"\n      [attr.type]=\"secondAction.type\"\n      data-test-id=\"button-group-second\"\n      (click)=\"onSecondaryActionClicked()\"\n    >\n      {{ secondAction?.label }}\n    </button>\n  </ng-container>\n\n  <div\n    class=\"ds-micro-action-wrapper\"\n    [class.ds-more-button]=\"microActionContent?.items?.length > 1\"\n    [class.ds-more-button-only]=\"secondAction?.variant !== DsButtonVariants.microAction && microActionContent?.items?.length > 1\"\n  >\n    <div class=\"ds-micro-action-wrapper\">\n      <ng-container *ngIf=\"secondAction?.variant === DsButtonVariants.microAction\">\n        <button\n          ds-button\n          class=\"ds-btn-group-micro-action\"\n          [variant]=\"secondAction?.variant\"\n          [attr.aria-label]=\"secondAction?.ariaLabel\"\n          [disabled]=\"secondAction.disabled\"\n          [attr.type]=\"secondAction.type\"\n          [microActionIcon]=\"secondAction?.icon ?? Icons.Bug\"\n          data-test-id=\"button-group-second\"\n          (click)=\"onSecondaryActionClicked()\"\n        >\n          {{ secondAction?.label }}\n        </button>\n      </ng-container>\n      <ng-container *ngIf=\"isSecondActionExist && microActionContent?.items?.length === 1\">\n        <button\n          ds-button\n          class=\"ds-btn-group-micro-action\"\n          [variant]=\"DsButtonVariants.microAction\"\n          [microActionIcon]=\"microActionContent.items.get(0).icon ?? Icons.Bug\"\n          [attr.aria-label]=\"microActionContent.items.get(0).ariaLabel\"\n          [disabled]=\"microActionContent.items.get(0).disabled\"\n        >\n          {{ microActionContent.items.get(0).label }}\n        </button>\n      </ng-container>\n    </div>\n\n    <ng-container *ngIf=\"isSecondActionExist && microActionContent?.items?.length > 1\" class=\"ds-btn-group-micro-action\">\n      <ds-dropdown class=\"ds-btn-group-micro-action\">\n        <ds-dropdown-toggle\n          [variant]=\"DsButtonVariants.microAction\"\n          [icon]=\"toggleButton?.icon ?? Icons.Plus\"\n          [label]=\"toggleButton?.label\"\n          [attr.aria-label]=\"toggleButton?.ariaLabel\"\n        >\n        </ds-dropdown-toggle>\n        <div ds-dropdown-menu>\n          <ds-dropdown-item\n            *ngFor=\"let microAction of microActionContent.items\"\n            [icon]=\"microAction.icon ?? Icons.Bug\"\n            [label]=\"microAction.label\"\n            [disabled]=\"microAction.disabled\"\n            (selected)=\"microAction.onMicroActionClicked()\"\n          >\n          </ds-dropdown-item>\n        </div>\n      </ds-dropdown>\n    </ng-container>\n  </div>\n</div>\n" }]
        }], ctorParameters: () => [], propDecorators: { primaryAction: [{
                type: Input
            }], secondAction: [{
                type: Input
            }], toggleButton: [{
                type: Input
            }], primaryActionClicked: [{
                type: Output
            }], secondActionClicked: [{
                type: Output
            }], microActionContent: [{
                type: ContentChild,
                args: [forwardRef(() => DsButtonGroupMenuDirective)]
            }] } });
class DsButtonGroupMicroComponent {
    constructor(dsButtonGroup) {
        this.dsButtonGroup = dsButtonGroup;
        this.microActionClicked = new EventEmitter();
    }
    onMicroActionClicked() {
        this.microActionClicked.emit();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsButtonGroupMicroComponent, deps: [{ token: forwardRef(() => DsButtonGroupComponent) }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.5", type: DsButtonGroupMicroComponent, selector: "ds-button-group-micro", inputs: { icon: "icon", label: "label", ariaLabel: "ariaLabel", disabled: "disabled" }, outputs: { microActionClicked: "microActionClicked" }, ngImport: i0, template: '', isInline: true }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsButtonGroupMicroComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'ds-button-group-micro',
                    template: '',
                }]
        }], ctorParameters: () => [{ type: DsButtonGroupComponent, decorators: [{
                    type: Inject,
                    args: [forwardRef(() => DsButtonGroupComponent)]
                }] }], propDecorators: { icon: [{
                type: Input
            }], label: [{
                type: Input
            }], ariaLabel: [{
                type: Input
            }], disabled: [{
                type: Input
            }], microActionClicked: [{
                type: Output
            }] } });
class DsButtonGroupMenuDirective {
    constructor(dsButtonGroup) {
        this.dsButtonGroup = dsButtonGroup;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsButtonGroupMenuDirective, deps: [{ token: forwardRef(() => DsButtonGroupComponent) }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.5", type: DsButtonGroupMenuDirective, selector: "[ds-button-group-menu]", queries: [{ propertyName: "items", predicate: i0.forwardRef(() => DsButtonGroupMicroComponent) }], ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsButtonGroupMenuDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[ds-button-group-menu]',
                }]
        }], ctorParameters: () => [{ type: DsButtonGroupComponent, decorators: [{
                    type: Inject,
                    args: [forwardRef(() => DsButtonGroupComponent)]
                }] }], propDecorators: { items: [{
                type: ContentChildren,
                args: [forwardRef(() => DsButtonGroupMicroComponent)]
            }] } });

class DsButtonGroupModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsButtonGroupModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.5", ngImport: i0, type: DsButtonGroupModule, declarations: [DsButtonGroupComponent, DsButtonGroupMicroComponent, DsButtonGroupMenuDirective], imports: [CommonModule, DsIconModule, DsDropdownModule, DsButtonModule], exports: [DsButtonGroupComponent, DsButtonGroupMicroComponent, DsButtonGroupMenuDirective] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsButtonGroupModule, imports: [CommonModule, DsIconModule, DsDropdownModule, DsButtonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsButtonGroupModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [DsButtonGroupComponent, DsButtonGroupMicroComponent, DsButtonGroupMenuDirective],
                    imports: [CommonModule, DsIconModule, DsDropdownModule, DsButtonModule],
                    exports: [DsButtonGroupComponent, DsButtonGroupMicroComponent, DsButtonGroupMenuDirective],
                }]
        }] });

class DsCheckboxesFeedbackComponent {
    set options(value) {
        this._options = value.map((option) => ({
            ...option,
            id: DomUtility.createUniqueDOMId(option.id),
        }));
    }
    constructor() {
        this.Icons = Icons;
        this.IconStyles = IconStyles;
        this.checked = false;
        this.valueChange = new EventEmitter();
        this._options = [];
    }
    onValueChanged(value, checked) {
        this.value = checked ? value : undefined;
        this.valueChange.emit(this.value);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsCheckboxesFeedbackComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.5", type: DsCheckboxesFeedbackComponent, selector: "ds-checkboxes-feedback", inputs: { title: "title", options: "options", value: "value" }, outputs: { valueChange: "valueChange" }, ngImport: i0, template: "<ng-container>\n  <fieldset class=\"ds-checkboxes-feedback\">\n    <legend class=\"ds-visually-hidden\">{{ title }}</legend>\n    <div class=\"ds-checkboxes-feedback-option\" *ngFor=\"let option of _options\">\n      <input\n        type=\"checkbox\"\n        class=\"ds-override-focus-indicator\"\n        [id]=\"option.id\"\n        [ngModel]=\"value === option.value\"\n        (ngModelChange)=\"onValueChanged(option.value, $event)\"\n      />\n      <label [htmlFor]=\"option.id\">\n        <ds-icon [icon]=\"option.icon\" [iconStyle]=\"value === option.value ? IconStyles.Solid : IconStyles.Light\"></ds-icon>\n        {{ option.label }}\n      </label>\n    </div>\n  </fieldset>\n</ng-container>\n", dependencies: [{ kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "component", type: DsIconComponent, selector: "ds-icon", inputs: ["icon", "iconStyle", "scale", "fixedWidth", "secondaryColor", "title"] }, { kind: "directive", type: i1$1.CheckboxControlValueAccessor, selector: "input[type=checkbox][formControlName],input[type=checkbox][formControl],input[type=checkbox][ngModel]" }, { kind: "directive", type: i1$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1$1.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsCheckboxesFeedbackComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ds-checkboxes-feedback', template: "<ng-container>\n  <fieldset class=\"ds-checkboxes-feedback\">\n    <legend class=\"ds-visually-hidden\">{{ title }}</legend>\n    <div class=\"ds-checkboxes-feedback-option\" *ngFor=\"let option of _options\">\n      <input\n        type=\"checkbox\"\n        class=\"ds-override-focus-indicator\"\n        [id]=\"option.id\"\n        [ngModel]=\"value === option.value\"\n        (ngModelChange)=\"onValueChanged(option.value, $event)\"\n      />\n      <label [htmlFor]=\"option.id\">\n        <ds-icon [icon]=\"option.icon\" [iconStyle]=\"value === option.value ? IconStyles.Solid : IconStyles.Light\"></ds-icon>\n        {{ option.label }}\n      </label>\n    </div>\n  </fieldset>\n</ng-container>\n" }]
        }], ctorParameters: () => [], propDecorators: { title: [{
                type: Input
            }], options: [{
                type: Input
            }], value: [{
                type: Input
            }], valueChange: [{
                type: Output
            }] } });

class DsCheckboxesFeedbackModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsCheckboxesFeedbackModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.5", ngImport: i0, type: DsCheckboxesFeedbackModule, declarations: [DsCheckboxesFeedbackComponent], imports: [CommonModule, DsIconModule, FormsModule], exports: [DsCheckboxesFeedbackComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsCheckboxesFeedbackModule, imports: [CommonModule, DsIconModule, FormsModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsCheckboxesFeedbackModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [DsCheckboxesFeedbackComponent],
                    imports: [CommonModule, DsIconModule, FormsModule],
                    exports: [DsCheckboxesFeedbackComponent],
                }]
        }] });

class DsCopyComponent {
    constructor() {
        this.DsButtonVariants = DsButtonVariants;
        this.Icons = Icons;
        this.label = 'Copy';
        this.content = 'content';
    }
    onCopyClicked(event) {
        event.preventDefault();
        if (CommonUtility.notNullishOrEmpty(this.htmlIdToCopy)) {
            try {
                const element = document.getElementById(`${this.htmlIdToCopy}`);
                const data = [
                    new ClipboardItem({
                        'text/plain': new Blob([element.innerText], { type: 'text/plain' }),
                        'text/html': new Blob([element.innerHTML], { type: 'text/html' }),
                    }),
                ];
                navigator.clipboard.write(data).then(() => alert('Copied to clipboard!')); // eslint-disable-line no-alert
            }
            catch (e) {
                // Firefox doesn't support ClipboardItem yet. Add the following code for compatibility
                const r = document.createRange();
                r.selectNode(document.getElementById(this.htmlIdToCopy));
                window.getSelection().removeAllRanges();
                window.getSelection().addRange(r);
                try {
                    document.execCommand('copy');
                    window.getSelection().removeAllRanges();
                    alert('Copied to clipboard!'); // eslint-disable-line no-alert
                }
                catch (err) {
                    console.log('Unable to copy!');
                }
            }
        }
        else {
            navigator.clipboard.writeText(this.textToCopy).then(() => alert('Copied to clipboard!')); // eslint-disable-line no-alert
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsCopyComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.5", type: DsCopyComponent, selector: "ds-copy", inputs: { label: "label", content: "content", textToCopy: "textToCopy", htmlIdToCopy: "htmlIdToCopy" }, ngImport: i0, template: "<button\n  ds-button\n  [variant]=\"DsButtonVariants.microActionHorizontalLayout\"\n  [microActionIcon]=\"Icons.Copy\"\n  (click)=\"onCopyClicked($event)\"\n>\n  {{ label }} <span class=\"ds-visually-hidden\">{{ content }}</span>\n</button>\n", dependencies: [{ kind: "component", type: DsButtonComponent, selector: "button[ds-button], a[ds-button]", inputs: ["visuallyHidden", "color", "variant", "withChevron", "microActionIcon", "hideMicroActionIcon", "disabledLink", "isExternalLink"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsCopyComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ds-copy', template: "<button\n  ds-button\n  [variant]=\"DsButtonVariants.microActionHorizontalLayout\"\n  [microActionIcon]=\"Icons.Copy\"\n  (click)=\"onCopyClicked($event)\"\n>\n  {{ label }} <span class=\"ds-visually-hidden\">{{ content }}</span>\n</button>\n" }]
        }], propDecorators: { label: [{
                type: Input
            }], content: [{
                type: Input
            }], textToCopy: [{
                type: Input
            }], htmlIdToCopy: [{
                type: Input
            }] } });

class DsCopyModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsCopyModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.5", ngImport: i0, type: DsCopyModule, declarations: [DsCopyComponent], imports: [DsButtonModule], exports: [DsCopyComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsCopyModule, imports: [DsButtonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsCopyModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [DsCopyComponent],
                    imports: [DsButtonModule],
                    exports: [DsCopyComponent],
                }]
        }] });

class DsStarRatingComponent {
    static { this._nextUniqueId = 0; }
    constructor(fb) {
        this.fb = fb;
        this.label = 'Rate response';
        this.stars = [1, 2, 3, 4, 5];
        this.submittedRating = '';
        this.Icons = Icons;
        this.IconStyles = IconStyles;
        this.DsButtonVariants = DsButtonVariants;
        this.showSubmitButton = false;
        this.idPrefix = `ds-star-rating-${DsStarRatingComponent._nextUniqueId++}-`;
        this.innerValue = null;
        this.onTouchedCallback = () => { };
        this.onChangeCallback = () => { };
        this.ratingForm = this.fb.group({
            starRating: [0],
        });
    }
    manageFocus() {
        if (this.shouldFocusOutput) {
            this.output.nativeElement.tabIndex = 0;
            this.output.nativeElement.focus();
            this.shouldFocusOutput = false;
        }
    }
    get value() {
        return this.innerValue ?? 0;
    }
    updateRating(value) {
        this.writeValue(value);
    }
    onStarClick(rating) {
        if (rating === this.value) {
            return;
        }
        this.shouldFocusOutput = false;
        this.updateRating(rating);
        this.submitRating(rating);
    }
    onKeydown(event) {
        if (event.key.includes('Arrow') && this.starRating.nativeElement.contains(event.target)) {
            this.showSubmitButton = true;
        }
    }
    onEnter(_) {
        this.onSubmit();
    }
    submitRating(rating) {
        if (typeof rating === 'number') {
            this.submittedRating = `${rating} star${rating > 1 ? 's' : ''} submitted`;
            this.onChangeCallback(rating);
        }
        this.showSubmitButton = false;
    }
    getIconStyle(index) {
        return this.ratingForm.value.starRating >= index ? IconStyles.Solid : IconStyles.Light;
    }
    onBlur() {
        this.onTouchedCallback();
    }
    onSubmit() {
        const formValue = this.ratingForm.value.starRating;
        if (this.value === formValue) {
            return;
        }
        this.shouldFocusOutput = true;
        this.writeValue(formValue);
        this.submitRating(formValue);
    }
    writeValue(value) {
        if (value !== this.innerValue) {
            const numValue = Number(value);
            this.innerValue = this.stars.includes(numValue) ? numValue : null;
            this.ratingForm.setValue({ starRating: this.innerValue });
        }
    }
    registerOnChange(fn) {
        this.onChangeCallback = fn;
    }
    registerOnTouched(fn) {
        this.onTouchedCallback = fn;
    }
    setDisabledState(isDisabled) {
        if (isDisabled) {
            this.ratingForm.disable();
        }
        else {
            this.ratingForm.enable();
        }
    }
    ngAfterViewChecked() {
        if (this.submittedRating && this.output && this.output.nativeElement) {
            this.manageFocus();
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsStarRatingComponent, deps: [{ token: i1$1.FormBuilder }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.5", type: DsStarRatingComponent, selector: "ds-star-rating", inputs: { label: "label", stars: "stars" }, host: { listeners: { "keydown": "onKeydown($event)", "keydown.enter": "onEnter($event)" } }, providers: [{ provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => DsStarRatingComponent), multi: true }], viewQueries: [{ propertyName: "output", first: true, predicate: ["outputElement"], descendants: true }, { propertyName: "starRating", first: true, predicate: ["starRating"], descendants: true }], ngImport: i0, template: "<form [formGroup]=\"ratingForm\" (ngSubmit)=\"onSubmit()\">\n  <fieldset role=\"radiogroup\">\n    <legend>{{ label }}</legend>\n    <div #starRating class=\"ds-star-rating\" (keydown.space)=\"showSubmitButton = true\">\n      <ng-container *ngFor=\"let rating of stars\">\n        <input\n          type=\"radio\"\n          [value]=\"rating\"\n          formControlName=\"starRating\"\n          name=\"starRating\"\n          [id]=\"idPrefix + 'star' + rating\"\n          class=\"ds-visually-hidden\"\n        />\n        <label [for]=\"idPrefix + 'star' + rating\" (click)=\"onStarClick(rating)\" (blur)=\"onBlur()\">\n          <span class=\"ds-visually-hidden\">{{ rating }} Star</span>\n          <ds-icon [icon]=\"Icons.Star\" [iconStyle]=\"getIconStyle(rating)\"></ds-icon>\n        </label>\n      </ng-container>\n    </div>\n  </fieldset>\n\n  <div *ngIf=\"showSubmitButton\" class=\"ds-star-rating-submit\">\n    <button type=\"submit\" ds-button [variant]=\"DsButtonVariants.microActionHorizontalLayout\" [hideMicroActionIcon]=\"true\">\n      Submit rating\n    </button>\n  </div>\n\n  <div *ngIf=\"submittedRating\" class=\"ds-star-rating-output\">\n    <output #outputElement aria-live=\"off\">{{ submittedRating }}</output>\n  </div>\n</form>\n", dependencies: [{ kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: DsIconComponent, selector: "ds-icon", inputs: ["icon", "iconStyle", "scale", "fixedWidth", "secondaryColor", "title"] }, { kind: "directive", type: i1$1.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i1$1.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i1$1.RadioControlValueAccessor, selector: "input[type=radio][formControlName],input[type=radio][formControl],input[type=radio][ngModel]", inputs: ["name", "formControlName", "value"] }, { kind: "directive", type: i1$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1$1.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i1$1.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i1$1.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { kind: "component", type: DsButtonComponent, selector: "button[ds-button], a[ds-button]", inputs: ["visuallyHidden", "color", "variant", "withChevron", "microActionIcon", "hideMicroActionIcon", "disabledLink", "isExternalLink"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsStarRatingComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ds-star-rating', providers: [{ provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => DsStarRatingComponent), multi: true }], template: "<form [formGroup]=\"ratingForm\" (ngSubmit)=\"onSubmit()\">\n  <fieldset role=\"radiogroup\">\n    <legend>{{ label }}</legend>\n    <div #starRating class=\"ds-star-rating\" (keydown.space)=\"showSubmitButton = true\">\n      <ng-container *ngFor=\"let rating of stars\">\n        <input\n          type=\"radio\"\n          [value]=\"rating\"\n          formControlName=\"starRating\"\n          name=\"starRating\"\n          [id]=\"idPrefix + 'star' + rating\"\n          class=\"ds-visually-hidden\"\n        />\n        <label [for]=\"idPrefix + 'star' + rating\" (click)=\"onStarClick(rating)\" (blur)=\"onBlur()\">\n          <span class=\"ds-visually-hidden\">{{ rating }} Star</span>\n          <ds-icon [icon]=\"Icons.Star\" [iconStyle]=\"getIconStyle(rating)\"></ds-icon>\n        </label>\n      </ng-container>\n    </div>\n  </fieldset>\n\n  <div *ngIf=\"showSubmitButton\" class=\"ds-star-rating-submit\">\n    <button type=\"submit\" ds-button [variant]=\"DsButtonVariants.microActionHorizontalLayout\" [hideMicroActionIcon]=\"true\">\n      Submit rating\n    </button>\n  </div>\n\n  <div *ngIf=\"submittedRating\" class=\"ds-star-rating-output\">\n    <output #outputElement aria-live=\"off\">{{ submittedRating }}</output>\n  </div>\n</form>\n" }]
        }], ctorParameters: () => [{ type: i1$1.FormBuilder }], propDecorators: { label: [{
                type: Input
            }], stars: [{
                type: Input
            }], output: [{
                type: ViewChild,
                args: ['outputElement']
            }], starRating: [{
                type: ViewChild,
                args: ['starRating']
            }], onKeydown: [{
                type: HostListener,
                args: ['keydown', ['$event']]
            }], onEnter: [{
                type: HostListener,
                args: ['keydown.enter', ['$event']]
            }] } });

class DsStarRatingModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsStarRatingModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.5", ngImport: i0, type: DsStarRatingModule, declarations: [DsStarRatingComponent], imports: [CommonModule, DsIconModule, ReactiveFormsModule, DsButtonModule], exports: [DsStarRatingComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsStarRatingModule, imports: [CommonModule, DsIconModule, ReactiveFormsModule, DsButtonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsStarRatingModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [DsStarRatingComponent],
                    imports: [CommonModule, DsIconModule, ReactiveFormsModule, DsButtonModule],
                    exports: [DsStarRatingComponent],
                }]
        }] });

class DsDetailsComponent {
    constructor() {
        this.summaryIcon = Icons.Keyboard;
        this.Icons = Icons;
        this.summaryId = DomUtility.createUniqueDOMId('details-summary');
        this.open = false;
    }
    toggle(toggleEvent) {
        this.open = toggleEvent.newState === 'open';
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsDetailsComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.5", type: DsDetailsComponent, selector: "ds-details", inputs: { summary: "summary", summaryIcon: "summaryIcon", summaryId: "summaryId", open: "open" }, ngImport: i0, template: "<ng-container>\n  <details class=\"ds-details\" (toggle)=\"toggle($event)\" [attr.open]=\"open ? '' : null\">\n    <summary [id]=\"summaryId\" class=\"ds-details-summary ds-override-focus-indicator\">\n      <ds-icon class=\"ds-details-summary-icon\" [icon]=\"summaryIcon\" [iconStyle]=\"\"></ds-icon>\n      {{ summary }}\n      <ds-icon class=\"ds-details-summary-chevron\" [icon]=\"open ? Icons.ChevronUp : Icons.ChevronDown\"></ds-icon>\n    </summary>\n    <div class=\"ds-details-content\">\n      <ng-content></ng-content>\n    </div>\n  </details>\n</ng-container>\n", dependencies: [{ kind: "component", type: DsIconComponent, selector: "ds-icon", inputs: ["icon", "iconStyle", "scale", "fixedWidth", "secondaryColor", "title"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsDetailsComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ds-details', template: "<ng-container>\n  <details class=\"ds-details\" (toggle)=\"toggle($event)\" [attr.open]=\"open ? '' : null\">\n    <summary [id]=\"summaryId\" class=\"ds-details-summary ds-override-focus-indicator\">\n      <ds-icon class=\"ds-details-summary-icon\" [icon]=\"summaryIcon\" [iconStyle]=\"\"></ds-icon>\n      {{ summary }}\n      <ds-icon class=\"ds-details-summary-chevron\" [icon]=\"open ? Icons.ChevronUp : Icons.ChevronDown\"></ds-icon>\n    </summary>\n    <div class=\"ds-details-content\">\n      <ng-content></ng-content>\n    </div>\n  </details>\n</ng-container>\n" }]
        }], propDecorators: { summary: [{
                type: Input
            }], summaryIcon: [{
                type: Input
            }], summaryId: [{
                type: Input
            }], open: [{
                type: Input
            }] } });

class DsDetailsModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsDetailsModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.5", ngImport: i0, type: DsDetailsModule, declarations: [DsDetailsComponent], imports: [DsIconModule, CommonModule], exports: [DsDetailsComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsDetailsModule, imports: [DsIconModule, CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsDetailsModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [DsDetailsComponent],
                    imports: [DsIconModule, CommonModule],
                    exports: [DsDetailsComponent],
                }]
        }] });

class DsTreeMenuItemStateDirective {
    constructor() {
        this.stateChange = new EventEmitter();
        this.isHovered = false;
        this.isFocused = false;
    }
    onMouseEnter() {
        this.isHovered = true;
        this.emitState();
    }
    onMouseLeave() {
        this.isHovered = false;
        this.emitState();
    }
    onFocus() {
        this.isFocused = true;
        this.emitState();
    }
    onBlur() {
        this.isFocused = false;
        this.emitState();
    }
    emitState() {
        this.stateChange.emit(this.isHovered || this.isFocused);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsTreeMenuItemStateDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.5", type: DsTreeMenuItemStateDirective, selector: "[dsTreeMenuItemState]", outputs: { stateChange: "stateChange" }, host: { listeners: { "mouseenter": "onMouseEnter()", "mouseleave": "onMouseLeave()", "focus": "onFocus()", "blur": "onBlur()" } }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsTreeMenuItemStateDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[dsTreeMenuItemState]',
                }]
        }], propDecorators: { stateChange: [{
                type: Output
            }], onMouseEnter: [{
                type: HostListener,
                args: ['mouseenter']
            }], onMouseLeave: [{
                type: HostListener,
                args: ['mouseleave']
            }], onFocus: [{
                type: HostListener,
                args: ['focus']
            }], onBlur: [{
                type: HostListener,
                args: ['blur']
            }] } });

class DsTreeMenuComponent {
    set menuItems(items) {
        const previousIds = this.flattenMenuItems(this._menuItems).map((item) => item.id);
        const currentIds = this.flattenMenuItems(items || []).map((item) => item.id);
        const itemsChanged = previousIds.length !== currentIds.length || JSON.stringify(previousIds.sort()) !== JSON.stringify(currentIds.sort());
        if (itemsChanged) {
            this.selectedItemId = '';
        }
        this._menuItems = items || [];
    }
    get menuItems() {
        return this._menuItems;
    }
    get treeItems() {
        return Array.from(this.treeNode.nativeElement.querySelectorAll('[role="treeitem"]'));
    }
    get flattenedMenuItems() {
        return this.flattenMenuItems(this.menuItems);
    }
    constructor() {
        this.menuAriaLabel = '';
        this._menuItems = [];
        this.rootItemsAlwaysExpanded = false;
        this.Icons = Icons;
        this.IconStyles = IconStyles;
        this.subtreeSuffix = '-subtree';
        this.focusedElements = new Set();
        this.selectedItemId = '';
    }
    ngOnChanges(changes) {
        if (changes['rootItemsAlwaysExpanded']) {
            this.ensureRootItemsExpanded();
        }
    }
    ensureRootItemsExpanded() {
        if (this.rootItemsAlwaysExpanded && this.menuItems?.length > 0) {
            this.menuItems.forEach((item) => {
                if (item.children && item.children.length > 0) {
                    item.expanded = true;
                }
            });
        }
    }
    onKeydownListen(event) {
        if (event.altKey || event.ctrlKey || event.metaKey) {
            return;
        }
        const target = event.target;
        const key = event.key;
        switch (key) {
            case ' ':
            case 'Enter':
                target.click();
                break;
            case 'ArrowUp':
                this.setFocusToPreviousTreeItem(target);
                break;
            case 'ArrowDown':
                this.setFocusToNextTreeItem(target);
                break;
            case 'ArrowRight':
                if (this.isExpandable(target)) {
                    if (this.isExpanded(target)) {
                        this.setFocusToNextTreeItem(target);
                    }
                    else {
                        this.expandTreeItem(target);
                    }
                }
                break;
            case 'ArrowLeft':
                if (this.isExpandable(target) && this.isExpanded(target)) {
                    this.collapseTreeItem(target);
                }
                else if (this.isInSubtree(target)) {
                    this.setFocusToParentTreeItem(target);
                }
                break;
            case 'Home':
                this.setFocusToTreeItem(this.treeItems[0]);
                break;
            case 'End':
                const visibleTreeItems = this.getVisibleTreeItems();
                this.setFocusToTreeItem(visibleTreeItems[visibleTreeItems.length - 1]);
                break;
            default:
                if (this.isPrintableCharacter(key)) {
                    if (key === '*') {
                        this.expandAllSiblingTreeItems(target);
                    }
                    else {
                        this.setFocusByFirstCharacter(target, key);
                    }
                }
                break;
        }
    }
    onFocusIn(event) {
        const target = event.target;
        if (this.treeNode.nativeElement.contains(target)) {
            this.treeNode.nativeElement.classList.add('focused-tree');
        }
    }
    onFocusOut(event) {
        const relatedTarget = event.relatedTarget;
        if (!this.treeNode.nativeElement.contains(relatedTarget)) {
            this.treeNode.nativeElement.classList.remove('focused-tree');
        }
    }
    handleItemClick(event, menuItem) {
        event.preventDefault();
        event.stopPropagation();
        this.selectedItemId = menuItem?.id || '';
        if (!menuItem?.disabled && menuItem?.onClick) {
            menuItem.onClick();
        }
    }
    onIconClick(event) {
        const target = event.currentTarget;
        const parentTreeItem = target.parentNode;
        if (this.isExpanded(parentTreeItem)) {
            this.collapseTreeItem(parentTreeItem);
        }
        else {
            this.expandTreeItem(parentTreeItem);
        }
        event.preventDefault();
        event.stopPropagation();
    }
    getSpacersArray(n) {
        const length = Math.max(0, this.rootItemsAlwaysExpanded ? n - 1 : n);
        return Array(length)
            .fill(0)
            .map((value, index) => index);
    }
    getParentTreeItem(treeItem) {
        let node = treeItem.parentNode;
        if (node) {
            node = node.parentNode;
            if (node) {
                node = node.previousElementSibling;
                if (node && node.getAttribute('role') === 'treeitem') {
                    return node;
                }
            }
        }
        return false;
    }
    isPrintableCharacter(str) {
        return str.length === 1 && str.match(/\S/) !== null;
    }
    isExpanded(treeItem) {
        return treeItem.getAttribute('aria-expanded') === 'true';
    }
    isExpandable(treeItem) {
        return treeItem.hasAttribute('aria-expanded');
    }
    isInSubtree(treeItem) {
        return (treeItem.parentNode &&
            treeItem.parentNode.parentNode &&
            treeItem.parentNode.parentNode.getAttribute('role') === 'group');
    }
    isFirstLevelItem(treeItem) {
        return (treeItem.parentNode &&
            treeItem.parentNode.parentNode &&
            treeItem.parentNode.parentNode.getAttribute('role') === 'tree');
    }
    getVisibleTreeItems() {
        return this.treeItems.filter((ti) => this.isVisible(ti));
    }
    isVisible(treeItem) {
        if (this.isInSubtree(treeItem)) {
            const parentTreeItem = this.getParentTreeItem(treeItem);
            return parentTreeItem && parentTreeItem.getAttribute('aria-expanded') === 'true';
        }
        return true;
    }
    collapseTreeItem(treeItem) {
        if (this.rootItemsAlwaysExpanded && this.isFirstLevelItem(treeItem)) {
            return;
        }
        const menuItem = this.flattenedMenuItems.find((item) => item.id === treeItem.id);
        if (this.isExpandable(treeItem) && menuItem) {
            menuItem.expanded = false;
        }
    }
    expandTreeItem(treeItem) {
        const menuItem = this.flattenedMenuItems.find((item) => item.id === treeItem.id);
        if (this.isExpandable(treeItem) && menuItem) {
            menuItem.expanded = true;
        }
    }
    expandAllSiblingTreeItems(treeItem) {
        const parentNode = treeItem.parentNode.parentNode;
        if (parentNode) {
            const siblingTreeItemNodes = parentNode.querySelectorAll(':scope > li > a[aria-expanded]');
            siblingTreeItemNodes.forEach((node) => this.expandTreeItem(node));
        }
    }
    setFocusToTreeItem(treeItem) {
        treeItem.focus();
        this.selectedItemId = treeItem.id;
    }
    setFocusToNextTreeItem(treeItem) {
        const visibleTreeItems = this.getVisibleTreeItems();
        const nextItem = visibleTreeItems[visibleTreeItems.indexOf(treeItem) + 1];
        if (nextItem) {
            this.setFocusToTreeItem(nextItem);
        }
    }
    setFocusToPreviousTreeItem(treeItem) {
        const visibleTreeItems = this.getVisibleTreeItems();
        const prevItem = visibleTreeItems[visibleTreeItems.indexOf(treeItem) - 1];
        if (prevItem) {
            this.setFocusToTreeItem(prevItem);
        }
    }
    setFocusToParentTreeItem(treeItem) {
        const parentTreeItem = this.getParentTreeItem(treeItem);
        if (parentTreeItem) {
            this.setFocusToTreeItem(parentTreeItem);
        }
    }
    flattenMenuItems(menuItems) {
        return menuItems.reduce((acc, item) => {
            acc.push(item);
            if (item.children) {
                acc.push(...this.flattenMenuItems(item.children));
            }
            return acc;
        }, []);
    }
    setFocusByFirstCharacter(treeItem, char) {
        const visibleTreeItems = this.getVisibleTreeItems();
        const start = visibleTreeItems.indexOf(treeItem) + 1;
        const index = visibleTreeItems
            .slice(start)
            .findIndex((ti) => ti.textContent.trim().toLowerCase().startsWith(char.toLowerCase()));
        if (index !== -1) {
            this.setFocusToTreeItem(visibleTreeItems[start + index]);
        }
        else {
            const indexFromStart = visibleTreeItems
                .slice(0, start)
                .findIndex((ti) => ti.textContent.trim().toLowerCase().startsWith(char.toLowerCase()));
            if (indexFromStart !== -1) {
                this.setFocusToTreeItem(visibleTreeItems[indexFromStart]);
            }
        }
    }
    onStateChange(element, isFocused) {
        if (isFocused) {
            this.focusedElements.add(element);
        }
        else {
            this.focusedElements.delete(element);
        }
    }
    isFocused(element) {
        const isExpander = element.classList.contains('expander-icon');
        const hasFocusedExpanderChild = Array.from(element.querySelectorAll('.expander-icon')).some((child) => this.focusedElements.has(child));
        if (!isExpander && hasFocusedExpanderChild) {
            return false;
        }
        return this.focusedElements.has(element);
    }
    isTabbable(menuItem) {
        const isSelected = this.selectedItemId === menuItem.id;
        if (this.selectedItemId) {
            return isSelected;
        }
        return this.flattenedMenuItems[0].id === menuItem.id;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsTreeMenuComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "17.3.5", type: DsTreeMenuComponent, selector: "ds-tree-menu", inputs: { menuAriaLabel: "menuAriaLabel", menuItems: "menuItems", rootItemsAlwaysExpanded: "rootItemsAlwaysExpanded" }, host: { listeners: { "keydown": "onKeydownListen($event)", "focusin": "onFocusIn($event)", "focusout": "onFocusOut($event)" } }, viewQueries: [{ propertyName: "treeNode", first: true, predicate: ["tree"], descendants: true, static: true }], usesOnChanges: true, ngImport: i0, template: "<nav [attr.aria-label]=\"menuAriaLabel\">\n  <ul #tree class=\"treeview-menu\" role=\"tree\" [attr.aria-label]=\"menuAriaLabel\">\n    <ng-container *ngTemplateOutlet=\"treeItems; context: { menuItems: menuItems, nestedLevel: 0 }\"></ng-container>\n  </ul>\n</nav>\n\n<ng-template #treeItems let-menuItems=\"menuItems\" let-nestedLevel=\"nestedLevel\">\n  @for (menuItem of menuItems; track $index) {\n    <li role=\"none\">\n      @if (menuItem.disabled) {\n        <span\n          #treeitem\n          [id]=\"menuItem.id\"\n          class=\"tree-item disabled\"\n          [ngClass]=\"{ 'focused-item': isFocused(treeitem) }\"\n          role=\"treeitem\"\n          [attr.tabindex]=\"isTabbable(treeitem) ? '0' : '-1'\"\n          [attr.aria-expanded]=\"menuItem.children?.length ? !!menuItem.expanded : null\"\n          [attr.aria-owns]=\"menuItem.children?.length ? menuItem.id + subtreeSuffix : null\"\n          dsTreeMenuItemState\n          (stateChange)=\"onStateChange(treeitem, $event)\"\n          (click)=\"handleItemClick($event, menuItem)\"\n        >\n          <ng-container\n            *ngTemplateOutlet=\"linkContent; context: { menuItem: menuItem, nestedLevel: nestedLevel, element: treeitem }\"\n          ></ng-container>\n        </span>\n      } @else {\n        <a\n          #treeitem\n          href=\"#\"\n          [id]=\"menuItem.id\"\n          class=\"tree-item\"\n          [ngClass]=\"{ active: menuItem.active, 'focused-item': isFocused(treeitem) }\"\n          role=\"treeitem\"\n          [attr.tabindex]=\"isTabbable(treeitem) ? '0' : '-1'\"\n          (click)=\"handleItemClick($event, menuItem)\"\n          [attr.aria-expanded]=\"menuItem.children?.length ? !!menuItem.expanded : null\"\n          [attr.aria-owns]=\"menuItem.children?.length ? menuItem.id + subtreeSuffix : null\"\n          dsTreeMenuItemState\n          (stateChange)=\"onStateChange(treeitem, $event)\"\n        >\n          <ng-container\n            *ngTemplateOutlet=\"linkContent; context: { menuItem: menuItem, nestedLevel: nestedLevel, element: treeitem }\"\n          ></ng-container>\n        </a>\n      }\n      @if (menuItem.children?.length) {\n        <ul class=\"subtree\" [attr.id]=\"menuItem.id + subtreeSuffix\" role=\"group\" [attr.aria-label]=\"menuItem.label\">\n          <ng-container\n            *ngTemplateOutlet=\"treeItems; context: { menuItems: menuItem.children, nestedLevel: nestedLevel + 1 }\"\n          ></ng-container>\n        </ul>\n      }\n    </li>\n  }\n</ng-template>\n\n<ng-template #linkContent let-menuItem=\"menuItem\" let-nestedLevel=\"nestedLevel\" let-element=\"element\">\n  @for (_ of getSpacersArray(nestedLevel); track $index) {\n    <span class=\"spacer\"></span>\n  }\n  @if (!rootItemsAlwaysExpanded || nestedLevel > 0) {\n    @if (menuItem.children?.length) {\n      <span\n        #expanderIcon\n        dsTreeMenuItemState\n        class=\"expander-icon\"\n        (stateChange)=\"onStateChange(expanderIcon, $event)\"\n        (click)=\"onIconClick($event)\"\n      >\n        <ds-icon\n          [iconStyle]=\"isFocused(expanderIcon) ? IconStyles.Solid : IconStyles.Light\"\n          [icon]=\"menuItem.expanded ? Icons.ChevronDown : Icons.ChevronRight\"\n        ></ds-icon>\n      </span>\n    } @else {\n      <span class=\"spacer\"></span>\n    }\n  }\n  <span class=\"icon\">\n    @if (menuItem.icon) {\n      <ds-icon\n        [iconStyle]=\"menuItem.active || (isFocused(element) && !menuItem.disabled) ? IconStyles.Solid : IconStyles.Light\"\n        [icon]=\"menuItem.icon\"\n      ></ds-icon>\n    } @else {\n      <span class=\"icon-placeholder\"></span>\n    }\n  </span>\n  <span class=\"tree-item-label\">\n    {{ menuItem.label }}\n  </span>\n</ng-template>\n", dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "component", type: DsIconComponent, selector: "ds-icon", inputs: ["icon", "iconStyle", "scale", "fixedWidth", "secondaryColor", "title"] }, { kind: "directive", type: DsTreeMenuItemStateDirective, selector: "[dsTreeMenuItemState]", outputs: ["stateChange"] }], changeDetection: i0.ChangeDetectionStrategy.Default }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsTreeMenuComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ds-tree-menu', changeDetection: ChangeDetectionStrategy.Default, template: "<nav [attr.aria-label]=\"menuAriaLabel\">\n  <ul #tree class=\"treeview-menu\" role=\"tree\" [attr.aria-label]=\"menuAriaLabel\">\n    <ng-container *ngTemplateOutlet=\"treeItems; context: { menuItems: menuItems, nestedLevel: 0 }\"></ng-container>\n  </ul>\n</nav>\n\n<ng-template #treeItems let-menuItems=\"menuItems\" let-nestedLevel=\"nestedLevel\">\n  @for (menuItem of menuItems; track $index) {\n    <li role=\"none\">\n      @if (menuItem.disabled) {\n        <span\n          #treeitem\n          [id]=\"menuItem.id\"\n          class=\"tree-item disabled\"\n          [ngClass]=\"{ 'focused-item': isFocused(treeitem) }\"\n          role=\"treeitem\"\n          [attr.tabindex]=\"isTabbable(treeitem) ? '0' : '-1'\"\n          [attr.aria-expanded]=\"menuItem.children?.length ? !!menuItem.expanded : null\"\n          [attr.aria-owns]=\"menuItem.children?.length ? menuItem.id + subtreeSuffix : null\"\n          dsTreeMenuItemState\n          (stateChange)=\"onStateChange(treeitem, $event)\"\n          (click)=\"handleItemClick($event, menuItem)\"\n        >\n          <ng-container\n            *ngTemplateOutlet=\"linkContent; context: { menuItem: menuItem, nestedLevel: nestedLevel, element: treeitem }\"\n          ></ng-container>\n        </span>\n      } @else {\n        <a\n          #treeitem\n          href=\"#\"\n          [id]=\"menuItem.id\"\n          class=\"tree-item\"\n          [ngClass]=\"{ active: menuItem.active, 'focused-item': isFocused(treeitem) }\"\n          role=\"treeitem\"\n          [attr.tabindex]=\"isTabbable(treeitem) ? '0' : '-1'\"\n          (click)=\"handleItemClick($event, menuItem)\"\n          [attr.aria-expanded]=\"menuItem.children?.length ? !!menuItem.expanded : null\"\n          [attr.aria-owns]=\"menuItem.children?.length ? menuItem.id + subtreeSuffix : null\"\n          dsTreeMenuItemState\n          (stateChange)=\"onStateChange(treeitem, $event)\"\n        >\n          <ng-container\n            *ngTemplateOutlet=\"linkContent; context: { menuItem: menuItem, nestedLevel: nestedLevel, element: treeitem }\"\n          ></ng-container>\n        </a>\n      }\n      @if (menuItem.children?.length) {\n        <ul class=\"subtree\" [attr.id]=\"menuItem.id + subtreeSuffix\" role=\"group\" [attr.aria-label]=\"menuItem.label\">\n          <ng-container\n            *ngTemplateOutlet=\"treeItems; context: { menuItems: menuItem.children, nestedLevel: nestedLevel + 1 }\"\n          ></ng-container>\n        </ul>\n      }\n    </li>\n  }\n</ng-template>\n\n<ng-template #linkContent let-menuItem=\"menuItem\" let-nestedLevel=\"nestedLevel\" let-element=\"element\">\n  @for (_ of getSpacersArray(nestedLevel); track $index) {\n    <span class=\"spacer\"></span>\n  }\n  @if (!rootItemsAlwaysExpanded || nestedLevel > 0) {\n    @if (menuItem.children?.length) {\n      <span\n        #expanderIcon\n        dsTreeMenuItemState\n        class=\"expander-icon\"\n        (stateChange)=\"onStateChange(expanderIcon, $event)\"\n        (click)=\"onIconClick($event)\"\n      >\n        <ds-icon\n          [iconStyle]=\"isFocused(expanderIcon) ? IconStyles.Solid : IconStyles.Light\"\n          [icon]=\"menuItem.expanded ? Icons.ChevronDown : Icons.ChevronRight\"\n        ></ds-icon>\n      </span>\n    } @else {\n      <span class=\"spacer\"></span>\n    }\n  }\n  <span class=\"icon\">\n    @if (menuItem.icon) {\n      <ds-icon\n        [iconStyle]=\"menuItem.active || (isFocused(element) && !menuItem.disabled) ? IconStyles.Solid : IconStyles.Light\"\n        [icon]=\"menuItem.icon\"\n      ></ds-icon>\n    } @else {\n      <span class=\"icon-placeholder\"></span>\n    }\n  </span>\n  <span class=\"tree-item-label\">\n    {{ menuItem.label }}\n  </span>\n</ng-template>\n" }]
        }], ctorParameters: () => [], propDecorators: { menuAriaLabel: [{
                type: Input
            }], menuItems: [{
                type: Input
            }], rootItemsAlwaysExpanded: [{
                type: Input
            }], treeNode: [{
                type: ViewChild,
                args: ['tree', { static: true }]
            }], onKeydownListen: [{
                type: HostListener,
                args: ['keydown', ['$event']]
            }], onFocusIn: [{
                type: HostListener,
                args: ['focusin', ['$event']]
            }], onFocusOut: [{
                type: HostListener,
                args: ['focusout', ['$event']]
            }] } });

class DsTreeMenuModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsTreeMenuModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.5", ngImport: i0, type: DsTreeMenuModule, declarations: [DsTreeMenuComponent, DsTreeMenuItemStateDirective], imports: [CommonModule, DsIconModule], exports: [DsTreeMenuComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsTreeMenuModule, imports: [CommonModule, DsIconModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsTreeMenuModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [DsTreeMenuComponent, DsTreeMenuItemStateDirective],
                    imports: [CommonModule, DsIconModule],
                    exports: [DsTreeMenuComponent],
                }]
        }] });

class DsChatBubbleComponent {
    constructor() {
        this.isError = false;
        this.isCustomer = false;
        this.customerName = 'Customer Name';
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsChatBubbleComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.5", type: DsChatBubbleComponent, selector: "ds-chat-bubble", inputs: { bodyText: "bodyText", isError: "isError", isCustomer: "isCustomer", customerName: "customerName" }, ngImport: i0, template: "<div\n  class=\"ds-chat-bubble\"\n  tabindex=\"0\"\n  [class.ds-customer-chat-bubble]=\"isCustomer\"\n  [class.ds-level-access-chat-bubble]=\"!isCustomer\"\n  [class.ds-error-chat]=\"isError\"\n>\n  <div class=\"ds-chat-bubble-header\">\n    <ng-container *ngIf=\"isCustomer; else levelAccess\">\n      <div class=\"ds-customer-name\">{{ customerName }}</div>\n    </ng-container>\n  </div>\n  <div class=\"ds-chat-bubble-body\">\n    {{ bodyText }}\n  </div>\n</div>\n\n<ng-template #levelAccess>\n  <div class=\"ds-chatbot-name\">\n    <svg width=\"50\" height=\"20\" viewBox=\"0 0 50 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path d=\"M48.1227 19.2003V18.3329H47.8125V18.1571H48.6423V18.3329H48.3335V19.2003H48.1227Z\" fill=\"#074EB0\" />\n      <path\n        d=\"M48.7763 19.2004V18.1571H49.0918L49.2812 18.8687L49.4678 18.1571H49.7833V19.2004H49.5873V18.3786L49.3805 19.2004H49.1778L48.971 18.3786V19.2004H48.775H48.7763Z\"\n        fill=\"#074EB0\"\n      />\n      <path\n        d=\"M18.8517 10.0001C18.8517 7.3066 20.5436 5.01459 22.9202 4.11094C21.1975 1.97065 18.559 0.598389 15.597 0.598389H9.4017C4.20942 0.598389 0 4.80781 0 10.0001C0 15.1924 4.20942 19.4018 9.4017 19.4018H15.597C18.559 19.4018 21.1975 18.0295 22.9202 15.8892C20.5436 14.9856 18.8517 12.6936 18.8517 10.0001ZM10.6853 3.8961C11.2197 3.8961 11.6548 4.32309 11.6548 4.85212C11.6548 5.38115 11.2197 5.80679 10.6853 5.80679C10.1509 5.80679 9.71724 5.3798 9.71724 4.85212C9.71724 4.32443 10.1509 3.8961 10.6853 3.8961ZM13.8891 12.8708V12.8641C13.5077 14.0914 12.5665 15.1091 11.2815 15.5052C9.24729 16.1296 7.10968 14.9561 6.45847 12.8789H6.46115C6.28123 12.3082 6.22215 11.6879 6.31077 11.0555C6.50412 9.68321 7.34198 8.57278 8.4618 8.00616H8.45374C8.55042 7.95782 8.66052 7.93768 8.77331 7.95379C9.07542 7.9981 9.28086 8.28679 9.23789 8.59695C9.20835 8.80508 9.07408 8.96889 8.89818 9.04139L8.88073 9.05482C8.12344 9.46972 7.56352 10.2404 7.43059 11.183C7.37017 11.6208 7.41045 12.0464 7.52727 12.4425C7.63334 12.8158 7.81998 13.1407 8.04019 13.424C8.05227 13.4388 8.06167 13.4522 8.07376 13.4656C8.10732 13.5073 8.14223 13.5462 8.17849 13.5865C8.21743 13.6281 8.25637 13.6697 8.29799 13.7087C8.30739 13.7181 8.31813 13.7288 8.32753 13.7369C8.72095 14.1008 9.28623 14.3854 9.84883 14.47H9.85286C10.2248 14.5183 10.6115 14.4915 10.9942 14.3733C11.8763 14.1021 12.5329 13.416 12.8216 12.5835L12.831 12.5633C12.8753 12.3727 13.0136 12.2115 13.207 12.1525C13.4983 12.0625 13.8031 12.2344 13.8891 12.5351C13.9213 12.6479 13.9186 12.7634 13.8864 12.8695L13.8891 12.8708ZM17.5775 13.5207L16.4778 14.1357C16.4684 14.1397 16.459 14.1397 16.4496 14.1451C16.4389 14.1477 16.4308 14.1504 16.4201 14.1545C16.3637 14.1773 16.3073 14.1853 16.2509 14.184C16.2455 14.184 16.2415 14.184 16.2375 14.184C16.2052 14.1813 16.1717 14.18 16.1408 14.1706C16.0173 14.1424 15.9031 14.0699 15.8266 13.9557L14.2919 11.6409H10.7646C10.7135 11.6409 10.6759 11.6409 10.6249 11.6369C10.2812 11.602 10.0006 11.3012 10.0006 10.9534V6.98301C10.0006 6.60973 10.308 6.30896 10.684 6.30896C11.06 6.30896 11.3661 6.60973 11.3661 6.98301V8.23711H13.4728C13.7749 8.23711 14.0206 8.50699 14.0206 8.84133C14.0206 9.17566 13.7749 9.44555 13.4728 9.44555H11.3661V10.411H14.4047C14.7215 10.4298 14.8357 10.6177 14.8974 10.709L16.5141 13.1474L17.1519 12.7903C17.3573 12.6761 17.6178 12.7473 17.7346 12.9487C17.8514 13.1515 17.7789 13.4093 17.5735 13.5234L17.5775 13.5207Z\"\n        fill=\"#074EB0\"\n      />\n      <path\n        d=\"M27.712 8.80271L22.6942 6.19246C22.6942 7.26664 22.8151 7.95948 23.5522 8.3435L26.0738 9.65533L27.712 8.80271Z\"\n        fill=\"#074EB0\"\n      />\n      <path\n        d=\"M28.3671 9.14428L26.729 9.99691H26.7317L23.5763 11.6404C22.8579 12.0298 22.6941 12.877 22.6941 13.8035L27.25 11.4336C28.2583 10.8844 28.3684 10.2131 28.3684 9.14562L28.3671 9.14428Z\"\n        fill=\"#074EB0\"\n      />\n      <path\n        d=\"M35.4704 10.4846H41.6361C41.6764 10.4846 41.7059 10.4497 41.7059 10.4081V5.10031C41.7059 5.05869 41.6764 5.02378 41.6361 5.02378H35.4704C35.4301 5.02378 35.3992 5.05869 35.3992 5.10031V10.4081C35.3992 10.4497 35.4301 10.4846 35.4704 10.4846Z\"\n        fill=\"#074EB0\"\n      />\n      <path\n        d=\"M40.5987 0.598389H34.4034C31.4816 0.598389 28.8714 1.93036 27.1474 4.02097C29.6542 4.8548 31.4628 7.21395 31.4628 10.0001C31.4628 12.7862 29.6529 15.1467 27.1474 15.9792C28.8714 18.0698 31.4816 19.4018 34.4034 19.4018H40.5987C45.791 19.4018 50.0004 15.1924 50.0004 10.0001C50.0004 4.80781 45.791 0.598389 40.5987 0.598389ZM34.2651 3.92564C34.2651 3.87327 34.3 3.83165 34.3443 3.83165H42.7148C42.7578 3.83165 42.794 3.87327 42.794 3.92564V11.8047C42.794 11.8557 42.7591 11.8974 42.7148 11.8974H34.3443C34.3 11.8974 34.2651 11.8544 34.2651 11.8047V3.92564ZM43.0062 15.6449C43.0062 15.704 42.9592 15.7509 42.9001 15.7509H34.159C34.1013 15.7509 34.0516 15.704 34.0516 15.6449V12.4532C34.0516 12.3942 34.1013 12.3472 34.159 12.3472H42.9001C42.9592 12.3472 43.0062 12.3942 43.0062 12.4532V15.6449Z\"\n        fill=\"#074EB0\"\n      />\n      <path\n        d=\"M35.6887 14.1776H34.8267C34.7743 14.1776 34.7341 14.2192 34.7341 14.2703V15.1336C34.7341 15.1847 34.7743 15.2263 34.8267 15.2263H35.6887C35.7411 15.2263 35.7827 15.186 35.7827 15.1336V14.2703C35.7827 14.2192 35.7397 14.1776 35.6887 14.1776Z\"\n        fill=\"#074EB0\"\n      />\n      <path\n        d=\"M37.3237 13.8688H38.1871C38.2367 13.8688 38.2797 13.8272 38.2797 13.7748V12.9114C38.2797 12.8604 38.2381 12.8188 38.1871 12.8188H37.3237C37.2713 12.8188 37.2297 12.8604 37.2297 12.9114V13.7748C37.2297 13.8258 37.2727 13.8688 37.3237 13.8688Z\"\n        fill=\"#074EB0\"\n      />\n      <path\n        d=\"M35.6896 13.8688H36.5503C36.604 13.8688 36.6456 13.8272 36.6456 13.7748V12.9114C36.6456 12.8604 36.604 12.8188 36.5503 12.8188H35.6896C35.6372 12.8188 35.5956 12.8604 35.5956 12.9114V13.7748C35.5956 13.8258 35.6372 13.8688 35.6896 13.8688Z\"\n        fill=\"#074EB0\"\n      />\n      <path\n        d=\"M38.9597 13.8688H39.8231C39.8755 13.8688 39.9157 13.8272 39.9157 13.7748V12.9114C39.9157 12.8604 39.8755 12.8188 39.8231 12.8188H38.9597C38.9074 12.8188 38.8671 12.8604 38.8671 12.9114V13.7748C38.8671 13.8258 38.9074 13.8688 38.9597 13.8688Z\"\n        fill=\"#074EB0\"\n      />\n      <path\n        d=\"M40.5938 13.8688H41.4572C41.5082 13.8688 41.5499 13.8272 41.5499 13.7748V12.9114C41.5499 12.8604 41.5082 12.8188 41.4572 12.8188H40.5938C40.5415 12.8188 40.5012 12.8604 40.5012 12.9114V13.7748C40.5012 13.8258 40.5415 13.8688 40.5938 13.8688Z\"\n        fill=\"#074EB0\"\n      />\n      <path\n        d=\"M42.2265 14.1776H41.3632C41.3121 14.1776 41.2705 14.2192 41.2705 14.2703V15.1336C41.2705 15.1847 41.3121 15.2263 41.3632 15.2263H42.2265C42.2775 15.2263 42.3192 15.186 42.3192 15.1336V14.2703C42.3192 14.2192 42.2775 14.1776 42.2265 14.1776Z\"\n        fill=\"#074EB0\"\n      />\n      <path\n        d=\"M38.9583 14.1776H38.0963C38.0439 14.1776 38.0023 14.2192 38.0023 14.2703V15.1336C38.0023 15.1847 38.0439 15.2263 38.0963 15.2263H38.9583C39.0107 15.2263 39.0523 15.186 39.0523 15.1336V14.2703C39.0523 14.2192 39.0107 14.1776 38.9583 14.1776Z\"\n        fill=\"#074EB0\"\n      />\n      <path\n        d=\"M37.3231 14.1776H36.4597C36.4074 14.1776 36.3671 14.2192 36.3671 14.2703V15.1336C36.3671 15.1847 36.4074 15.2263 36.4597 15.2263H37.3231C37.3755 15.2263 37.4171 15.186 37.4171 15.1336V14.2703C37.4171 14.2192 37.3755 14.1776 37.3231 14.1776Z\"\n        fill=\"#074EB0\"\n      />\n      <path\n        d=\"M40.5924 14.1776H39.729C39.678 14.1776 39.6364 14.2192 39.6364 14.2703V15.1336C39.6364 15.1847 39.678 15.2263 39.729 15.2263H40.5924C40.6448 15.2263 40.6864 15.186 40.6864 15.1336V14.2703C40.6864 14.2192 40.6448 14.1776 40.5924 14.1776Z\"\n        fill=\"#074EB0\"\n      />\n    </svg>\n    <span>Level Access</span>\n  </div>\n</ng-template>\n", dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsChatBubbleComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ds-chat-bubble', template: "<div\n  class=\"ds-chat-bubble\"\n  tabindex=\"0\"\n  [class.ds-customer-chat-bubble]=\"isCustomer\"\n  [class.ds-level-access-chat-bubble]=\"!isCustomer\"\n  [class.ds-error-chat]=\"isError\"\n>\n  <div class=\"ds-chat-bubble-header\">\n    <ng-container *ngIf=\"isCustomer; else levelAccess\">\n      <div class=\"ds-customer-name\">{{ customerName }}</div>\n    </ng-container>\n  </div>\n  <div class=\"ds-chat-bubble-body\">\n    {{ bodyText }}\n  </div>\n</div>\n\n<ng-template #levelAccess>\n  <div class=\"ds-chatbot-name\">\n    <svg width=\"50\" height=\"20\" viewBox=\"0 0 50 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path d=\"M48.1227 19.2003V18.3329H47.8125V18.1571H48.6423V18.3329H48.3335V19.2003H48.1227Z\" fill=\"#074EB0\" />\n      <path\n        d=\"M48.7763 19.2004V18.1571H49.0918L49.2812 18.8687L49.4678 18.1571H49.7833V19.2004H49.5873V18.3786L49.3805 19.2004H49.1778L48.971 18.3786V19.2004H48.775H48.7763Z\"\n        fill=\"#074EB0\"\n      />\n      <path\n        d=\"M18.8517 10.0001C18.8517 7.3066 20.5436 5.01459 22.9202 4.11094C21.1975 1.97065 18.559 0.598389 15.597 0.598389H9.4017C4.20942 0.598389 0 4.80781 0 10.0001C0 15.1924 4.20942 19.4018 9.4017 19.4018H15.597C18.559 19.4018 21.1975 18.0295 22.9202 15.8892C20.5436 14.9856 18.8517 12.6936 18.8517 10.0001ZM10.6853 3.8961C11.2197 3.8961 11.6548 4.32309 11.6548 4.85212C11.6548 5.38115 11.2197 5.80679 10.6853 5.80679C10.1509 5.80679 9.71724 5.3798 9.71724 4.85212C9.71724 4.32443 10.1509 3.8961 10.6853 3.8961ZM13.8891 12.8708V12.8641C13.5077 14.0914 12.5665 15.1091 11.2815 15.5052C9.24729 16.1296 7.10968 14.9561 6.45847 12.8789H6.46115C6.28123 12.3082 6.22215 11.6879 6.31077 11.0555C6.50412 9.68321 7.34198 8.57278 8.4618 8.00616H8.45374C8.55042 7.95782 8.66052 7.93768 8.77331 7.95379C9.07542 7.9981 9.28086 8.28679 9.23789 8.59695C9.20835 8.80508 9.07408 8.96889 8.89818 9.04139L8.88073 9.05482C8.12344 9.46972 7.56352 10.2404 7.43059 11.183C7.37017 11.6208 7.41045 12.0464 7.52727 12.4425C7.63334 12.8158 7.81998 13.1407 8.04019 13.424C8.05227 13.4388 8.06167 13.4522 8.07376 13.4656C8.10732 13.5073 8.14223 13.5462 8.17849 13.5865C8.21743 13.6281 8.25637 13.6697 8.29799 13.7087C8.30739 13.7181 8.31813 13.7288 8.32753 13.7369C8.72095 14.1008 9.28623 14.3854 9.84883 14.47H9.85286C10.2248 14.5183 10.6115 14.4915 10.9942 14.3733C11.8763 14.1021 12.5329 13.416 12.8216 12.5835L12.831 12.5633C12.8753 12.3727 13.0136 12.2115 13.207 12.1525C13.4983 12.0625 13.8031 12.2344 13.8891 12.5351C13.9213 12.6479 13.9186 12.7634 13.8864 12.8695L13.8891 12.8708ZM17.5775 13.5207L16.4778 14.1357C16.4684 14.1397 16.459 14.1397 16.4496 14.1451C16.4389 14.1477 16.4308 14.1504 16.4201 14.1545C16.3637 14.1773 16.3073 14.1853 16.2509 14.184C16.2455 14.184 16.2415 14.184 16.2375 14.184C16.2052 14.1813 16.1717 14.18 16.1408 14.1706C16.0173 14.1424 15.9031 14.0699 15.8266 13.9557L14.2919 11.6409H10.7646C10.7135 11.6409 10.6759 11.6409 10.6249 11.6369C10.2812 11.602 10.0006 11.3012 10.0006 10.9534V6.98301C10.0006 6.60973 10.308 6.30896 10.684 6.30896C11.06 6.30896 11.3661 6.60973 11.3661 6.98301V8.23711H13.4728C13.7749 8.23711 14.0206 8.50699 14.0206 8.84133C14.0206 9.17566 13.7749 9.44555 13.4728 9.44555H11.3661V10.411H14.4047C14.7215 10.4298 14.8357 10.6177 14.8974 10.709L16.5141 13.1474L17.1519 12.7903C17.3573 12.6761 17.6178 12.7473 17.7346 12.9487C17.8514 13.1515 17.7789 13.4093 17.5735 13.5234L17.5775 13.5207Z\"\n        fill=\"#074EB0\"\n      />\n      <path\n        d=\"M27.712 8.80271L22.6942 6.19246C22.6942 7.26664 22.8151 7.95948 23.5522 8.3435L26.0738 9.65533L27.712 8.80271Z\"\n        fill=\"#074EB0\"\n      />\n      <path\n        d=\"M28.3671 9.14428L26.729 9.99691H26.7317L23.5763 11.6404C22.8579 12.0298 22.6941 12.877 22.6941 13.8035L27.25 11.4336C28.2583 10.8844 28.3684 10.2131 28.3684 9.14562L28.3671 9.14428Z\"\n        fill=\"#074EB0\"\n      />\n      <path\n        d=\"M35.4704 10.4846H41.6361C41.6764 10.4846 41.7059 10.4497 41.7059 10.4081V5.10031C41.7059 5.05869 41.6764 5.02378 41.6361 5.02378H35.4704C35.4301 5.02378 35.3992 5.05869 35.3992 5.10031V10.4081C35.3992 10.4497 35.4301 10.4846 35.4704 10.4846Z\"\n        fill=\"#074EB0\"\n      />\n      <path\n        d=\"M40.5987 0.598389H34.4034C31.4816 0.598389 28.8714 1.93036 27.1474 4.02097C29.6542 4.8548 31.4628 7.21395 31.4628 10.0001C31.4628 12.7862 29.6529 15.1467 27.1474 15.9792C28.8714 18.0698 31.4816 19.4018 34.4034 19.4018H40.5987C45.791 19.4018 50.0004 15.1924 50.0004 10.0001C50.0004 4.80781 45.791 0.598389 40.5987 0.598389ZM34.2651 3.92564C34.2651 3.87327 34.3 3.83165 34.3443 3.83165H42.7148C42.7578 3.83165 42.794 3.87327 42.794 3.92564V11.8047C42.794 11.8557 42.7591 11.8974 42.7148 11.8974H34.3443C34.3 11.8974 34.2651 11.8544 34.2651 11.8047V3.92564ZM43.0062 15.6449C43.0062 15.704 42.9592 15.7509 42.9001 15.7509H34.159C34.1013 15.7509 34.0516 15.704 34.0516 15.6449V12.4532C34.0516 12.3942 34.1013 12.3472 34.159 12.3472H42.9001C42.9592 12.3472 43.0062 12.3942 43.0062 12.4532V15.6449Z\"\n        fill=\"#074EB0\"\n      />\n      <path\n        d=\"M35.6887 14.1776H34.8267C34.7743 14.1776 34.7341 14.2192 34.7341 14.2703V15.1336C34.7341 15.1847 34.7743 15.2263 34.8267 15.2263H35.6887C35.7411 15.2263 35.7827 15.186 35.7827 15.1336V14.2703C35.7827 14.2192 35.7397 14.1776 35.6887 14.1776Z\"\n        fill=\"#074EB0\"\n      />\n      <path\n        d=\"M37.3237 13.8688H38.1871C38.2367 13.8688 38.2797 13.8272 38.2797 13.7748V12.9114C38.2797 12.8604 38.2381 12.8188 38.1871 12.8188H37.3237C37.2713 12.8188 37.2297 12.8604 37.2297 12.9114V13.7748C37.2297 13.8258 37.2727 13.8688 37.3237 13.8688Z\"\n        fill=\"#074EB0\"\n      />\n      <path\n        d=\"M35.6896 13.8688H36.5503C36.604 13.8688 36.6456 13.8272 36.6456 13.7748V12.9114C36.6456 12.8604 36.604 12.8188 36.5503 12.8188H35.6896C35.6372 12.8188 35.5956 12.8604 35.5956 12.9114V13.7748C35.5956 13.8258 35.6372 13.8688 35.6896 13.8688Z\"\n        fill=\"#074EB0\"\n      />\n      <path\n        d=\"M38.9597 13.8688H39.8231C39.8755 13.8688 39.9157 13.8272 39.9157 13.7748V12.9114C39.9157 12.8604 39.8755 12.8188 39.8231 12.8188H38.9597C38.9074 12.8188 38.8671 12.8604 38.8671 12.9114V13.7748C38.8671 13.8258 38.9074 13.8688 38.9597 13.8688Z\"\n        fill=\"#074EB0\"\n      />\n      <path\n        d=\"M40.5938 13.8688H41.4572C41.5082 13.8688 41.5499 13.8272 41.5499 13.7748V12.9114C41.5499 12.8604 41.5082 12.8188 41.4572 12.8188H40.5938C40.5415 12.8188 40.5012 12.8604 40.5012 12.9114V13.7748C40.5012 13.8258 40.5415 13.8688 40.5938 13.8688Z\"\n        fill=\"#074EB0\"\n      />\n      <path\n        d=\"M42.2265 14.1776H41.3632C41.3121 14.1776 41.2705 14.2192 41.2705 14.2703V15.1336C41.2705 15.1847 41.3121 15.2263 41.3632 15.2263H42.2265C42.2775 15.2263 42.3192 15.186 42.3192 15.1336V14.2703C42.3192 14.2192 42.2775 14.1776 42.2265 14.1776Z\"\n        fill=\"#074EB0\"\n      />\n      <path\n        d=\"M38.9583 14.1776H38.0963C38.0439 14.1776 38.0023 14.2192 38.0023 14.2703V15.1336C38.0023 15.1847 38.0439 15.2263 38.0963 15.2263H38.9583C39.0107 15.2263 39.0523 15.186 39.0523 15.1336V14.2703C39.0523 14.2192 39.0107 14.1776 38.9583 14.1776Z\"\n        fill=\"#074EB0\"\n      />\n      <path\n        d=\"M37.3231 14.1776H36.4597C36.4074 14.1776 36.3671 14.2192 36.3671 14.2703V15.1336C36.3671 15.1847 36.4074 15.2263 36.4597 15.2263H37.3231C37.3755 15.2263 37.4171 15.186 37.4171 15.1336V14.2703C37.4171 14.2192 37.3755 14.1776 37.3231 14.1776Z\"\n        fill=\"#074EB0\"\n      />\n      <path\n        d=\"M40.5924 14.1776H39.729C39.678 14.1776 39.6364 14.2192 39.6364 14.2703V15.1336C39.6364 15.1847 39.678 15.2263 39.729 15.2263H40.5924C40.6448 15.2263 40.6864 15.186 40.6864 15.1336V14.2703C40.6864 14.2192 40.6448 14.1776 40.5924 14.1776Z\"\n        fill=\"#074EB0\"\n      />\n    </svg>\n    <span>Level Access</span>\n  </div>\n</ng-template>\n" }]
        }], ctorParameters: () => [], propDecorators: { bodyText: [{
                type: Input
            }], isError: [{
                type: Input
            }], isCustomer: [{
                type: Input
            }], customerName: [{
                type: Input
            }] } });

class DsChatBubbleModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsChatBubbleModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.5", ngImport: i0, type: DsChatBubbleModule, declarations: [DsChatBubbleComponent], imports: [CommonModule], exports: [DsChatBubbleComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsChatBubbleModule, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsChatBubbleModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [DsChatBubbleComponent],
                    imports: [CommonModule],
                    exports: [DsChatBubbleComponent],
                }]
        }] });

class DsSearchBarComponent {
    constructor() {
        this.Icons = Icons;
        this.IconStyles = IconStyles;
        this.labelId = DomUtility.createUniqueDOMId('ds-search-bar-label');
        this.instructionId = DomUtility.createUniqueDOMId('ds-search-bar-instruction');
        this.inputId = DomUtility.createUniqueDOMId('ds-search-bar-input');
        this.buttonId = DomUtility.createUniqueDOMId('ds-search-bar-button');
        this.errorMessageId = DomUtility.createUniqueDOMId('ds-search-bar-error');
        this.invalid = false;
        this.search = new EventEmitter();
    }
    onSearch() {
        this.invalid = CommonUtility.isNullishOrEmpty(this.value);
        if (this.invalid) {
            this.searchInput.nativeElement.focus();
            return;
        }
        this.search.emit(this.value);
    }
    updateAndValidateValue(event) {
        const input = event.target;
        this.value = input.value;
        if (this.invalid && CommonUtility.notNullishOrEmpty(this.value)) {
            this.invalid = false;
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsSearchBarComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.5", type: DsSearchBarComponent, selector: "ds-search-bar", inputs: { keyword: "keyword", instruction: "instruction" }, outputs: { search: "search" }, viewQueries: [{ propertyName: "searchInput", first: true, predicate: ["searchInput"], descendants: true }], ngImport: i0, template: "<div class=\"ds-search-widget\">\n  <label\n    [id]=\"labelId\"\n    class=\"ds-search-bar-label\"\n    [for]=\"inputId\"\n    [attr.aria-labelledby]=\"instruction ? labelId + ' ' + instructionId : labelId\"\n  >\n    Search by {{ keyword }}\n  </label>\n  <div *ngIf=\"instruction\" [id]=\"instructionId\" class=\"ds-search-bar-instruction\">{{ instruction }}</div>\n  <div class=\"ds-search-bar\">\n    <ds-icon class=\"ds-search-bar-icon\" [icon]=\"Icons.MagnifyingGlass\" [iconStyle]=\"IconStyles.Light\"></ds-icon>\n    <input\n      #searchInput\n      [id]=\"inputId\"\n      [attr.aria-required]=\"true\"\n      [attr.aria-errormessage]=\"invalid ? errorMessageId : null\"\n      [attr.aria-invalid]=\"invalid\"\n      (keyup)=\"updateAndValidateValue($event)\"\n      (search)=\"updateAndValidateValue($event)\"\n      name=\"search\"\n      type=\"search\"\n      autocomplete=\"on\"\n    />\n    <button [id]=\"buttonId\" type=\"button\" (click)=\"onSearch()\">Search</button>\n  </div>\n  <!-- TODO EAP-17082 - Update to use error message component -->\n  <div *ngIf=\"invalid\" [id]=\"errorMessageId\" class=\"ds-search-bar-error\" role=\"alert\">\n    <ds-icon [icon]=\"Icons.CircleExclamation\" [iconStyle]=\"IconStyles.Light\"></ds-icon>\n    <span>Enter {{ keyword }} to search</span>\n  </div>\n</div>\n", dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: DsIconComponent, selector: "ds-icon", inputs: ["icon", "iconStyle", "scale", "fixedWidth", "secondaryColor", "title"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsSearchBarComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ds-search-bar', template: "<div class=\"ds-search-widget\">\n  <label\n    [id]=\"labelId\"\n    class=\"ds-search-bar-label\"\n    [for]=\"inputId\"\n    [attr.aria-labelledby]=\"instruction ? labelId + ' ' + instructionId : labelId\"\n  >\n    Search by {{ keyword }}\n  </label>\n  <div *ngIf=\"instruction\" [id]=\"instructionId\" class=\"ds-search-bar-instruction\">{{ instruction }}</div>\n  <div class=\"ds-search-bar\">\n    <ds-icon class=\"ds-search-bar-icon\" [icon]=\"Icons.MagnifyingGlass\" [iconStyle]=\"IconStyles.Light\"></ds-icon>\n    <input\n      #searchInput\n      [id]=\"inputId\"\n      [attr.aria-required]=\"true\"\n      [attr.aria-errormessage]=\"invalid ? errorMessageId : null\"\n      [attr.aria-invalid]=\"invalid\"\n      (keyup)=\"updateAndValidateValue($event)\"\n      (search)=\"updateAndValidateValue($event)\"\n      name=\"search\"\n      type=\"search\"\n      autocomplete=\"on\"\n    />\n    <button [id]=\"buttonId\" type=\"button\" (click)=\"onSearch()\">Search</button>\n  </div>\n  <!-- TODO EAP-17082 - Update to use error message component -->\n  <div *ngIf=\"invalid\" [id]=\"errorMessageId\" class=\"ds-search-bar-error\" role=\"alert\">\n    <ds-icon [icon]=\"Icons.CircleExclamation\" [iconStyle]=\"IconStyles.Light\"></ds-icon>\n    <span>Enter {{ keyword }} to search</span>\n  </div>\n</div>\n" }]
        }], propDecorators: { keyword: [{
                type: Input
            }], instruction: [{
                type: Input
            }], search: [{
                type: Output
            }], searchInput: [{
                type: ViewChild,
                args: ['searchInput']
            }] } });

class DsSearchBarModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsSearchBarModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.5", ngImport: i0, type: DsSearchBarModule, declarations: [DsSearchBarComponent], imports: [NgbModule, CommonModule, DsButtonModule, DsIconModule], exports: [DsSearchBarComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsSearchBarModule, imports: [NgbModule, CommonModule, DsButtonModule, DsIconModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsSearchBarModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [DsSearchBarComponent],
                    imports: [NgbModule, CommonModule, DsButtonModule, DsIconModule],
                    exports: [DsSearchBarComponent],
                }]
        }] });

/*
 * Public API Surface of design-system
 */
const DS_MODULES = [
    DsIconModule,
    DsButtonModule,
    DsButtonGroupModule,
    DsCheckboxModule,
    DsTooltipModule,
    DsInputModule,
    DsRadioModule,
    DsHeaderBarModule,
    DsLinkModule,
    DsDropdownModule,
    DsToolbarModule,
    DsBreadcrumbModule,
    DsModalModule,
    DsPaginationModule,
    DsCardModule,
    DsTabsModule,
    DsChipModule,
    DsCheckboxesFeedbackModule,
    DsCopyModule,
    DsStarRatingModule,
    DsDetailsModule,
    DsTreeMenuModule,
];
class DsModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.5", ngImport: i0, type: DsModule, imports: [DsIconModule,
            DsButtonModule,
            DsButtonGroupModule,
            DsCheckboxModule,
            DsTooltipModule,
            DsInputModule,
            DsRadioModule,
            DsHeaderBarModule,
            DsLinkModule,
            DsDropdownModule,
            DsToolbarModule,
            DsBreadcrumbModule,
            DsModalModule,
            DsPaginationModule,
            DsCardModule,
            DsTabsModule,
            DsChipModule,
            DsCheckboxesFeedbackModule,
            DsCopyModule,
            DsStarRatingModule,
            DsDetailsModule,
            DsTreeMenuModule], exports: [DsIconModule,
            DsButtonModule,
            DsButtonGroupModule,
            DsCheckboxModule,
            DsTooltipModule,
            DsInputModule,
            DsRadioModule,
            DsHeaderBarModule,
            DsLinkModule,
            DsDropdownModule,
            DsToolbarModule,
            DsBreadcrumbModule,
            DsModalModule,
            DsPaginationModule,
            DsCardModule,
            DsTabsModule,
            DsChipModule,
            DsCheckboxesFeedbackModule,
            DsCopyModule,
            DsStarRatingModule,
            DsDetailsModule,
            DsTreeMenuModule] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsModule, imports: [DS_MODULES, DsIconModule,
            DsButtonModule,
            DsButtonGroupModule,
            DsCheckboxModule,
            DsTooltipModule,
            DsInputModule,
            DsRadioModule,
            DsHeaderBarModule,
            DsLinkModule,
            DsDropdownModule,
            DsToolbarModule,
            DsBreadcrumbModule,
            DsModalModule,
            DsPaginationModule,
            DsCardModule,
            DsTabsModule,
            DsChipModule,
            DsCheckboxesFeedbackModule,
            DsCopyModule,
            DsStarRatingModule,
            DsDetailsModule,
            DsTreeMenuModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DsModule, decorators: [{
            type: NgModule,
            args: [{ imports: DS_MODULES, exports: DS_MODULES }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { DsBreadcrumbComponent, DsBreadcrumbModule, DsBreakpoints, DsButtonColor, DsButtonComponent, DsButtonGroupComponent, DsButtonGroupMenuDirective, DsButtonGroupMicroComponent, DsButtonGroupModule, DsButtonModule, DsButtonVariants, DsCardComponent, DsCardModule, DsCardVariant, DsChatBubbleComponent, DsChatBubbleModule, DsCheckboxComponent, DsCheckboxGroupComponent, DsCheckboxModule, DsCheckboxesFeedbackComponent, DsCheckboxesFeedbackModule, DsChipColorVariant, DsChipComponent, DsChipModule, DsColors, DsCopyComponent, DsCopyModule, DsDetailsComponent, DsDetailsModule, DsDropdownComponent, DsDropdownItemComponent, DsDropdownMenuDirective, DsDropdownModule, DsDropdownToggleComponent, DsHeaderBarComponent, DsHeaderBarModule, DsHeaderPrimaryActionDirective, DsHeaderSecondaryMicroActionDirective, DsIconComponent, DsIconModule, DsInputComponent, DsInputFieldDirective, DsInputModule, DsInputStates, DsLinkColor, DsLinkComponent, DsLinkModule, DsModalColorVariant, DsModalComponent, DsModalModule, DsModalService, DsModalSlideOutAlignment, DsModalSlideOutFooterDirective, DsModalVariant, DsModule, DsPaginationComponent, DsPaginationModule, DsRadioComponent, DsRadioGroupComponent, DsRadioModule, DsSearchBarComponent, DsSearchBarModule, DsStarRatingComponent, DsStarRatingModule, DsTabComponent, DsTabsComponent, DsTabsModule, DsToolbarComponent, DsToolbarModule, DsTooltipComponent, DsTooltipDirective, DsTooltipModule, DsTooltipPosition, DsTreeMenuComponent, DsTreeMenuModule, IconScale, IconStyles, Icons };
